const plzData = [
  {
    "plz": "01067",
    "gebiet": 3
  },
  {
    "plz": "01069",
    "gebiet": 3
  },
  {
    "plz": "01074",
    "gebiet": 3
  },
  {
    "plz": "01097",
    "gebiet": 3
  },
  {
    "plz": "01099",
    "gebiet": 3
  },
  {
    "plz": "01108",
    "gebiet": 3
  },
  {
    "plz": "01109",
    "gebiet": 3
  },
  {
    "plz": "01127",
    "gebiet": 3
  },
  {
    "plz": "01129",
    "gebiet": 3
  },
  {
    "plz": "01139",
    "gebiet": 3
  },
  {
    "plz": "01156",
    "gebiet": 3
  },
  {
    "plz": "01157",
    "gebiet": 3
  },
  {
    "plz": "01159",
    "gebiet": 3
  },
  {
    "plz": "01169",
    "gebiet": 3
  },
  {
    "plz": "01187",
    "gebiet": 3
  },
  {
    "plz": "01189",
    "gebiet": 3
  },
  {
    "plz": "01217",
    "gebiet": 3
  },
  {
    "plz": "01219",
    "gebiet": 3
  },
  {
    "plz": "01237",
    "gebiet": 3
  },
  {
    "plz": "01257",
    "gebiet": 3
  },
  {
    "plz": "01259",
    "gebiet": 3
  },
  {
    "plz": "01277",
    "gebiet": 3
  },
  {
    "plz": "01279",
    "gebiet": 3
  },
  {
    "plz": "01282",
    "gebiet": 3
  },
  {
    "plz": "01307",
    "gebiet": 3
  },
  {
    "plz": "01309",
    "gebiet": 3
  },
  {
    "plz": "01324",
    "gebiet": 3
  },
  {
    "plz": "01326",
    "gebiet": 3
  },
  {
    "plz": "01328",
    "gebiet": 3
  },
  {
    "plz": "01445",
    "gebiet": 3
  },
  {
    "plz": "01454",
    "gebiet": 3
  },
  {
    "plz": "01458",
    "gebiet": 3
  },
  {
    "plz": "01468",
    "gebiet": 3
  },
  {
    "plz": "01477",
    "gebiet": 3
  },
  {
    "plz": "01558",
    "gebiet": 3
  },
  {
    "plz": "01561",
    "gebiet": 3
  },
  {
    "plz": "01587",
    "gebiet": 3
  },
  {
    "plz": "01589",
    "gebiet": 3
  },
  {
    "plz": "01591",
    "gebiet": 3
  },
  {
    "plz": "01609",
    "gebiet": 3
  },
  {
    "plz": "01640",
    "gebiet": 3
  },
  {
    "plz": "01662",
    "gebiet": 3
  },
  {
    "plz": "01665",
    "gebiet": 3
  },
  {
    "plz": "01705",
    "gebiet": 3
  },
  {
    "plz": "01723",
    "gebiet": 3
  },
  {
    "plz": "01728",
    "gebiet": 3
  },
  {
    "plz": "01737",
    "gebiet": 3
  },
  {
    "plz": "01744",
    "gebiet": 3
  },
  {
    "plz": "01768",
    "gebiet": 3
  },
  {
    "plz": "01773",
    "gebiet": 3
  },
  {
    "plz": "01774",
    "gebiet": 3
  },
  {
    "plz": "01796",
    "gebiet": 3
  },
  {
    "plz": "01809",
    "gebiet": 3
  },
  {
    "plz": "01814",
    "gebiet": 3
  },
  {
    "plz": "01833",
    "gebiet": 3
  },
  {
    "plz": "01844",
    "gebiet": 3
  },
  {
    "plz": "01847",
    "gebiet": 3
  },
  {
    "plz": "01848",
    "gebiet": 3
  },
  {
    "plz": "01855",
    "gebiet": 3
  },
  {
    "plz": "01877",
    "gebiet": 3
  },
  {
    "plz": "01896",
    "gebiet": 3
  },
  {
    "plz": "01900",
    "gebiet": 3
  },
  {
    "plz": "01904",
    "gebiet": 3
  },
  {
    "plz": "01906",
    "gebiet": 3
  },
  {
    "plz": "01917",
    "gebiet": 3
  },
  {
    "plz": "01920",
    "gebiet": 3
  },
  {
    "plz": "01936",
    "gebiet": 3
  },
  {
    "plz": "01945",
    "gebiet": 3
  },
  {
    "plz": "01958",
    "gebiet": 3
  },
  {
    "plz": "01968",
    "gebiet": 3
  },
  {
    "plz": "01979",
    "gebiet": 3
  },
  {
    "plz": "01983",
    "gebiet": 3
  },
  {
    "plz": "01987",
    "gebiet": 3
  },
  {
    "plz": "01994",
    "gebiet": 3
  },
  {
    "plz": "01996",
    "gebiet": 3
  },
  {
    "plz": "01998",
    "gebiet": 3
  },
  {
    "plz": "02625",
    "gebiet": 3
  },
  {
    "plz": "02681",
    "gebiet": 3
  },
  {
    "plz": "02689",
    "gebiet": 3
  },
  {
    "plz": "02694",
    "gebiet": 3
  },
  {
    "plz": "02708",
    "gebiet": 3
  },
  {
    "plz": "02727",
    "gebiet": 3
  },
  {
    "plz": "02730",
    "gebiet": 3
  },
  {
    "plz": "02733",
    "gebiet": 3
  },
  {
    "plz": "02736",
    "gebiet": 3
  },
  {
    "plz": "02739",
    "gebiet": 3
  },
  {
    "plz": "02747",
    "gebiet": 3
  },
  {
    "plz": "02763",
    "gebiet": 3
  },
  {
    "plz": "02779",
    "gebiet": 3
  },
  {
    "plz": "02785",
    "gebiet": 3
  },
  {
    "plz": "02791",
    "gebiet": 3
  },
  {
    "plz": "02794",
    "gebiet": 3
  },
  {
    "plz": "02826",
    "gebiet": 3
  },
  {
    "plz": "02828",
    "gebiet": 3
  },
  {
    "plz": "02829",
    "gebiet": 3
  },
  {
    "plz": "02906",
    "gebiet": 3
  },
  {
    "plz": "02923",
    "gebiet": 3
  },
  {
    "plz": "02943",
    "gebiet": 3
  },
  {
    "plz": "02953",
    "gebiet": 3
  },
  {
    "plz": "02956",
    "gebiet": 3
  },
  {
    "plz": "02959",
    "gebiet": 3
  },
  {
    "plz": "02977",
    "gebiet": 3
  },
  {
    "plz": "02979",
    "gebiet": 3
  },
  {
    "plz": "02991",
    "gebiet": 3
  },
  {
    "plz": "03042",
    "gebiet": 3
  },
  {
    "plz": "03044",
    "gebiet": 3
  },
  {
    "plz": "03046",
    "gebiet": 3
  },
  {
    "plz": "03048",
    "gebiet": 3
  },
  {
    "plz": "03050",
    "gebiet": 3
  },
  {
    "plz": "03051",
    "gebiet": 3
  },
  {
    "plz": "03055",
    "gebiet": 3
  },
  {
    "plz": "03058",
    "gebiet": 3
  },
  {
    "plz": "03099",
    "gebiet": 3
  },
  {
    "plz": "03116",
    "gebiet": 3
  },
  {
    "plz": "03130",
    "gebiet": 3
  },
  {
    "plz": "03149",
    "gebiet": 3
  },
  {
    "plz": "03159",
    "gebiet": 3
  },
  {
    "plz": "03172",
    "gebiet": 3
  },
  {
    "plz": "03185",
    "gebiet": 3
  },
  {
    "plz": "03205",
    "gebiet": 3
  },
  {
    "plz": "03222",
    "gebiet": 3
  },
  {
    "plz": "03226",
    "gebiet": 3
  },
  {
    "plz": "03238",
    "gebiet": 3
  },
  {
    "plz": "03246",
    "gebiet": 3
  },
  {
    "plz": "03249",
    "gebiet": 3
  },
  {
    "plz": "03253",
    "gebiet": 3
  },
  {
    "plz": "04103",
    "gebiet": 3
  },
  {
    "plz": "04105",
    "gebiet": 3
  },
  {
    "plz": "04107",
    "gebiet": 3
  },
  {
    "plz": "04109",
    "gebiet": 3
  },
  {
    "plz": "04129",
    "gebiet": 3
  },
  {
    "plz": "04131",
    "gebiet": 3
  },
  {
    "plz": "04155",
    "gebiet": 3
  },
  {
    "plz": "04157",
    "gebiet": 3
  },
  {
    "plz": "04158",
    "gebiet": 3
  },
  {
    "plz": "04159",
    "gebiet": 3
  },
  {
    "plz": "04177",
    "gebiet": 3
  },
  {
    "plz": "04178",
    "gebiet": 3
  },
  {
    "plz": "04179",
    "gebiet": 3
  },
  {
    "plz": "04205",
    "gebiet": 3
  },
  {
    "plz": "04207",
    "gebiet": 3
  },
  {
    "plz": "04209",
    "gebiet": 3
  },
  {
    "plz": "04229",
    "gebiet": 3
  },
  {
    "plz": "04249",
    "gebiet": 3
  },
  {
    "plz": "04275",
    "gebiet": 3
  },
  {
    "plz": "04277",
    "gebiet": 3
  },
  {
    "plz": "04288",
    "gebiet": 3
  },
  {
    "plz": "04299",
    "gebiet": 3
  },
  {
    "plz": "04315",
    "gebiet": 3
  },
  {
    "plz": "04317",
    "gebiet": 3
  },
  {
    "plz": "04319",
    "gebiet": 3
  },
  {
    "plz": "04329",
    "gebiet": 3
  },
  {
    "plz": "04347",
    "gebiet": 3
  },
  {
    "plz": "04349",
    "gebiet": 3
  },
  {
    "plz": "04356",
    "gebiet": 3
  },
  {
    "plz": "04357",
    "gebiet": 3
  },
  {
    "plz": "04416",
    "gebiet": 3
  },
  {
    "plz": "04420",
    "gebiet": 3
  },
  {
    "plz": "04425",
    "gebiet": 3
  },
  {
    "plz": "04435",
    "gebiet": 3
  },
  {
    "plz": "04451",
    "gebiet": 3
  },
  {
    "plz": "04509",
    "gebiet": 3
  },
  {
    "plz": "04519",
    "gebiet": 3
  },
  {
    "plz": "04523",
    "gebiet": 5
  },
  {
    "plz": "04539",
    "gebiet": 5
  },
  {
    "plz": "04552",
    "gebiet": 5
  },
  {
    "plz": "04564",
    "gebiet": 3
  },
  {
    "plz": "04565",
    "gebiet": 5
  },
  {
    "plz": "04571",
    "gebiet": 3
  },
  {
    "plz": "04575",
    "gebiet": 5
  },
  {
    "plz": "04600",
    "gebiet": 5
  },
  {
    "plz": "04603",
    "gebiet": 5
  },
  {
    "plz": "04610",
    "gebiet": 5
  },
  {
    "plz": "04613",
    "gebiet": 5
  },
  {
    "plz": "04617",
    "gebiet": 5
  },
  {
    "plz": "04626",
    "gebiet": 5
  },
  {
    "plz": "04643",
    "gebiet": 5
  },
  {
    "plz": "04651",
    "gebiet": 3
  },
  {
    "plz": "04654",
    "gebiet": 5
  },
  {
    "plz": "04668",
    "gebiet": 3
  },
  {
    "plz": "04680",
    "gebiet": 3
  },
  {
    "plz": "04683",
    "gebiet": 3
  },
  {
    "plz": "04703",
    "gebiet": 3
  },
  {
    "plz": "04720",
    "gebiet": 3
  },
  {
    "plz": "04736",
    "gebiet": 3
  },
  {
    "plz": "04741",
    "gebiet": 3
  },
  {
    "plz": "04746",
    "gebiet": 3
  },
  {
    "plz": "04749",
    "gebiet": 3
  },
  {
    "plz": "04758",
    "gebiet": 3
  },
  {
    "plz": "04769",
    "gebiet": 3
  },
  {
    "plz": "04779",
    "gebiet": 3
  },
  {
    "plz": "04808",
    "gebiet": 3
  },
  {
    "plz": "04821",
    "gebiet": 3
  },
  {
    "plz": "04827",
    "gebiet": 3
  },
  {
    "plz": "04828",
    "gebiet": 3
  },
  {
    "plz": "04838",
    "gebiet": 3
  },
  {
    "plz": "04849",
    "gebiet": 3
  },
  {
    "plz": "04860",
    "gebiet": 3
  },
  {
    "plz": "04880",
    "gebiet": 3
  },
  {
    "plz": "04886",
    "gebiet": 3
  },
  {
    "plz": "04895",
    "gebiet": 3
  },
  {
    "plz": "04910",
    "gebiet": 3
  },
  {
    "plz": "04916",
    "gebiet": 3
  },
  {
    "plz": "04924",
    "gebiet": 3
  },
  {
    "plz": "04928",
    "gebiet": 3
  },
  {
    "plz": "04932",
    "gebiet": 3
  },
  {
    "plz": "06052",
    "gebiet": 5
  },
  {
    "plz": "06108",
    "gebiet": 5
  },
  {
    "plz": "06110",
    "gebiet": 5
  },
  {
    "plz": "06112",
    "gebiet": 5
  },
  {
    "plz": "06114",
    "gebiet": 5
  },
  {
    "plz": "06116",
    "gebiet": 5
  },
  {
    "plz": "06118",
    "gebiet": 5
  },
  {
    "plz": "06120",
    "gebiet": 5
  },
  {
    "plz": "06126",
    "gebiet": 5
  },
  {
    "plz": "06130",
    "gebiet": 5
  },
  {
    "plz": "06132",
    "gebiet": 5
  },
  {
    "plz": "06179",
    "gebiet": 5
  },
  {
    "plz": "06188",
    "gebiet": 3
  },
  {
    "plz": "06193",
    "gebiet": 3
  },
  {
    "plz": "06198",
    "gebiet": 5
  },
  {
    "plz": "06217",
    "gebiet": 5
  },
  {
    "plz": "06231",
    "gebiet": 5
  },
  {
    "plz": "06237",
    "gebiet": 5
  },
  {
    "plz": "06246",
    "gebiet": 5
  },
  {
    "plz": "06249",
    "gebiet": 5
  },
  {
    "plz": "06258",
    "gebiet": 5
  },
  {
    "plz": "06268",
    "gebiet": 5
  },
  {
    "plz": "06279",
    "gebiet": 5
  },
  {
    "plz": "06295",
    "gebiet": 5
  },
  {
    "plz": "06308",
    "gebiet": 5
  },
  {
    "plz": "06313",
    "gebiet": 5
  },
  {
    "plz": "06317",
    "gebiet": 5
  },
  {
    "plz": "06333",
    "gebiet": 5
  },
  {
    "plz": "06343",
    "gebiet": 5
  },
  {
    "plz": "06347",
    "gebiet": 5
  },
  {
    "plz": "06366",
    "gebiet": 3
  },
  {
    "plz": "06385",
    "gebiet": 3
  },
  {
    "plz": "06386",
    "gebiet": 3
  },
  {
    "plz": "06388",
    "gebiet": 3
  },
  {
    "plz": "06406",
    "gebiet": 3
  },
  {
    "plz": "06420",
    "gebiet": 5
  },
  {
    "plz": "06425",
    "gebiet": 5
  },
  {
    "plz": "06449",
    "gebiet": 5
  },
  {
    "plz": "06484",
    "gebiet": 5
  },
  {
    "plz": "06485",
    "gebiet": 5
  },
  {
    "plz": "06502",
    "gebiet": 5
  },
  {
    "plz": "06526",
    "gebiet": 5
  },
  {
    "plz": "06528",
    "gebiet": 5
  },
  {
    "plz": "06536",
    "gebiet": 5
  },
  {
    "plz": "06537",
    "gebiet": 5
  },
  {
    "plz": "06542",
    "gebiet": 5
  },
  {
    "plz": "06567",
    "gebiet": 5
  },
  {
    "plz": "06571",
    "gebiet": 5
  },
  {
    "plz": "06618",
    "gebiet": 5
  },
  {
    "plz": "06628",
    "gebiet": 5
  },
  {
    "plz": "06632",
    "gebiet": 5
  },
  {
    "plz": "06642",
    "gebiet": 5
  },
  {
    "plz": "06647",
    "gebiet": 5
  },
  {
    "plz": "06667",
    "gebiet": 5
  },
  {
    "plz": "06679",
    "gebiet": 5
  },
  {
    "plz": "06686",
    "gebiet": 5
  },
  {
    "plz": "06712",
    "gebiet": 5
  },
  {
    "plz": "06731",
    "gebiet": 3
  },
  {
    "plz": "06749",
    "gebiet": 3
  },
  {
    "plz": "06766",
    "gebiet": 3
  },
  {
    "plz": "06773",
    "gebiet": 3
  },
  {
    "plz": "06779",
    "gebiet": 3
  },
  {
    "plz": "06785",
    "gebiet": 3
  },
  {
    "plz": "06800",
    "gebiet": 3
  },
  {
    "plz": "06842",
    "gebiet": 3
  },
  {
    "plz": "06844",
    "gebiet": 3
  },
  {
    "plz": "06846",
    "gebiet": 3
  },
  {
    "plz": "06847",
    "gebiet": 3
  },
  {
    "plz": "06849",
    "gebiet": 3
  },
  {
    "plz": "06862",
    "gebiet": 3
  },
  {
    "plz": "06869",
    "gebiet": 3
  },
  {
    "plz": "06886",
    "gebiet": 3
  },
  {
    "plz": "06888",
    "gebiet": 3
  },
  {
    "plz": "06895",
    "gebiet": 3
  },
  {
    "plz": "06901",
    "gebiet": 3
  },
  {
    "plz": "06917",
    "gebiet": 3
  },
  {
    "plz": "06925",
    "gebiet": 3
  },
  {
    "plz": "07318",
    "gebiet": 5
  },
  {
    "plz": "07333",
    "gebiet": 5
  },
  {
    "plz": "07356",
    "gebiet": 7
  },
  {
    "plz": "07366",
    "gebiet": 7
  },
  {
    "plz": "07381",
    "gebiet": 5
  },
  {
    "plz": "07389",
    "gebiet": 5
  },
  {
    "plz": "07407",
    "gebiet": 5
  },
  {
    "plz": "07422",
    "gebiet": 5
  },
  {
    "plz": "07426",
    "gebiet": 5
  },
  {
    "plz": "07545",
    "gebiet": 5
  },
  {
    "plz": "07546",
    "gebiet": 5
  },
  {
    "plz": "07548",
    "gebiet": 5
  },
  {
    "plz": "07549",
    "gebiet": 5
  },
  {
    "plz": "07551",
    "gebiet": 5
  },
  {
    "plz": "07552",
    "gebiet": 5
  },
  {
    "plz": "07554",
    "gebiet": 5
  },
  {
    "plz": "07570",
    "gebiet": 5
  },
  {
    "plz": "07580",
    "gebiet": 5
  },
  {
    "plz": "07586",
    "gebiet": 5
  },
  {
    "plz": "07589",
    "gebiet": 5
  },
  {
    "plz": "07607",
    "gebiet": 5
  },
  {
    "plz": "07613",
    "gebiet": 5
  },
  {
    "plz": "07616",
    "gebiet": 5
  },
  {
    "plz": "07629",
    "gebiet": 5
  },
  {
    "plz": "07646",
    "gebiet": 5
  },
  {
    "plz": "07743",
    "gebiet": 5
  },
  {
    "plz": "07745",
    "gebiet": 5
  },
  {
    "plz": "07749",
    "gebiet": 5
  },
  {
    "plz": "07751",
    "gebiet": 5
  },
  {
    "plz": "07768",
    "gebiet": 5
  },
  {
    "plz": "07774",
    "gebiet": 5
  },
  {
    "plz": "07778",
    "gebiet": 5
  },
  {
    "plz": "07806",
    "gebiet": 5
  },
  {
    "plz": "07907",
    "gebiet": 5
  },
  {
    "plz": "07922",
    "gebiet": 5
  },
  {
    "plz": "07924",
    "gebiet": 5
  },
  {
    "plz": "07927",
    "gebiet": 7
  },
  {
    "plz": "07937",
    "gebiet": 5
  },
  {
    "plz": "07950",
    "gebiet": 5
  },
  {
    "plz": "07955",
    "gebiet": 5
  },
  {
    "plz": "07973",
    "gebiet": 5
  },
  {
    "plz": "07985",
    "gebiet": 5
  },
  {
    "plz": "08056",
    "gebiet": 5
  },
  {
    "plz": "08058",
    "gebiet": 5
  },
  {
    "plz": "08060",
    "gebiet": 5
  },
  {
    "plz": "08062",
    "gebiet": 5
  },
  {
    "plz": "08064",
    "gebiet": 5
  },
  {
    "plz": "08107",
    "gebiet": 5
  },
  {
    "plz": "08112",
    "gebiet": 5
  },
  {
    "plz": "08115",
    "gebiet": 5
  },
  {
    "plz": "08132",
    "gebiet": 5
  },
  {
    "plz": "08134",
    "gebiet": 5
  },
  {
    "plz": "08141",
    "gebiet": 5
  },
  {
    "plz": "08209",
    "gebiet": 5
  },
  {
    "plz": "08223",
    "gebiet": 5
  },
  {
    "plz": "08228",
    "gebiet": 5
  },
  {
    "plz": "08233",
    "gebiet": 5
  },
  {
    "plz": "08237",
    "gebiet": 5
  },
  {
    "plz": "08248",
    "gebiet": 5
  },
  {
    "plz": "08258",
    "gebiet": 5
  },
  {
    "plz": "08261",
    "gebiet": 5
  },
  {
    "plz": "08262",
    "gebiet": 5
  },
  {
    "plz": "08276",
    "gebiet": 5
  },
  {
    "plz": "08280",
    "gebiet": 5
  },
  {
    "plz": "08289",
    "gebiet": 5
  },
  {
    "plz": "08294",
    "gebiet": 5
  },
  {
    "plz": "08297",
    "gebiet": 5
  },
  {
    "plz": "08304",
    "gebiet": 5
  },
  {
    "plz": "08321",
    "gebiet": 5
  },
  {
    "plz": "08328",
    "gebiet": 5
  },
  {
    "plz": "08340",
    "gebiet": 5
  },
  {
    "plz": "08344",
    "gebiet": 5
  },
  {
    "plz": "08349",
    "gebiet": 5
  },
  {
    "plz": "08359",
    "gebiet": 5
  },
  {
    "plz": "08371",
    "gebiet": 5
  },
  {
    "plz": "08393",
    "gebiet": 5
  },
  {
    "plz": "08412",
    "gebiet": 5
  },
  {
    "plz": "08428",
    "gebiet": 5
  },
  {
    "plz": "08451",
    "gebiet": 5
  },
  {
    "plz": "08459",
    "gebiet": 5
  },
  {
    "plz": "08468",
    "gebiet": 5
  },
  {
    "plz": "08491",
    "gebiet": 5
  },
  {
    "plz": "08496",
    "gebiet": 5
  },
  {
    "plz": "08499",
    "gebiet": 5
  },
  {
    "plz": "08506",
    "gebiet": 5
  },
  {
    "plz": "08523",
    "gebiet": 5
  },
  {
    "plz": "08525",
    "gebiet": 5
  },
  {
    "plz": "08527",
    "gebiet": 5
  },
  {
    "plz": "08538",
    "gebiet": 5
  },
  {
    "plz": "08539",
    "gebiet": 5
  },
  {
    "plz": "08541",
    "gebiet": 5
  },
  {
    "plz": "08606",
    "gebiet": 5
  },
  {
    "plz": "08626",
    "gebiet": 5
  },
  {
    "plz": "08648",
    "gebiet": 5
  },
  {
    "plz": "09026",
    "gebiet": 5
  },
  {
    "plz": "09054",
    "gebiet": 5
  },
  {
    "plz": "09111",
    "gebiet": 5
  },
  {
    "plz": "09112",
    "gebiet": 5
  },
  {
    "plz": "09113",
    "gebiet": 5
  },
  {
    "plz": "09114",
    "gebiet": 5
  },
  {
    "plz": "09116",
    "gebiet": 5
  },
  {
    "plz": "09117",
    "gebiet": 5
  },
  {
    "plz": "09119",
    "gebiet": 5
  },
  {
    "plz": "09120",
    "gebiet": 5
  },
  {
    "plz": "09123",
    "gebiet": 5
  },
  {
    "plz": "09125",
    "gebiet": 5
  },
  {
    "plz": "09126",
    "gebiet": 5
  },
  {
    "plz": "09127",
    "gebiet": 5
  },
  {
    "plz": "09128",
    "gebiet": 5
  },
  {
    "plz": "09130",
    "gebiet": 5
  },
  {
    "plz": "09131",
    "gebiet": 5
  },
  {
    "plz": "09212",
    "gebiet": 5
  },
  {
    "plz": "09217",
    "gebiet": 5
  },
  {
    "plz": "09221",
    "gebiet": 5
  },
  {
    "plz": "09224",
    "gebiet": 5
  },
  {
    "plz": "09228",
    "gebiet": 5
  },
  {
    "plz": "09232",
    "gebiet": 5
  },
  {
    "plz": "09235",
    "gebiet": 5
  },
  {
    "plz": "09243",
    "gebiet": 5
  },
  {
    "plz": "09244",
    "gebiet": 5
  },
  {
    "plz": "09306",
    "gebiet": 5
  },
  {
    "plz": "09322",
    "gebiet": 5
  },
  {
    "plz": "09326",
    "gebiet": 3
  },
  {
    "plz": "09328",
    "gebiet": 5
  },
  {
    "plz": "09337",
    "gebiet": 5
  },
  {
    "plz": "09350",
    "gebiet": 5
  },
  {
    "plz": "09356",
    "gebiet": 5
  },
  {
    "plz": "09366",
    "gebiet": 5
  },
  {
    "plz": "09376",
    "gebiet": 5
  },
  {
    "plz": "09380",
    "gebiet": 5
  },
  {
    "plz": "09385",
    "gebiet": 5
  },
  {
    "plz": "09394",
    "gebiet": 5
  },
  {
    "plz": "09405",
    "gebiet": 5
  },
  {
    "plz": "09419",
    "gebiet": 5
  },
  {
    "plz": "09423",
    "gebiet": 5
  },
  {
    "plz": "09427",
    "gebiet": 5
  },
  {
    "plz": "09430",
    "gebiet": 5
  },
  {
    "plz": "09456",
    "gebiet": 5
  },
  {
    "plz": "09465",
    "gebiet": 5
  },
  {
    "plz": "09474",
    "gebiet": 5
  },
  {
    "plz": "09488",
    "gebiet": 5
  },
  {
    "plz": "09496",
    "gebiet": 5
  },
  {
    "plz": "09526",
    "gebiet": 5
  },
  {
    "plz": "09557",
    "gebiet": 5
  },
  {
    "plz": "09569",
    "gebiet": 5
  },
  {
    "plz": "09573",
    "gebiet": 5
  },
  {
    "plz": "09575",
    "gebiet": 5
  },
  {
    "plz": "09577",
    "gebiet": 5
  },
  {
    "plz": "09579",
    "gebiet": 5
  },
  {
    "plz": "09599",
    "gebiet": 3
  },
  {
    "plz": "09600",
    "gebiet": 3
  },
  {
    "plz": "09603",
    "gebiet": 3
  },
  {
    "plz": "09618",
    "gebiet": 5
  },
  {
    "plz": "09619",
    "gebiet": 5
  },
  {
    "plz": "09627",
    "gebiet": 3
  },
  {
    "plz": "09633",
    "gebiet": 3
  },
  {
    "plz": "09638",
    "gebiet": 3
  },
  {
    "plz": "09648",
    "gebiet": 3
  },
  {
    "plz": "09661",
    "gebiet": 3
  },
  {
    "plz": "09669",
    "gebiet": 5
  },
  {
    "plz": "09944",
    "gebiet": 5
  },
  {
    "plz": "10115",
    "gebiet": 3
  },
  {
    "plz": "10117",
    "gebiet": 3
  },
  {
    "plz": "10119",
    "gebiet": 3
  },
  {
    "plz": "10178",
    "gebiet": 3
  },
  {
    "plz": "10179",
    "gebiet": 3
  },
  {
    "plz": "10207",
    "gebiet": 3
  },
  {
    "plz": "10243",
    "gebiet": 3
  },
  {
    "plz": "10245",
    "gebiet": 3
  },
  {
    "plz": "10247",
    "gebiet": 3
  },
  {
    "plz": "10249",
    "gebiet": 3
  },
  {
    "plz": "10315",
    "gebiet": 3
  },
  {
    "plz": "10317",
    "gebiet": 3
  },
  {
    "plz": "10318",
    "gebiet": 3
  },
  {
    "plz": "10365",
    "gebiet": 3
  },
  {
    "plz": "10367",
    "gebiet": 3
  },
  {
    "plz": "10405",
    "gebiet": 3
  },
  {
    "plz": "10407",
    "gebiet": 3
  },
  {
    "plz": "10409",
    "gebiet": 3
  },
  {
    "plz": "10435",
    "gebiet": 3
  },
  {
    "plz": "10437",
    "gebiet": 3
  },
  {
    "plz": "10439",
    "gebiet": 3
  },
  {
    "plz": "10551",
    "gebiet": 3
  },
  {
    "plz": "10555",
    "gebiet": 3
  },
  {
    "plz": "10557",
    "gebiet": 3
  },
  {
    "plz": "10559",
    "gebiet": 3
  },
  {
    "plz": "10585",
    "gebiet": 3
  },
  {
    "plz": "10587",
    "gebiet": 3
  },
  {
    "plz": "10589",
    "gebiet": 3
  },
  {
    "plz": "10623",
    "gebiet": 3
  },
  {
    "plz": "10625",
    "gebiet": 3
  },
  {
    "plz": "10627",
    "gebiet": 3
  },
  {
    "plz": "10629",
    "gebiet": 3
  },
  {
    "plz": "10707",
    "gebiet": 3
  },
  {
    "plz": "10709",
    "gebiet": 3
  },
  {
    "plz": "10711",
    "gebiet": 3
  },
  {
    "plz": "10713",
    "gebiet": 3
  },
  {
    "plz": "10715",
    "gebiet": 3
  },
  {
    "plz": "10717",
    "gebiet": 3
  },
  {
    "plz": "10719",
    "gebiet": 3
  },
  {
    "plz": "10777",
    "gebiet": 3
  },
  {
    "plz": "10779",
    "gebiet": 3
  },
  {
    "plz": "10781",
    "gebiet": 3
  },
  {
    "plz": "10783",
    "gebiet": 3
  },
  {
    "plz": "10785",
    "gebiet": 3
  },
  {
    "plz": "10787",
    "gebiet": 3
  },
  {
    "plz": "10789",
    "gebiet": 3
  },
  {
    "plz": "10823",
    "gebiet": 3
  },
  {
    "plz": "10827",
    "gebiet": 3
  },
  {
    "plz": "10837",
    "gebiet": 3
  },
  {
    "plz": "10923",
    "gebiet": 3
  },
  {
    "plz": "10961",
    "gebiet": 3
  },
  {
    "plz": "10965",
    "gebiet": 3
  },
  {
    "plz": "10967",
    "gebiet": 3
  },
  {
    "plz": "10969",
    "gebiet": 3
  },
  {
    "plz": "10997",
    "gebiet": 3
  },
  {
    "plz": "10999",
    "gebiet": 3
  },
  {
    "plz": "11516",
    "gebiet": 3
  },
  {
    "plz": "12045",
    "gebiet": 3
  },
  {
    "plz": "12047",
    "gebiet": 3
  },
  {
    "plz": "12051",
    "gebiet": 3
  },
  {
    "plz": "12053",
    "gebiet": 3
  },
  {
    "plz": "12099",
    "gebiet": 3
  },
  {
    "plz": "12101",
    "gebiet": 3
  },
  {
    "plz": "12103",
    "gebiet": 3
  },
  {
    "plz": "12105",
    "gebiet": 3
  },
  {
    "plz": "12107",
    "gebiet": 3
  },
  {
    "plz": "12109",
    "gebiet": 3
  },
  {
    "plz": "12159",
    "gebiet": 3
  },
  {
    "plz": "12161",
    "gebiet": 3
  },
  {
    "plz": "12163",
    "gebiet": 3
  },
  {
    "plz": "12167",
    "gebiet": 3
  },
  {
    "plz": "12169",
    "gebiet": 3
  },
  {
    "plz": "12203",
    "gebiet": 3
  },
  {
    "plz": "12205",
    "gebiet": 3
  },
  {
    "plz": "12207",
    "gebiet": 3
  },
  {
    "plz": "12209",
    "gebiet": 3
  },
  {
    "plz": "12247",
    "gebiet": 3
  },
  {
    "plz": "12249",
    "gebiet": 3
  },
  {
    "plz": "12277",
    "gebiet": 3
  },
  {
    "plz": "12279",
    "gebiet": 3
  },
  {
    "plz": "12305",
    "gebiet": 3
  },
  {
    "plz": "12307",
    "gebiet": 3
  },
  {
    "plz": "12309",
    "gebiet": 3
  },
  {
    "plz": "12347",
    "gebiet": 3
  },
  {
    "plz": "12349",
    "gebiet": 3
  },
  {
    "plz": "12351",
    "gebiet": 3
  },
  {
    "plz": "12353",
    "gebiet": 3
  },
  {
    "plz": "12355",
    "gebiet": 3
  },
  {
    "plz": "12357",
    "gebiet": 3
  },
  {
    "plz": "12435",
    "gebiet": 3
  },
  {
    "plz": "12437",
    "gebiet": 3
  },
  {
    "plz": "12439",
    "gebiet": 3
  },
  {
    "plz": "12459",
    "gebiet": 3
  },
  {
    "plz": "12461",
    "gebiet": 3
  },
  {
    "plz": "12487",
    "gebiet": 3
  },
  {
    "plz": "12489",
    "gebiet": 3
  },
  {
    "plz": "12524",
    "gebiet": 3
  },
  {
    "plz": "12526",
    "gebiet": 3
  },
  {
    "plz": "12527",
    "gebiet": 3
  },
  {
    "plz": "12529",
    "gebiet": 3
  },
  {
    "plz": "12555",
    "gebiet": 3
  },
  {
    "plz": "12557",
    "gebiet": 3
  },
  {
    "plz": "12559",
    "gebiet": 3
  },
  {
    "plz": "12587",
    "gebiet": 3
  },
  {
    "plz": "12589",
    "gebiet": 3
  },
  {
    "plz": "12619",
    "gebiet": 3
  },
  {
    "plz": "12621",
    "gebiet": 3
  },
  {
    "plz": "12623",
    "gebiet": 3
  },
  {
    "plz": "12627",
    "gebiet": 3
  },
  {
    "plz": "12629",
    "gebiet": 3
  },
  {
    "plz": "12679",
    "gebiet": 3
  },
  {
    "plz": "12681",
    "gebiet": 3
  },
  {
    "plz": "12683",
    "gebiet": 3
  },
  {
    "plz": "12685",
    "gebiet": 3
  },
  {
    "plz": "12687",
    "gebiet": 3
  },
  {
    "plz": "12689",
    "gebiet": 3
  },
  {
    "plz": "13051",
    "gebiet": 3
  },
  {
    "plz": "13053",
    "gebiet": 3
  },
  {
    "plz": "13055",
    "gebiet": 3
  },
  {
    "plz": "13086",
    "gebiet": 3
  },
  {
    "plz": "13088",
    "gebiet": 3
  },
  {
    "plz": "13089",
    "gebiet": 3
  },
  {
    "plz": "13092",
    "gebiet": 3
  },
  {
    "plz": "13125",
    "gebiet": 3
  },
  {
    "plz": "13127",
    "gebiet": 3
  },
  {
    "plz": "13156",
    "gebiet": 3
  },
  {
    "plz": "13158",
    "gebiet": 3
  },
  {
    "plz": "13187",
    "gebiet": 3
  },
  {
    "plz": "13189",
    "gebiet": 3
  },
  {
    "plz": "13357",
    "gebiet": 3
  },
  {
    "plz": "13407",
    "gebiet": 3
  },
  {
    "plz": "13409",
    "gebiet": 3
  },
  {
    "plz": "13435",
    "gebiet": 3
  },
  {
    "plz": "13437",
    "gebiet": 3
  },
  {
    "plz": "13439",
    "gebiet": 3
  },
  {
    "plz": "13445",
    "gebiet": 3
  },
  {
    "plz": "13465",
    "gebiet": 3
  },
  {
    "plz": "13467",
    "gebiet": 3
  },
  {
    "plz": "13469",
    "gebiet": 3
  },
  {
    "plz": "13503",
    "gebiet": 3
  },
  {
    "plz": "13507",
    "gebiet": 3
  },
  {
    "plz": "13509",
    "gebiet": 3
  },
  {
    "plz": "13581",
    "gebiet": 3
  },
  {
    "plz": "13583",
    "gebiet": 3
  },
  {
    "plz": "13585",
    "gebiet": 3
  },
  {
    "plz": "13591",
    "gebiet": 3
  },
  {
    "plz": "13593",
    "gebiet": 3
  },
  {
    "plz": "13595",
    "gebiet": 3
  },
  {
    "plz": "13599",
    "gebiet": 3
  },
  {
    "plz": "13627",
    "gebiet": 3
  },
  {
    "plz": "13681",
    "gebiet": 3
  },
  {
    "plz": "14002",
    "gebiet": 3
  },
  {
    "plz": "14050",
    "gebiet": 3
  },
  {
    "plz": "14052",
    "gebiet": 3
  },
  {
    "plz": "14057",
    "gebiet": 3
  },
  {
    "plz": "14059",
    "gebiet": 3
  },
  {
    "plz": "14089",
    "gebiet": 3
  },
  {
    "plz": "14109",
    "gebiet": 3
  },
  {
    "plz": "14163",
    "gebiet": 3
  },
  {
    "plz": "14165",
    "gebiet": 3
  },
  {
    "plz": "14167",
    "gebiet": 3
  },
  {
    "plz": "14169",
    "gebiet": 3
  },
  {
    "plz": "14193",
    "gebiet": 3
  },
  {
    "plz": "14195",
    "gebiet": 3
  },
  {
    "plz": "14197",
    "gebiet": 3
  },
  {
    "plz": "14199",
    "gebiet": 3
  },
  {
    "plz": "14467",
    "gebiet": 3
  },
  {
    "plz": "14469",
    "gebiet": 3
  },
  {
    "plz": "14471",
    "gebiet": 3
  },
  {
    "plz": "14473",
    "gebiet": 3
  },
  {
    "plz": "14476",
    "gebiet": 3
  },
  {
    "plz": "14478",
    "gebiet": 3
  },
  {
    "plz": "14480",
    "gebiet": 3
  },
  {
    "plz": "14482",
    "gebiet": 3
  },
  {
    "plz": "14513",
    "gebiet": 3
  },
  {
    "plz": "14532",
    "gebiet": 3
  },
  {
    "plz": "14542",
    "gebiet": 3
  },
  {
    "plz": "14547",
    "gebiet": 3
  },
  {
    "plz": "14548",
    "gebiet": 3
  },
  {
    "plz": "14550",
    "gebiet": 3
  },
  {
    "plz": "14552",
    "gebiet": 3
  },
  {
    "plz": "14554",
    "gebiet": 3
  },
  {
    "plz": "14558",
    "gebiet": 3
  },
  {
    "plz": "14612",
    "gebiet": 3
  },
  {
    "plz": "14624",
    "gebiet": 3
  },
  {
    "plz": "14641",
    "gebiet": 3
  },
  {
    "plz": "14656",
    "gebiet": 3
  },
  {
    "plz": "14669",
    "gebiet": 3
  },
  {
    "plz": "14703",
    "gebiet": 3
  },
  {
    "plz": "14712",
    "gebiet": 3
  },
  {
    "plz": "14715",
    "gebiet": 3
  },
  {
    "plz": "14727",
    "gebiet": 3
  },
  {
    "plz": "14770",
    "gebiet": 3
  },
  {
    "plz": "14772",
    "gebiet": 3
  },
  {
    "plz": "14776",
    "gebiet": 3
  },
  {
    "plz": "14778",
    "gebiet": 3
  },
  {
    "plz": "14789",
    "gebiet": 3
  },
  {
    "plz": "14793",
    "gebiet": 3
  },
  {
    "plz": "14798",
    "gebiet": 3
  },
  {
    "plz": "14806",
    "gebiet": 3
  },
  {
    "plz": "14913",
    "gebiet": 3
  },
  {
    "plz": "14943",
    "gebiet": 3
  },
  {
    "plz": "14959",
    "gebiet": 3
  },
  {
    "plz": "14974",
    "gebiet": 3
  },
  {
    "plz": "15230",
    "gebiet": 3
  },
  {
    "plz": "15232",
    "gebiet": 3
  },
  {
    "plz": "15234",
    "gebiet": 3
  },
  {
    "plz": "15236",
    "gebiet": 3
  },
  {
    "plz": "15299",
    "gebiet": 3
  },
  {
    "plz": "15306",
    "gebiet": 3
  },
  {
    "plz": "15324",
    "gebiet": 3
  },
  {
    "plz": "15326",
    "gebiet": 3
  },
  {
    "plz": "15344",
    "gebiet": 3
  },
  {
    "plz": "15345",
    "gebiet": 3
  },
  {
    "plz": "15366",
    "gebiet": 3
  },
  {
    "plz": "15370",
    "gebiet": 3
  },
  {
    "plz": "15374",
    "gebiet": 3
  },
  {
    "plz": "15377",
    "gebiet": 3
  },
  {
    "plz": "15378",
    "gebiet": 3
  },
  {
    "plz": "15517",
    "gebiet": 3
  },
  {
    "plz": "15518",
    "gebiet": 3
  },
  {
    "plz": "15526",
    "gebiet": 3
  },
  {
    "plz": "15537",
    "gebiet": 3
  },
  {
    "plz": "15562",
    "gebiet": 3
  },
  {
    "plz": "15566",
    "gebiet": 3
  },
  {
    "plz": "15569",
    "gebiet": 3
  },
  {
    "plz": "15711",
    "gebiet": 3
  },
  {
    "plz": "15712",
    "gebiet": 3
  },
  {
    "plz": "15713",
    "gebiet": 3
  },
  {
    "plz": "15738",
    "gebiet": 3
  },
  {
    "plz": "15741",
    "gebiet": 3
  },
  {
    "plz": "15745",
    "gebiet": 3
  },
  {
    "plz": "15746",
    "gebiet": 3
  },
  {
    "plz": "15749",
    "gebiet": 3
  },
  {
    "plz": "15754",
    "gebiet": 3
  },
  {
    "plz": "15806",
    "gebiet": 3
  },
  {
    "plz": "15827",
    "gebiet": 3
  },
  {
    "plz": "15831",
    "gebiet": 3
  },
  {
    "plz": "15834",
    "gebiet": 3
  },
  {
    "plz": "15838",
    "gebiet": 3
  },
  {
    "plz": "15848",
    "gebiet": 3
  },
  {
    "plz": "15859",
    "gebiet": 3
  },
  {
    "plz": "15864",
    "gebiet": 3
  },
  {
    "plz": "15890",
    "gebiet": 3
  },
  {
    "plz": "15907",
    "gebiet": 3
  },
  {
    "plz": "15913",
    "gebiet": 3
  },
  {
    "plz": "15926",
    "gebiet": 3
  },
  {
    "plz": "15936",
    "gebiet": 3
  },
  {
    "plz": "16225",
    "gebiet": 1
  },
  {
    "plz": "16227",
    "gebiet": 1
  },
  {
    "plz": "16230",
    "gebiet": 1
  },
  {
    "plz": "16247",
    "gebiet": 1
  },
  {
    "plz": "16248",
    "gebiet": 1
  },
  {
    "plz": "16259",
    "gebiet": 1
  },
  {
    "plz": "16278",
    "gebiet": 1
  },
  {
    "plz": "16286",
    "gebiet": 1
  },
  {
    "plz": "16303",
    "gebiet": 1
  },
  {
    "plz": "16321",
    "gebiet": 1
  },
  {
    "plz": "16341",
    "gebiet": 1
  },
  {
    "plz": "16348",
    "gebiet": 1
  },
  {
    "plz": "16356",
    "gebiet": 1
  },
  {
    "plz": "16359",
    "gebiet": 1
  },
  {
    "plz": "16515",
    "gebiet": 1
  },
  {
    "plz": "16540",
    "gebiet": 1
  },
  {
    "plz": "16547",
    "gebiet": 1
  },
  {
    "plz": "16548",
    "gebiet": 1
  },
  {
    "plz": "16552",
    "gebiet": 1
  },
  {
    "plz": "16556",
    "gebiet": 1
  },
  {
    "plz": "16562",
    "gebiet": 1
  },
  {
    "plz": "16567",
    "gebiet": 1
  },
  {
    "plz": "16727",
    "gebiet": 1
  },
  {
    "plz": "16761",
    "gebiet": 1
  },
  {
    "plz": "16766",
    "gebiet": 1
  },
  {
    "plz": "16775",
    "gebiet": 1
  },
  {
    "plz": "16792",
    "gebiet": 1
  },
  {
    "plz": "16802",
    "gebiet": 1
  },
  {
    "plz": "16816",
    "gebiet": 1
  },
  {
    "plz": "16818",
    "gebiet": 1
  },
  {
    "plz": "16827",
    "gebiet": 1
  },
  {
    "plz": "16831",
    "gebiet": 1
  },
  {
    "plz": "16833",
    "gebiet": 1
  },
  {
    "plz": "16835",
    "gebiet": 1
  },
  {
    "plz": "16845",
    "gebiet": 1
  },
  {
    "plz": "16866",
    "gebiet": 1
  },
  {
    "plz": "16868",
    "gebiet": 1
  },
  {
    "plz": "16909",
    "gebiet": 1
  },
  {
    "plz": "16928",
    "gebiet": 1
  },
  {
    "plz": "17033",
    "gebiet": 1
  },
  {
    "plz": "17034",
    "gebiet": 1
  },
  {
    "plz": "17036",
    "gebiet": 1
  },
  {
    "plz": "17039",
    "gebiet": 1
  },
  {
    "plz": "17087",
    "gebiet": 1
  },
  {
    "plz": "17091",
    "gebiet": 1
  },
  {
    "plz": "17094",
    "gebiet": 1
  },
  {
    "plz": "17111",
    "gebiet": 1
  },
  {
    "plz": "17139",
    "gebiet": 1
  },
  {
    "plz": "17153",
    "gebiet": 1
  },
  {
    "plz": "17159",
    "gebiet": 1
  },
  {
    "plz": "17166",
    "gebiet": 1
  },
  {
    "plz": "17168",
    "gebiet": 1
  },
  {
    "plz": "17192",
    "gebiet": 1
  },
  {
    "plz": "17207",
    "gebiet": 1
  },
  {
    "plz": "17213",
    "gebiet": 1
  },
  {
    "plz": "17214",
    "gebiet": 1
  },
  {
    "plz": "17235",
    "gebiet": 1
  },
  {
    "plz": "17252",
    "gebiet": 1
  },
  {
    "plz": "17258",
    "gebiet": 1
  },
  {
    "plz": "17268",
    "gebiet": 1
  },
  {
    "plz": "17291",
    "gebiet": 1
  },
  {
    "plz": "17309",
    "gebiet": 1
  },
  {
    "plz": "17321",
    "gebiet": 1
  },
  {
    "plz": "17328",
    "gebiet": 1
  },
  {
    "plz": "17335",
    "gebiet": 1
  },
  {
    "plz": "17349",
    "gebiet": 1
  },
  {
    "plz": "17389",
    "gebiet": 1
  },
  {
    "plz": "17419",
    "gebiet": 1
  },
  {
    "plz": "17424",
    "gebiet": 1
  },
  {
    "plz": "17438",
    "gebiet": 1
  },
  {
    "plz": "17459",
    "gebiet": 1
  },
  {
    "plz": "17489",
    "gebiet": 1
  },
  {
    "plz": "17491",
    "gebiet": 1
  },
  {
    "plz": "17493",
    "gebiet": 1
  },
  {
    "plz": "17498",
    "gebiet": 1
  },
  {
    "plz": "17509",
    "gebiet": 1
  },
  {
    "plz": "18055",
    "gebiet": 1
  },
  {
    "plz": "18057",
    "gebiet": 1
  },
  {
    "plz": "18059",
    "gebiet": 1
  },
  {
    "plz": "18069",
    "gebiet": 1
  },
  {
    "plz": "18106",
    "gebiet": 1
  },
  {
    "plz": "18107",
    "gebiet": 1
  },
  {
    "plz": "18109",
    "gebiet": 1
  },
  {
    "plz": "18119",
    "gebiet": 1
  },
  {
    "plz": "18146",
    "gebiet": 1
  },
  {
    "plz": "18147",
    "gebiet": 1
  },
  {
    "plz": "18182",
    "gebiet": 1
  },
  {
    "plz": "18184",
    "gebiet": 1
  },
  {
    "plz": "18190",
    "gebiet": 1
  },
  {
    "plz": "18195",
    "gebiet": 1
  },
  {
    "plz": "18196",
    "gebiet": 1
  },
  {
    "plz": "18198",
    "gebiet": 1
  },
  {
    "plz": "18209",
    "gebiet": 1
  },
  {
    "plz": "18211",
    "gebiet": 1
  },
  {
    "plz": "18225",
    "gebiet": 1
  },
  {
    "plz": "18230",
    "gebiet": 1
  },
  {
    "plz": "18239",
    "gebiet": 1
  },
  {
    "plz": "18258",
    "gebiet": 1
  },
  {
    "plz": "18273",
    "gebiet": 1
  },
  {
    "plz": "18276",
    "gebiet": 1
  },
  {
    "plz": "18292",
    "gebiet": 1
  },
  {
    "plz": "18299",
    "gebiet": 1
  },
  {
    "plz": "18311",
    "gebiet": 1
  },
  {
    "plz": "18356",
    "gebiet": 1
  },
  {
    "plz": "18435",
    "gebiet": 1
  },
  {
    "plz": "18437",
    "gebiet": 1
  },
  {
    "plz": "18439",
    "gebiet": 1
  },
  {
    "plz": "18442",
    "gebiet": 1
  },
  {
    "plz": "18445",
    "gebiet": 1
  },
  {
    "plz": "18507",
    "gebiet": 1
  },
  {
    "plz": "18510",
    "gebiet": 1
  },
  {
    "plz": "18528",
    "gebiet": 1
  },
  {
    "plz": "18546",
    "gebiet": 1
  },
  {
    "plz": "18551",
    "gebiet": 1
  },
  {
    "plz": "18573",
    "gebiet": 1
  },
  {
    "plz": "18574",
    "gebiet": 1
  },
  {
    "plz": "18581",
    "gebiet": 1
  },
  {
    "plz": "19053",
    "gebiet": 1
  },
  {
    "plz": "19055",
    "gebiet": 1
  },
  {
    "plz": "19057",
    "gebiet": 1
  },
  {
    "plz": "19059",
    "gebiet": 1
  },
  {
    "plz": "19061",
    "gebiet": 1
  },
  {
    "plz": "19067",
    "gebiet": 1
  },
  {
    "plz": "19071",
    "gebiet": 1
  },
  {
    "plz": "19075",
    "gebiet": 1
  },
  {
    "plz": "19086",
    "gebiet": 1
  },
  {
    "plz": "19089",
    "gebiet": 1
  },
  {
    "plz": "19205",
    "gebiet": 1
  },
  {
    "plz": "19209",
    "gebiet": 1
  },
  {
    "plz": "19217",
    "gebiet": 1
  },
  {
    "plz": "19230",
    "gebiet": 1
  },
  {
    "plz": "19246",
    "gebiet": 1
  },
  {
    "plz": "19273",
    "gebiet": 1
  },
  {
    "plz": "19294",
    "gebiet": 1
  },
  {
    "plz": "19300",
    "gebiet": 1
  },
  {
    "plz": "19322",
    "gebiet": 1
  },
  {
    "plz": "19348",
    "gebiet": 1
  },
  {
    "plz": "19357",
    "gebiet": 1
  },
  {
    "plz": "19370",
    "gebiet": 1
  },
  {
    "plz": "19372",
    "gebiet": 1
  },
  {
    "plz": "19374",
    "gebiet": 1
  },
  {
    "plz": "19386",
    "gebiet": 1
  },
  {
    "plz": "19399",
    "gebiet": 1
  },
  {
    "plz": "19406",
    "gebiet": 1
  },
  {
    "plz": "19412",
    "gebiet": 1
  },
  {
    "plz": "19417",
    "gebiet": 1
  },
  {
    "plz": "20007",
    "gebiet": 1
  },
  {
    "plz": "20036",
    "gebiet": 1
  },
  {
    "plz": "20095",
    "gebiet": 1
  },
  {
    "plz": "20097",
    "gebiet": 1
  },
  {
    "plz": "20099",
    "gebiet": 1
  },
  {
    "plz": "20144",
    "gebiet": 1
  },
  {
    "plz": "20146",
    "gebiet": 1
  },
  {
    "plz": "20148",
    "gebiet": 1
  },
  {
    "plz": "20249",
    "gebiet": 1
  },
  {
    "plz": "20251",
    "gebiet": 1
  },
  {
    "plz": "20255",
    "gebiet": 1
  },
  {
    "plz": "20257",
    "gebiet": 1
  },
  {
    "plz": "20306",
    "gebiet": 1
  },
  {
    "plz": "20351",
    "gebiet": 1
  },
  {
    "plz": "20354",
    "gebiet": 1
  },
  {
    "plz": "20355",
    "gebiet": 1
  },
  {
    "plz": "20359",
    "gebiet": 1
  },
  {
    "plz": "20457",
    "gebiet": 1
  },
  {
    "plz": "20459",
    "gebiet": 1
  },
  {
    "plz": "20535",
    "gebiet": 1
  },
  {
    "plz": "20537",
    "gebiet": 1
  },
  {
    "plz": "21029",
    "gebiet": 1
  },
  {
    "plz": "21031",
    "gebiet": 1
  },
  {
    "plz": "21033",
    "gebiet": 1
  },
  {
    "plz": "21035",
    "gebiet": 1
  },
  {
    "plz": "21039",
    "gebiet": 1
  },
  {
    "plz": "21073",
    "gebiet": 1
  },
  {
    "plz": "21075",
    "gebiet": 1
  },
  {
    "plz": "21077",
    "gebiet": 1
  },
  {
    "plz": "21079",
    "gebiet": 1
  },
  {
    "plz": "21109",
    "gebiet": 1
  },
  {
    "plz": "21129",
    "gebiet": 1
  },
  {
    "plz": "21147",
    "gebiet": 1
  },
  {
    "plz": "21149",
    "gebiet": 1
  },
  {
    "plz": "21217",
    "gebiet": 1
  },
  {
    "plz": "21218",
    "gebiet": 1
  },
  {
    "plz": "21220",
    "gebiet": 1
  },
  {
    "plz": "21224",
    "gebiet": 1
  },
  {
    "plz": "21228",
    "gebiet": 1
  },
  {
    "plz": "21235",
    "gebiet": 1
  },
  {
    "plz": "21244",
    "gebiet": 1
  },
  {
    "plz": "21255",
    "gebiet": 1
  },
  {
    "plz": "21256",
    "gebiet": 1
  },
  {
    "plz": "21261",
    "gebiet": 1
  },
  {
    "plz": "21266",
    "gebiet": 1
  },
  {
    "plz": "21271",
    "gebiet": 1
  },
  {
    "plz": "21335",
    "gebiet": 1
  },
  {
    "plz": "21337",
    "gebiet": 1
  },
  {
    "plz": "21339",
    "gebiet": 1
  },
  {
    "plz": "21368",
    "gebiet": 1
  },
  {
    "plz": "21376",
    "gebiet": 1
  },
  {
    "plz": "21385",
    "gebiet": 1
  },
  {
    "plz": "21389",
    "gebiet": 1
  },
  {
    "plz": "21391",
    "gebiet": 1
  },
  {
    "plz": "21394",
    "gebiet": 1
  },
  {
    "plz": "21397",
    "gebiet": 1
  },
  {
    "plz": "21398",
    "gebiet": 1
  },
  {
    "plz": "21407",
    "gebiet": 1
  },
  {
    "plz": "21409",
    "gebiet": 1
  },
  {
    "plz": "21423",
    "gebiet": 1
  },
  {
    "plz": "21435",
    "gebiet": 1
  },
  {
    "plz": "21436",
    "gebiet": 1
  },
  {
    "plz": "21444",
    "gebiet": 1
  },
  {
    "plz": "21445",
    "gebiet": 1
  },
  {
    "plz": "21465",
    "gebiet": 1
  },
  {
    "plz": "21481",
    "gebiet": 1
  },
  {
    "plz": "21493",
    "gebiet": 1
  },
  {
    "plz": "21497",
    "gebiet": 1
  },
  {
    "plz": "21502",
    "gebiet": 1
  },
  {
    "plz": "21509",
    "gebiet": 1
  },
  {
    "plz": "21514",
    "gebiet": 1
  },
  {
    "plz": "21516",
    "gebiet": 1
  },
  {
    "plz": "21521",
    "gebiet": 1
  },
  {
    "plz": "21614",
    "gebiet": 1
  },
  {
    "plz": "21629",
    "gebiet": 1
  },
  {
    "plz": "21635",
    "gebiet": 1
  },
  {
    "plz": "21643",
    "gebiet": 1
  },
  {
    "plz": "21644",
    "gebiet": 1
  },
  {
    "plz": "21680",
    "gebiet": 1
  },
  {
    "plz": "21682",
    "gebiet": 1
  },
  {
    "plz": "21683",
    "gebiet": 1
  },
  {
    "plz": "21684",
    "gebiet": 1
  },
  {
    "plz": "21698",
    "gebiet": 1
  },
  {
    "plz": "21706",
    "gebiet": 1
  },
  {
    "plz": "21717",
    "gebiet": 1
  },
  {
    "plz": "21755",
    "gebiet": 1
  },
  {
    "plz": "22041",
    "gebiet": 1
  },
  {
    "plz": "22043",
    "gebiet": 1
  },
  {
    "plz": "22045",
    "gebiet": 1
  },
  {
    "plz": "22047",
    "gebiet": 1
  },
  {
    "plz": "22049",
    "gebiet": 1
  },
  {
    "plz": "22083",
    "gebiet": 1
  },
  {
    "plz": "22085",
    "gebiet": 1
  },
  {
    "plz": "22087",
    "gebiet": 1
  },
  {
    "plz": "22089",
    "gebiet": 1
  },
  {
    "plz": "22111",
    "gebiet": 1
  },
  {
    "plz": "22113",
    "gebiet": 1
  },
  {
    "plz": "22115",
    "gebiet": 1
  },
  {
    "plz": "22119",
    "gebiet": 1
  },
  {
    "plz": "22121",
    "gebiet": 1
  },
  {
    "plz": "22124",
    "gebiet": 1
  },
  {
    "plz": "22143",
    "gebiet": 1
  },
  {
    "plz": "22145",
    "gebiet": 1
  },
  {
    "plz": "22147",
    "gebiet": 1
  },
  {
    "plz": "22159",
    "gebiet": 1
  },
  {
    "plz": "22175",
    "gebiet": 1
  },
  {
    "plz": "22179",
    "gebiet": 1
  },
  {
    "plz": "22297",
    "gebiet": 1
  },
  {
    "plz": "22299",
    "gebiet": 1
  },
  {
    "plz": "22301",
    "gebiet": 1
  },
  {
    "plz": "22303",
    "gebiet": 1
  },
  {
    "plz": "22307",
    "gebiet": 1
  },
  {
    "plz": "22335",
    "gebiet": 1
  },
  {
    "plz": "22337",
    "gebiet": 1
  },
  {
    "plz": "22339",
    "gebiet": 1
  },
  {
    "plz": "22359",
    "gebiet": 1
  },
  {
    "plz": "22391",
    "gebiet": 1
  },
  {
    "plz": "22393",
    "gebiet": 1
  },
  {
    "plz": "22395",
    "gebiet": 1
  },
  {
    "plz": "22397",
    "gebiet": 1
  },
  {
    "plz": "22399",
    "gebiet": 1
  },
  {
    "plz": "22415",
    "gebiet": 1
  },
  {
    "plz": "22417",
    "gebiet": 1
  },
  {
    "plz": "22419",
    "gebiet": 1
  },
  {
    "plz": "22424",
    "gebiet": 1
  },
  {
    "plz": "22453",
    "gebiet": 1
  },
  {
    "plz": "22457",
    "gebiet": 1
  },
  {
    "plz": "22459",
    "gebiet": 1
  },
  {
    "plz": "22506",
    "gebiet": 1
  },
  {
    "plz": "22523",
    "gebiet": 1
  },
  {
    "plz": "22525",
    "gebiet": 1
  },
  {
    "plz": "22527",
    "gebiet": 1
  },
  {
    "plz": "22529",
    "gebiet": 1
  },
  {
    "plz": "22533",
    "gebiet": 1
  },
  {
    "plz": "22549",
    "gebiet": 1
  },
  {
    "plz": "22559",
    "gebiet": 1
  },
  {
    "plz": "22587",
    "gebiet": 1
  },
  {
    "plz": "22589",
    "gebiet": 1
  },
  {
    "plz": "22605",
    "gebiet": 1
  },
  {
    "plz": "22607",
    "gebiet": 1
  },
  {
    "plz": "22609",
    "gebiet": 1
  },
  {
    "plz": "22761",
    "gebiet": 1
  },
  {
    "plz": "22763",
    "gebiet": 1
  },
  {
    "plz": "22765",
    "gebiet": 1
  },
  {
    "plz": "22767",
    "gebiet": 1
  },
  {
    "plz": "22769",
    "gebiet": 1
  },
  {
    "plz": "22844",
    "gebiet": 1
  },
  {
    "plz": "22846",
    "gebiet": 1
  },
  {
    "plz": "22848",
    "gebiet": 1
  },
  {
    "plz": "22850",
    "gebiet": 1
  },
  {
    "plz": "22869",
    "gebiet": 1
  },
  {
    "plz": "22880",
    "gebiet": 1
  },
  {
    "plz": "22885",
    "gebiet": 1
  },
  {
    "plz": "22905",
    "gebiet": 1
  },
  {
    "plz": "22926",
    "gebiet": 1
  },
  {
    "plz": "22941",
    "gebiet": 1
  },
  {
    "plz": "22946",
    "gebiet": 1
  },
  {
    "plz": "22949",
    "gebiet": 1
  },
  {
    "plz": "22955",
    "gebiet": 1
  },
  {
    "plz": "22958",
    "gebiet": 1
  },
  {
    "plz": "22959",
    "gebiet": 1
  },
  {
    "plz": "22964",
    "gebiet": 1
  },
  {
    "plz": "22965",
    "gebiet": 1
  },
  {
    "plz": "22967",
    "gebiet": 1
  },
  {
    "plz": "23532",
    "gebiet": 1
  },
  {
    "plz": "23552",
    "gebiet": 1
  },
  {
    "plz": "23554",
    "gebiet": 1
  },
  {
    "plz": "23556",
    "gebiet": 1
  },
  {
    "plz": "23558",
    "gebiet": 1
  },
  {
    "plz": "23560",
    "gebiet": 1
  },
  {
    "plz": "23562",
    "gebiet": 1
  },
  {
    "plz": "23564",
    "gebiet": 1
  },
  {
    "plz": "23566",
    "gebiet": 1
  },
  {
    "plz": "23568",
    "gebiet": 1
  },
  {
    "plz": "23569",
    "gebiet": 1
  },
  {
    "plz": "23570",
    "gebiet": 1
  },
  {
    "plz": "23611",
    "gebiet": 1
  },
  {
    "plz": "23617",
    "gebiet": 1
  },
  {
    "plz": "23619",
    "gebiet": 1
  },
  {
    "plz": "23623",
    "gebiet": 1
  },
  {
    "plz": "23626",
    "gebiet": 1
  },
  {
    "plz": "23627",
    "gebiet": 1
  },
  {
    "plz": "23669",
    "gebiet": 1
  },
  {
    "plz": "23683",
    "gebiet": 1
  },
  {
    "plz": "23684",
    "gebiet": 1
  },
  {
    "plz": "23689",
    "gebiet": 1
  },
  {
    "plz": "23701",
    "gebiet": 1
  },
  {
    "plz": "23714",
    "gebiet": 1
  },
  {
    "plz": "23717",
    "gebiet": 1
  },
  {
    "plz": "23738",
    "gebiet": 1
  },
  {
    "plz": "23743",
    "gebiet": 1
  },
  {
    "plz": "23749",
    "gebiet": 1
  },
  {
    "plz": "23758",
    "gebiet": 1
  },
  {
    "plz": "23769",
    "gebiet": 1
  },
  {
    "plz": "23774",
    "gebiet": 1
  },
  {
    "plz": "23795",
    "gebiet": 1
  },
  {
    "plz": "23812",
    "gebiet": 1
  },
  {
    "plz": "23815",
    "gebiet": 1
  },
  {
    "plz": "23816",
    "gebiet": 1
  },
  {
    "plz": "23821",
    "gebiet": 1
  },
  {
    "plz": "23829",
    "gebiet": 1
  },
  {
    "plz": "23843",
    "gebiet": 1
  },
  {
    "plz": "23858",
    "gebiet": 1
  },
  {
    "plz": "23863",
    "gebiet": 1
  },
  {
    "plz": "23867",
    "gebiet": 1
  },
  {
    "plz": "23879",
    "gebiet": 1
  },
  {
    "plz": "23898",
    "gebiet": 1
  },
  {
    "plz": "23909",
    "gebiet": 1
  },
  {
    "plz": "23911",
    "gebiet": 1
  },
  {
    "plz": "23919",
    "gebiet": 1
  },
  {
    "plz": "23923",
    "gebiet": 1
  },
  {
    "plz": "23936",
    "gebiet": 1
  },
  {
    "plz": "23946",
    "gebiet": 1
  },
  {
    "plz": "23952",
    "gebiet": 1
  },
  {
    "plz": "23966",
    "gebiet": 1
  },
  {
    "plz": "23968",
    "gebiet": 1
  },
  {
    "plz": "23970",
    "gebiet": 1
  },
  {
    "plz": "24103",
    "gebiet": 1
  },
  {
    "plz": "24105",
    "gebiet": 1
  },
  {
    "plz": "24106",
    "gebiet": 1
  },
  {
    "plz": "24107",
    "gebiet": 1
  },
  {
    "plz": "24109",
    "gebiet": 1
  },
  {
    "plz": "24113",
    "gebiet": 1
  },
  {
    "plz": "24114",
    "gebiet": 1
  },
  {
    "plz": "24116",
    "gebiet": 1
  },
  {
    "plz": "24143",
    "gebiet": 1
  },
  {
    "plz": "24145",
    "gebiet": 1
  },
  {
    "plz": "24146",
    "gebiet": 1
  },
  {
    "plz": "24147",
    "gebiet": 1
  },
  {
    "plz": "24148",
    "gebiet": 1
  },
  {
    "plz": "24149",
    "gebiet": 1
  },
  {
    "plz": "24154",
    "gebiet": 1
  },
  {
    "plz": "24159",
    "gebiet": 1
  },
  {
    "plz": "24161",
    "gebiet": 1
  },
  {
    "plz": "24211",
    "gebiet": 1
  },
  {
    "plz": "24214",
    "gebiet": 1
  },
  {
    "plz": "24217",
    "gebiet": 1
  },
  {
    "plz": "24220",
    "gebiet": 1
  },
  {
    "plz": "24223",
    "gebiet": 1
  },
  {
    "plz": "24226",
    "gebiet": 1
  },
  {
    "plz": "24232",
    "gebiet": 1
  },
  {
    "plz": "24235",
    "gebiet": 1
  },
  {
    "plz": "24242",
    "gebiet": 1
  },
  {
    "plz": "24245",
    "gebiet": 1
  },
  {
    "plz": "24247",
    "gebiet": 1
  },
  {
    "plz": "24306",
    "gebiet": 1
  },
  {
    "plz": "24321",
    "gebiet": 1
  },
  {
    "plz": "24326",
    "gebiet": 1
  },
  {
    "plz": "24340",
    "gebiet": 1
  },
  {
    "plz": "24357",
    "gebiet": 1
  },
  {
    "plz": "24358",
    "gebiet": 1
  },
  {
    "plz": "24376",
    "gebiet": 1
  },
  {
    "plz": "24534",
    "gebiet": 1
  },
  {
    "plz": "24536",
    "gebiet": 1
  },
  {
    "plz": "24537",
    "gebiet": 1
  },
  {
    "plz": "24539",
    "gebiet": 1
  },
  {
    "plz": "24558",
    "gebiet": 1
  },
  {
    "plz": "24568",
    "gebiet": 1
  },
  {
    "plz": "24576",
    "gebiet": 1
  },
  {
    "plz": "24589",
    "gebiet": 1
  },
  {
    "plz": "24594",
    "gebiet": 1
  },
  {
    "plz": "24598",
    "gebiet": 1
  },
  {
    "plz": "24610",
    "gebiet": 1
  },
  {
    "plz": "24613",
    "gebiet": 1
  },
  {
    "plz": "24619",
    "gebiet": 1
  },
  {
    "plz": "24622",
    "gebiet": 1
  },
  {
    "plz": "24628",
    "gebiet": 1
  },
  {
    "plz": "24629",
    "gebiet": 1
  },
  {
    "plz": "24631",
    "gebiet": 1
  },
  {
    "plz": "24632",
    "gebiet": 1
  },
  {
    "plz": "24635",
    "gebiet": 1
  },
  {
    "plz": "24646",
    "gebiet": 1
  },
  {
    "plz": "24768",
    "gebiet": 1
  },
  {
    "plz": "24782",
    "gebiet": 1
  },
  {
    "plz": "24787",
    "gebiet": 1
  },
  {
    "plz": "24796",
    "gebiet": 1
  },
  {
    "plz": "24799",
    "gebiet": 1
  },
  {
    "plz": "24808",
    "gebiet": 1
  },
  {
    "plz": "24809",
    "gebiet": 1
  },
  {
    "plz": "24814",
    "gebiet": 1
  },
  {
    "plz": "24819",
    "gebiet": 1
  },
  {
    "plz": "24837",
    "gebiet": 1
  },
  {
    "plz": "24848",
    "gebiet": 1
  },
  {
    "plz": "24852",
    "gebiet": 1
  },
  {
    "plz": "24855",
    "gebiet": 1
  },
  {
    "plz": "24860",
    "gebiet": 1
  },
  {
    "plz": "24875",
    "gebiet": 1
  },
  {
    "plz": "24879",
    "gebiet": 1
  },
  {
    "plz": "24881",
    "gebiet": 1
  },
  {
    "plz": "24894",
    "gebiet": 1
  },
  {
    "plz": "24899",
    "gebiet": 1
  },
  {
    "plz": "24937",
    "gebiet": 1
  },
  {
    "plz": "24939",
    "gebiet": 1
  },
  {
    "plz": "24941",
    "gebiet": 1
  },
  {
    "plz": "24943",
    "gebiet": 1
  },
  {
    "plz": "24944",
    "gebiet": 1
  },
  {
    "plz": "24960",
    "gebiet": 1
  },
  {
    "plz": "24972",
    "gebiet": 1
  },
  {
    "plz": "24975",
    "gebiet": 1
  },
  {
    "plz": "24976",
    "gebiet": 1
  },
  {
    "plz": "24980",
    "gebiet": 1
  },
  {
    "plz": "24986",
    "gebiet": 1
  },
  {
    "plz": "24988",
    "gebiet": 1
  },
  {
    "plz": "24989",
    "gebiet": 1
  },
  {
    "plz": "24992",
    "gebiet": 1
  },
  {
    "plz": "24999",
    "gebiet": 1
  },
  {
    "plz": "25335",
    "gebiet": 1
  },
  {
    "plz": "25336",
    "gebiet": 1
  },
  {
    "plz": "25337",
    "gebiet": 1
  },
  {
    "plz": "25348",
    "gebiet": 1
  },
  {
    "plz": "25355",
    "gebiet": 1
  },
  {
    "plz": "25358",
    "gebiet": 1
  },
  {
    "plz": "25365",
    "gebiet": 1
  },
  {
    "plz": "25371",
    "gebiet": 1
  },
  {
    "plz": "25376",
    "gebiet": 1
  },
  {
    "plz": "25377",
    "gebiet": 1
  },
  {
    "plz": "25421",
    "gebiet": 1
  },
  {
    "plz": "25436",
    "gebiet": 1
  },
  {
    "plz": "25451",
    "gebiet": 1
  },
  {
    "plz": "25452",
    "gebiet": 1
  },
  {
    "plz": "25462",
    "gebiet": 1
  },
  {
    "plz": "25469",
    "gebiet": 1
  },
  {
    "plz": "25474",
    "gebiet": 1
  },
  {
    "plz": "25479",
    "gebiet": 1
  },
  {
    "plz": "25485",
    "gebiet": 1
  },
  {
    "plz": "25489",
    "gebiet": 1
  },
  {
    "plz": "25521",
    "gebiet": 1
  },
  {
    "plz": "25524",
    "gebiet": 1
  },
  {
    "plz": "25541",
    "gebiet": 1
  },
  {
    "plz": "25548",
    "gebiet": 1
  },
  {
    "plz": "25551",
    "gebiet": 1
  },
  {
    "plz": "25557",
    "gebiet": 1
  },
  {
    "plz": "25563",
    "gebiet": 1
  },
  {
    "plz": "25569",
    "gebiet": 1
  },
  {
    "plz": "25575",
    "gebiet": 1
  },
  {
    "plz": "25582",
    "gebiet": 1
  },
  {
    "plz": "25596",
    "gebiet": 1
  },
  {
    "plz": "25704",
    "gebiet": 1
  },
  {
    "plz": "25709",
    "gebiet": 1
  },
  {
    "plz": "25727",
    "gebiet": 1
  },
  {
    "plz": "25746",
    "gebiet": 1
  },
  {
    "plz": "25770",
    "gebiet": 1
  },
  {
    "plz": "25782",
    "gebiet": 1
  },
  {
    "plz": "25795",
    "gebiet": 1
  },
  {
    "plz": "25813",
    "gebiet": 1
  },
  {
    "plz": "25821",
    "gebiet": 1
  },
  {
    "plz": "25832",
    "gebiet": 1
  },
  {
    "plz": "25840",
    "gebiet": 1
  },
  {
    "plz": "25845",
    "gebiet": 1
  },
  {
    "plz": "25866",
    "gebiet": 1
  },
  {
    "plz": "25899",
    "gebiet": 1
  },
  {
    "plz": "25924",
    "gebiet": 1
  },
  {
    "plz": "26053",
    "gebiet": 1
  },
  {
    "plz": "26121",
    "gebiet": 2
  },
  {
    "plz": "26122",
    "gebiet": 2
  },
  {
    "plz": "26123",
    "gebiet": 2
  },
  {
    "plz": "26125",
    "gebiet": 2
  },
  {
    "plz": "26127",
    "gebiet": 2
  },
  {
    "plz": "26131",
    "gebiet": 2
  },
  {
    "plz": "26133",
    "gebiet": 2
  },
  {
    "plz": "26135",
    "gebiet": 2
  },
  {
    "plz": "26160",
    "gebiet": 2
  },
  {
    "plz": "26169",
    "gebiet": 2
  },
  {
    "plz": "26180",
    "gebiet": 2
  },
  {
    "plz": "26188",
    "gebiet": 2
  },
  {
    "plz": "26203",
    "gebiet": 2
  },
  {
    "plz": "26209",
    "gebiet": 2
  },
  {
    "plz": "26215",
    "gebiet": 2
  },
  {
    "plz": "26219",
    "gebiet": 2
  },
  {
    "plz": "26316",
    "gebiet": 2
  },
  {
    "plz": "26340",
    "gebiet": 2
  },
  {
    "plz": "26349",
    "gebiet": 2
  },
  {
    "plz": "26382",
    "gebiet": 2
  },
  {
    "plz": "26386",
    "gebiet": 2
  },
  {
    "plz": "26389",
    "gebiet": 2
  },
  {
    "plz": "26409",
    "gebiet": 2
  },
  {
    "plz": "26419",
    "gebiet": 2
  },
  {
    "plz": "26427",
    "gebiet": 2
  },
  {
    "plz": "26434",
    "gebiet": 2
  },
  {
    "plz": "26446",
    "gebiet": 2
  },
  {
    "plz": "26506",
    "gebiet": 2
  },
  {
    "plz": "26529",
    "gebiet": 2
  },
  {
    "plz": "26532",
    "gebiet": 2
  },
  {
    "plz": "26585",
    "gebiet": 2
  },
  {
    "plz": "26603",
    "gebiet": 2
  },
  {
    "plz": "26605",
    "gebiet": 2
  },
  {
    "plz": "26607",
    "gebiet": 2
  },
  {
    "plz": "26639",
    "gebiet": 2
  },
  {
    "plz": "26655",
    "gebiet": 2
  },
  {
    "plz": "26670",
    "gebiet": 2
  },
  {
    "plz": "26676",
    "gebiet": 2
  },
  {
    "plz": "26683",
    "gebiet": 2
  },
  {
    "plz": "26689",
    "gebiet": 2
  },
  {
    "plz": "26721",
    "gebiet": 2
  },
  {
    "plz": "26725",
    "gebiet": 2
  },
  {
    "plz": "26789",
    "gebiet": 2
  },
  {
    "plz": "26817",
    "gebiet": 2
  },
  {
    "plz": "26826",
    "gebiet": 2
  },
  {
    "plz": "26831",
    "gebiet": 2
  },
  {
    "plz": "26835",
    "gebiet": 2
  },
  {
    "plz": "26842",
    "gebiet": 2
  },
  {
    "plz": "26845",
    "gebiet": 2
  },
  {
    "plz": "26871",
    "gebiet": 2
  },
  {
    "plz": "26892",
    "gebiet": 2
  },
  {
    "plz": "26904",
    "gebiet": 2
  },
  {
    "plz": "26931",
    "gebiet": 2
  },
  {
    "plz": "26935",
    "gebiet": 2
  },
  {
    "plz": "26954",
    "gebiet": 2
  },
  {
    "plz": "27211",
    "gebiet": 1
  },
  {
    "plz": "27232",
    "gebiet": 2
  },
  {
    "plz": "27239",
    "gebiet": 2
  },
  {
    "plz": "27243",
    "gebiet": 1
  },
  {
    "plz": "27245",
    "gebiet": 2
  },
  {
    "plz": "27257",
    "gebiet": 2
  },
  {
    "plz": "27283",
    "gebiet": 1
  },
  {
    "plz": "27299",
    "gebiet": 1
  },
  {
    "plz": "27305",
    "gebiet": 2
  },
  {
    "plz": "27308",
    "gebiet": 1
  },
  {
    "plz": "27327",
    "gebiet": 1
  },
  {
    "plz": "27356",
    "gebiet": 1
  },
  {
    "plz": "27367",
    "gebiet": 1
  },
  {
    "plz": "27383",
    "gebiet": 1
  },
  {
    "plz": "27404",
    "gebiet": 1
  },
  {
    "plz": "27412",
    "gebiet": 1
  },
  {
    "plz": "27419",
    "gebiet": 1
  },
  {
    "plz": "27432",
    "gebiet": 1
  },
  {
    "plz": "27442",
    "gebiet": 1
  },
  {
    "plz": "27446",
    "gebiet": 1
  },
  {
    "plz": "27472",
    "gebiet": 1
  },
  {
    "plz": "27476",
    "gebiet": 1
  },
  {
    "plz": "27568",
    "gebiet": 1
  },
  {
    "plz": "27570",
    "gebiet": 1
  },
  {
    "plz": "27572",
    "gebiet": 1
  },
  {
    "plz": "27574",
    "gebiet": 1
  },
  {
    "plz": "27578",
    "gebiet": 1
  },
  {
    "plz": "27580",
    "gebiet": 1
  },
  {
    "plz": "27616",
    "gebiet": 1
  },
  {
    "plz": "27711",
    "gebiet": 1
  },
  {
    "plz": "27721",
    "gebiet": 1
  },
  {
    "plz": "27729",
    "gebiet": 1
  },
  {
    "plz": "27749",
    "gebiet": 1
  },
  {
    "plz": "27753",
    "gebiet": 1
  },
  {
    "plz": "27755",
    "gebiet": 1
  },
  {
    "plz": "27777",
    "gebiet": 1
  },
  {
    "plz": "27778",
    "gebiet": 1
  },
  {
    "plz": "27793",
    "gebiet": 2
  },
  {
    "plz": "27798",
    "gebiet": 2
  },
  {
    "plz": "27801",
    "gebiet": 1
  },
  {
    "plz": "27804",
    "gebiet": 2
  },
  {
    "plz": "27809",
    "gebiet": 1
  },
  {
    "plz": "28058",
    "gebiet": 1
  },
  {
    "plz": "28195",
    "gebiet": 1
  },
  {
    "plz": "28197",
    "gebiet": 1
  },
  {
    "plz": "28199",
    "gebiet": 1
  },
  {
    "plz": "28201",
    "gebiet": 1
  },
  {
    "plz": "28203",
    "gebiet": 1
  },
  {
    "plz": "28205",
    "gebiet": 1
  },
  {
    "plz": "28207",
    "gebiet": 1
  },
  {
    "plz": "28209",
    "gebiet": 1
  },
  {
    "plz": "28211",
    "gebiet": 1
  },
  {
    "plz": "28215",
    "gebiet": 1
  },
  {
    "plz": "28217",
    "gebiet": 1
  },
  {
    "plz": "28219",
    "gebiet": 1
  },
  {
    "plz": "28239",
    "gebiet": 1
  },
  {
    "plz": "28259",
    "gebiet": 1
  },
  {
    "plz": "28277",
    "gebiet": 1
  },
  {
    "plz": "28279",
    "gebiet": 1
  },
  {
    "plz": "28307",
    "gebiet": 1
  },
  {
    "plz": "28309",
    "gebiet": 1
  },
  {
    "plz": "28325",
    "gebiet": 1
  },
  {
    "plz": "28327",
    "gebiet": 1
  },
  {
    "plz": "28329",
    "gebiet": 1
  },
  {
    "plz": "28355",
    "gebiet": 1
  },
  {
    "plz": "28359",
    "gebiet": 1
  },
  {
    "plz": "28717",
    "gebiet": 1
  },
  {
    "plz": "28757",
    "gebiet": 1
  },
  {
    "plz": "28759",
    "gebiet": 1
  },
  {
    "plz": "28777",
    "gebiet": 1
  },
  {
    "plz": "28779",
    "gebiet": 1
  },
  {
    "plz": "28790",
    "gebiet": 1
  },
  {
    "plz": "28816",
    "gebiet": 1
  },
  {
    "plz": "28832",
    "gebiet": 1
  },
  {
    "plz": "28844",
    "gebiet": 1
  },
  {
    "plz": "28857",
    "gebiet": 1
  },
  {
    "plz": "28865",
    "gebiet": 1
  },
  {
    "plz": "28870",
    "gebiet": 1
  },
  {
    "plz": "28879",
    "gebiet": 1
  },
  {
    "plz": "29221",
    "gebiet": 2
  },
  {
    "plz": "29225",
    "gebiet": 2
  },
  {
    "plz": "29227",
    "gebiet": 2
  },
  {
    "plz": "29308",
    "gebiet": 2
  },
  {
    "plz": "29320",
    "gebiet": 1
  },
  {
    "plz": "29323",
    "gebiet": 2
  },
  {
    "plz": "29328",
    "gebiet": 1
  },
  {
    "plz": "29331",
    "gebiet": 2
  },
  {
    "plz": "29336",
    "gebiet": 2
  },
  {
    "plz": "29348",
    "gebiet": 1
  },
  {
    "plz": "29359",
    "gebiet": 2
  },
  {
    "plz": "29392",
    "gebiet": 2
  },
  {
    "plz": "29393",
    "gebiet": 2
  },
  {
    "plz": "29410",
    "gebiet": 1
  },
  {
    "plz": "29439",
    "gebiet": 1
  },
  {
    "plz": "29456",
    "gebiet": 1
  },
  {
    "plz": "29459",
    "gebiet": 1
  },
  {
    "plz": "29482",
    "gebiet": 1
  },
  {
    "plz": "29525",
    "gebiet": 1
  },
  {
    "plz": "29574",
    "gebiet": 1
  },
  {
    "plz": "29579",
    "gebiet": 1
  },
  {
    "plz": "29590",
    "gebiet": 1
  },
  {
    "plz": "29614",
    "gebiet": 1
  },
  {
    "plz": "29633",
    "gebiet": 1
  },
  {
    "plz": "29640",
    "gebiet": 1
  },
  {
    "plz": "29664",
    "gebiet": 1
  },
  {
    "plz": "29690",
    "gebiet": 2
  },
  {
    "plz": "30159",
    "gebiet": 2
  },
  {
    "plz": "30161",
    "gebiet": 2
  },
  {
    "plz": "30163",
    "gebiet": 2
  },
  {
    "plz": "30169",
    "gebiet": 2
  },
  {
    "plz": "30171",
    "gebiet": 2
  },
  {
    "plz": "30173",
    "gebiet": 2
  },
  {
    "plz": "30175",
    "gebiet": 2
  },
  {
    "plz": "30177",
    "gebiet": 2
  },
  {
    "plz": "30179",
    "gebiet": 2
  },
  {
    "plz": "30453",
    "gebiet": 2
  },
  {
    "plz": "30457",
    "gebiet": 2
  },
  {
    "plz": "30459",
    "gebiet": 2
  },
  {
    "plz": "30519",
    "gebiet": 2
  },
  {
    "plz": "30539",
    "gebiet": 2
  },
  {
    "plz": "30559",
    "gebiet": 2
  },
  {
    "plz": "30601",
    "gebiet": 2
  },
  {
    "plz": "30627",
    "gebiet": 2
  },
  {
    "plz": "30629",
    "gebiet": 2
  },
  {
    "plz": "30631",
    "gebiet": 2
  },
  {
    "plz": "30634",
    "gebiet": 2
  },
  {
    "plz": "30655",
    "gebiet": 2
  },
  {
    "plz": "30657",
    "gebiet": 2
  },
  {
    "plz": "30659",
    "gebiet": 2
  },
  {
    "plz": "30823",
    "gebiet": 2
  },
  {
    "plz": "30826",
    "gebiet": 2
  },
  {
    "plz": "30827",
    "gebiet": 2
  },
  {
    "plz": "30851",
    "gebiet": 2
  },
  {
    "plz": "30853",
    "gebiet": 2
  },
  {
    "plz": "30855",
    "gebiet": 2
  },
  {
    "plz": "30880",
    "gebiet": 2
  },
  {
    "plz": "30890",
    "gebiet": 2
  },
  {
    "plz": "30900",
    "gebiet": 2
  },
  {
    "plz": "30903",
    "gebiet": 2
  },
  {
    "plz": "30916",
    "gebiet": 2
  },
  {
    "plz": "30938",
    "gebiet": 2
  },
  {
    "plz": "30952",
    "gebiet": 2
  },
  {
    "plz": "30966",
    "gebiet": 2
  },
  {
    "plz": "30974",
    "gebiet": 2
  },
  {
    "plz": "30982",
    "gebiet": 2
  },
  {
    "plz": "30989",
    "gebiet": 2
  },
  {
    "plz": "31008",
    "gebiet": 2
  },
  {
    "plz": "31020",
    "gebiet": 2
  },
  {
    "plz": "31028",
    "gebiet": 2
  },
  {
    "plz": "31061",
    "gebiet": 2
  },
  {
    "plz": "31079",
    "gebiet": 2
  },
  {
    "plz": "31134",
    "gebiet": 2
  },
  {
    "plz": "31137",
    "gebiet": 2
  },
  {
    "plz": "31139",
    "gebiet": 2
  },
  {
    "plz": "31157",
    "gebiet": 2
  },
  {
    "plz": "31162",
    "gebiet": 2
  },
  {
    "plz": "31171",
    "gebiet": 2
  },
  {
    "plz": "31174",
    "gebiet": 2
  },
  {
    "plz": "31177",
    "gebiet": 2
  },
  {
    "plz": "31180",
    "gebiet": 2
  },
  {
    "plz": "31188",
    "gebiet": 2
  },
  {
    "plz": "31195",
    "gebiet": 2
  },
  {
    "plz": "31224",
    "gebiet": 2
  },
  {
    "plz": "31226",
    "gebiet": 2
  },
  {
    "plz": "31228",
    "gebiet": 2
  },
  {
    "plz": "31275",
    "gebiet": 2
  },
  {
    "plz": "31303",
    "gebiet": 2
  },
  {
    "plz": "31311",
    "gebiet": 2
  },
  {
    "plz": "31319",
    "gebiet": 2
  },
  {
    "plz": "31515",
    "gebiet": 2
  },
  {
    "plz": "31535",
    "gebiet": 2
  },
  {
    "plz": "31542",
    "gebiet": 2
  },
  {
    "plz": "31552",
    "gebiet": 2
  },
  {
    "plz": "31559",
    "gebiet": 2
  },
  {
    "plz": "31582",
    "gebiet": 2
  },
  {
    "plz": "31595",
    "gebiet": 2
  },
  {
    "plz": "31600",
    "gebiet": 2
  },
  {
    "plz": "31606",
    "gebiet": 2
  },
  {
    "plz": "31608",
    "gebiet": 2
  },
  {
    "plz": "31626",
    "gebiet": 2
  },
  {
    "plz": "31634",
    "gebiet": 2
  },
  {
    "plz": "31655",
    "gebiet": 2
  },
  {
    "plz": "31675",
    "gebiet": 2
  },
  {
    "plz": "31683",
    "gebiet": 2
  },
  {
    "plz": "31688",
    "gebiet": 2
  },
  {
    "plz": "31693",
    "gebiet": 2
  },
  {
    "plz": "31698",
    "gebiet": 2
  },
  {
    "plz": "31712",
    "gebiet": 2
  },
  {
    "plz": "31737",
    "gebiet": 2
  },
  {
    "plz": "31749",
    "gebiet": 2
  },
  {
    "plz": "31762",
    "gebiet": 2
  },
  {
    "plz": "31785",
    "gebiet": 2
  },
  {
    "plz": "31787",
    "gebiet": 2
  },
  {
    "plz": "31789",
    "gebiet": 2
  },
  {
    "plz": "31812",
    "gebiet": 2
  },
  {
    "plz": "31832",
    "gebiet": 2
  },
  {
    "plz": "31848",
    "gebiet": 2
  },
  {
    "plz": "31855",
    "gebiet": 2
  },
  {
    "plz": "31860",
    "gebiet": 2
  },
  {
    "plz": "32049",
    "gebiet": 2
  },
  {
    "plz": "32051",
    "gebiet": 2
  },
  {
    "plz": "32052",
    "gebiet": 2
  },
  {
    "plz": "32105",
    "gebiet": 2
  },
  {
    "plz": "32107",
    "gebiet": 2
  },
  {
    "plz": "32120",
    "gebiet": 2
  },
  {
    "plz": "32130",
    "gebiet": 2
  },
  {
    "plz": "32139",
    "gebiet": 2
  },
  {
    "plz": "32257",
    "gebiet": 2
  },
  {
    "plz": "32278",
    "gebiet": 2
  },
  {
    "plz": "32289",
    "gebiet": 2
  },
  {
    "plz": "32312",
    "gebiet": 2
  },
  {
    "plz": "32339",
    "gebiet": 2
  },
  {
    "plz": "32346",
    "gebiet": 2
  },
  {
    "plz": "32351",
    "gebiet": 2
  },
  {
    "plz": "32361",
    "gebiet": 2
  },
  {
    "plz": "32423",
    "gebiet": 2
  },
  {
    "plz": "32425",
    "gebiet": 2
  },
  {
    "plz": "32427",
    "gebiet": 2
  },
  {
    "plz": "32429",
    "gebiet": 2
  },
  {
    "plz": "32457",
    "gebiet": 2
  },
  {
    "plz": "32479",
    "gebiet": 2
  },
  {
    "plz": "32545",
    "gebiet": 2
  },
  {
    "plz": "32547",
    "gebiet": 2
  },
  {
    "plz": "32549",
    "gebiet": 2
  },
  {
    "plz": "32557",
    "gebiet": 2
  },
  {
    "plz": "32584",
    "gebiet": 2
  },
  {
    "plz": "32602",
    "gebiet": 2
  },
  {
    "plz": "32609",
    "gebiet": 2
  },
  {
    "plz": "32657",
    "gebiet": 2
  },
  {
    "plz": "32676",
    "gebiet": 2
  },
  {
    "plz": "32689",
    "gebiet": 2
  },
  {
    "plz": "32694",
    "gebiet": 2
  },
  {
    "plz": "32699",
    "gebiet": 2
  },
  {
    "plz": "32756",
    "gebiet": 2
  },
  {
    "plz": "32758",
    "gebiet": 2
  },
  {
    "plz": "32791",
    "gebiet": 2
  },
  {
    "plz": "32805",
    "gebiet": 2
  },
  {
    "plz": "32816",
    "gebiet": 2
  },
  {
    "plz": "32825",
    "gebiet": 2
  },
  {
    "plz": "32839",
    "gebiet": 2
  },
  {
    "plz": "33014",
    "gebiet": 2
  },
  {
    "plz": "33034",
    "gebiet": 2
  },
  {
    "plz": "33098",
    "gebiet": 2
  },
  {
    "plz": "33100",
    "gebiet": 2
  },
  {
    "plz": "33102",
    "gebiet": 2
  },
  {
    "plz": "33104",
    "gebiet": 2
  },
  {
    "plz": "33106",
    "gebiet": 2
  },
  {
    "plz": "33129",
    "gebiet": 2
  },
  {
    "plz": "33142",
    "gebiet": 2
  },
  {
    "plz": "33154",
    "gebiet": 2
  },
  {
    "plz": "33161",
    "gebiet": 2
  },
  {
    "plz": "33165",
    "gebiet": 2
  },
  {
    "plz": "33175",
    "gebiet": 2
  },
  {
    "plz": "33178",
    "gebiet": 2
  },
  {
    "plz": "33184",
    "gebiet": 2
  },
  {
    "plz": "33189",
    "gebiet": 2
  },
  {
    "plz": "33330",
    "gebiet": 2
  },
  {
    "plz": "33332",
    "gebiet": 2
  },
  {
    "plz": "33334",
    "gebiet": 2
  },
  {
    "plz": "33335",
    "gebiet": 2
  },
  {
    "plz": "33378",
    "gebiet": 2
  },
  {
    "plz": "33397",
    "gebiet": 2
  },
  {
    "plz": "33415",
    "gebiet": 2
  },
  {
    "plz": "33428",
    "gebiet": 2
  },
  {
    "plz": "33429",
    "gebiet": 2
  },
  {
    "plz": "33442",
    "gebiet": 2
  },
  {
    "plz": "33449",
    "gebiet": 2
  },
  {
    "plz": "33525",
    "gebiet": 2
  },
  {
    "plz": "33527",
    "gebiet": 2
  },
  {
    "plz": "33602",
    "gebiet": 2
  },
  {
    "plz": "33604",
    "gebiet": 2
  },
  {
    "plz": "33605",
    "gebiet": 2
  },
  {
    "plz": "33607",
    "gebiet": 2
  },
  {
    "plz": "33609",
    "gebiet": 2
  },
  {
    "plz": "33611",
    "gebiet": 2
  },
  {
    "plz": "33613",
    "gebiet": 2
  },
  {
    "plz": "33615",
    "gebiet": 2
  },
  {
    "plz": "33619",
    "gebiet": 2
  },
  {
    "plz": "33647",
    "gebiet": 2
  },
  {
    "plz": "33649",
    "gebiet": 2
  },
  {
    "plz": "33689",
    "gebiet": 2
  },
  {
    "plz": "33699",
    "gebiet": 2
  },
  {
    "plz": "33719",
    "gebiet": 2
  },
  {
    "plz": "33729",
    "gebiet": 2
  },
  {
    "plz": "33739",
    "gebiet": 2
  },
  {
    "plz": "33758",
    "gebiet": 2
  },
  {
    "plz": "33775",
    "gebiet": 2
  },
  {
    "plz": "33790",
    "gebiet": 2
  },
  {
    "plz": "33803",
    "gebiet": 2
  },
  {
    "plz": "33813",
    "gebiet": 2
  },
  {
    "plz": "33818",
    "gebiet": 2
  },
  {
    "plz": "33824",
    "gebiet": 2
  },
  {
    "plz": "33829",
    "gebiet": 2
  },
  {
    "plz": "34031",
    "gebiet": 2
  },
  {
    "plz": "34059",
    "gebiet": 2
  },
  {
    "plz": "34117",
    "gebiet": 5
  },
  {
    "plz": "34119",
    "gebiet": 5
  },
  {
    "plz": "34121",
    "gebiet": 5
  },
  {
    "plz": "34123",
    "gebiet": 5
  },
  {
    "plz": "34125",
    "gebiet": 5
  },
  {
    "plz": "34127",
    "gebiet": 5
  },
  {
    "plz": "34128",
    "gebiet": 5
  },
  {
    "plz": "34131",
    "gebiet": 5
  },
  {
    "plz": "34132",
    "gebiet": 5
  },
  {
    "plz": "34134",
    "gebiet": 5
  },
  {
    "plz": "34212",
    "gebiet": 5
  },
  {
    "plz": "34218",
    "gebiet": 5
  },
  {
    "plz": "34225",
    "gebiet": 5
  },
  {
    "plz": "34233",
    "gebiet": 5
  },
  {
    "plz": "34238",
    "gebiet": 5
  },
  {
    "plz": "34246",
    "gebiet": 5
  },
  {
    "plz": "34253",
    "gebiet": 5
  },
  {
    "plz": "34266",
    "gebiet": 5
  },
  {
    "plz": "34270",
    "gebiet": 5
  },
  {
    "plz": "34277",
    "gebiet": 5
  },
  {
    "plz": "34281",
    "gebiet": 5
  },
  {
    "plz": "34305",
    "gebiet": 5
  },
  {
    "plz": "34308",
    "gebiet": 5
  },
  {
    "plz": "34311",
    "gebiet": 5
  },
  {
    "plz": "34314",
    "gebiet": 5
  },
  {
    "plz": "34317",
    "gebiet": 5
  },
  {
    "plz": "34323",
    "gebiet": 5
  },
  {
    "plz": "34326",
    "gebiet": 5
  },
  {
    "plz": "34327",
    "gebiet": 5
  },
  {
    "plz": "34346",
    "gebiet": 5
  },
  {
    "plz": "34369",
    "gebiet": 5
  },
  {
    "plz": "34376",
    "gebiet": 5
  },
  {
    "plz": "34388",
    "gebiet": 2
  },
  {
    "plz": "34396",
    "gebiet": 5
  },
  {
    "plz": "34414",
    "gebiet": 5
  },
  {
    "plz": "34431",
    "gebiet": 5
  },
  {
    "plz": "34454",
    "gebiet": 5
  },
  {
    "plz": "34466",
    "gebiet": 5
  },
  {
    "plz": "34471",
    "gebiet": 5
  },
  {
    "plz": "34479",
    "gebiet": 5
  },
  {
    "plz": "34497",
    "gebiet": 5
  },
  {
    "plz": "34537",
    "gebiet": 5
  },
  {
    "plz": "34560",
    "gebiet": 5
  },
  {
    "plz": "34576",
    "gebiet": 5
  },
  {
    "plz": "34582",
    "gebiet": 5
  },
  {
    "plz": "34596",
    "gebiet": 5
  },
  {
    "plz": "34599",
    "gebiet": 5
  },
  {
    "plz": "34613",
    "gebiet": 5
  },
  {
    "plz": "34621",
    "gebiet": 5
  },
  {
    "plz": "34630",
    "gebiet": 5
  },
  {
    "plz": "34633",
    "gebiet": 5
  },
  {
    "plz": "35037",
    "gebiet": 5
  },
  {
    "plz": "35039",
    "gebiet": 5
  },
  {
    "plz": "35041",
    "gebiet": 5
  },
  {
    "plz": "35043",
    "gebiet": 5
  },
  {
    "plz": "35066",
    "gebiet": 5
  },
  {
    "plz": "35075",
    "gebiet": 5
  },
  {
    "plz": "35080",
    "gebiet": 5
  },
  {
    "plz": "35085",
    "gebiet": 5
  },
  {
    "plz": "35088",
    "gebiet": 5
  },
  {
    "plz": "35102",
    "gebiet": 5
  },
  {
    "plz": "35114",
    "gebiet": 5
  },
  {
    "plz": "35117",
    "gebiet": 5
  },
  {
    "plz": "35216",
    "gebiet": 5
  },
  {
    "plz": "35232",
    "gebiet": 5
  },
  {
    "plz": "35236",
    "gebiet": 5
  },
  {
    "plz": "35260",
    "gebiet": 5
  },
  {
    "plz": "35274",
    "gebiet": 5
  },
  {
    "plz": "35287",
    "gebiet": 5
  },
  {
    "plz": "35305",
    "gebiet": 5
  },
  {
    "plz": "35315",
    "gebiet": 5
  },
  {
    "plz": "35321",
    "gebiet": 6
  },
  {
    "plz": "35329",
    "gebiet": 5
  },
  {
    "plz": "35390",
    "gebiet": 5
  },
  {
    "plz": "35394",
    "gebiet": 5
  },
  {
    "plz": "35396",
    "gebiet": 5
  },
  {
    "plz": "35398",
    "gebiet": 5
  },
  {
    "plz": "35410",
    "gebiet": 6
  },
  {
    "plz": "35415",
    "gebiet": 6
  },
  {
    "plz": "35418",
    "gebiet": 6
  },
  {
    "plz": "35423",
    "gebiet": 6
  },
  {
    "plz": "35435",
    "gebiet": 5
  },
  {
    "plz": "35440",
    "gebiet": 6
  },
  {
    "plz": "35444",
    "gebiet": 5
  },
  {
    "plz": "35452",
    "gebiet": 6
  },
  {
    "plz": "35466",
    "gebiet": 5
  },
  {
    "plz": "35469",
    "gebiet": 5
  },
  {
    "plz": "35510",
    "gebiet": 6
  },
  {
    "plz": "35516",
    "gebiet": 6
  },
  {
    "plz": "35519",
    "gebiet": 6
  },
  {
    "plz": "35578",
    "gebiet": 6
  },
  {
    "plz": "35581",
    "gebiet": 6
  },
  {
    "plz": "35584",
    "gebiet": 6
  },
  {
    "plz": "35606",
    "gebiet": 6
  },
  {
    "plz": "35614",
    "gebiet": 6
  },
  {
    "plz": "35619",
    "gebiet": 6
  },
  {
    "plz": "35625",
    "gebiet": 6
  },
  {
    "plz": "35630",
    "gebiet": 6
  },
  {
    "plz": "35633",
    "gebiet": 6
  },
  {
    "plz": "35638",
    "gebiet": 6
  },
  {
    "plz": "35644",
    "gebiet": 5
  },
  {
    "plz": "35647",
    "gebiet": 6
  },
  {
    "plz": "35683",
    "gebiet": 5
  },
  {
    "plz": "35690",
    "gebiet": 5
  },
  {
    "plz": "35708",
    "gebiet": 5
  },
  {
    "plz": "35713",
    "gebiet": 5
  },
  {
    "plz": "35716",
    "gebiet": 5
  },
  {
    "plz": "35745",
    "gebiet": 5
  },
  {
    "plz": "35753",
    "gebiet": 6
  },
  {
    "plz": "35759",
    "gebiet": 6
  },
  {
    "plz": "35764",
    "gebiet": 6
  },
  {
    "plz": "35767",
    "gebiet": 5
  },
  {
    "plz": "35781",
    "gebiet": 6
  },
  {
    "plz": "35789",
    "gebiet": 6
  },
  {
    "plz": "35792",
    "gebiet": 6
  },
  {
    "plz": "35794",
    "gebiet": 6
  },
  {
    "plz": "36001",
    "gebiet": 6
  },
  {
    "plz": "36037",
    "gebiet": 5
  },
  {
    "plz": "36039",
    "gebiet": 5
  },
  {
    "plz": "36041",
    "gebiet": 5
  },
  {
    "plz": "36043",
    "gebiet": 5
  },
  {
    "plz": "36088",
    "gebiet": 5
  },
  {
    "plz": "36093",
    "gebiet": 5
  },
  {
    "plz": "36100",
    "gebiet": 5
  },
  {
    "plz": "36103",
    "gebiet": 5
  },
  {
    "plz": "36110",
    "gebiet": 5
  },
  {
    "plz": "36115",
    "gebiet": 5
  },
  {
    "plz": "36119",
    "gebiet": 5
  },
  {
    "plz": "36124",
    "gebiet": 5
  },
  {
    "plz": "36137",
    "gebiet": 5
  },
  {
    "plz": "36142",
    "gebiet": 5
  },
  {
    "plz": "36145",
    "gebiet": 5
  },
  {
    "plz": "36148",
    "gebiet": 5
  },
  {
    "plz": "36154",
    "gebiet": 5
  },
  {
    "plz": "36163",
    "gebiet": 5
  },
  {
    "plz": "36179",
    "gebiet": 5
  },
  {
    "plz": "36199",
    "gebiet": 5
  },
  {
    "plz": "36217",
    "gebiet": 5
  },
  {
    "plz": "36219",
    "gebiet": 5
  },
  {
    "plz": "36251",
    "gebiet": 5
  },
  {
    "plz": "36277",
    "gebiet": 5
  },
  {
    "plz": "36289",
    "gebiet": 5
  },
  {
    "plz": "36304",
    "gebiet": 5
  },
  {
    "plz": "36318",
    "gebiet": 5
  },
  {
    "plz": "36320",
    "gebiet": 5
  },
  {
    "plz": "36341",
    "gebiet": 5
  },
  {
    "plz": "36367",
    "gebiet": 5
  },
  {
    "plz": "36381",
    "gebiet": 5
  },
  {
    "plz": "36391",
    "gebiet": 5
  },
  {
    "plz": "36396",
    "gebiet": 5
  },
  {
    "plz": "36399",
    "gebiet": 5
  },
  {
    "plz": "36404",
    "gebiet": 5
  },
  {
    "plz": "36419",
    "gebiet": 5
  },
  {
    "plz": "36422",
    "gebiet": 5
  },
  {
    "plz": "36433",
    "gebiet": 5
  },
  {
    "plz": "36448",
    "gebiet": 5
  },
  {
    "plz": "36456",
    "gebiet": 5
  },
  {
    "plz": "36469",
    "gebiet": 5
  },
  {
    "plz": "37073",
    "gebiet": 5
  },
  {
    "plz": "37075",
    "gebiet": 5
  },
  {
    "plz": "37077",
    "gebiet": 5
  },
  {
    "plz": "37079",
    "gebiet": 5
  },
  {
    "plz": "37081",
    "gebiet": 5
  },
  {
    "plz": "37083",
    "gebiet": 5
  },
  {
    "plz": "37085",
    "gebiet": 5
  },
  {
    "plz": "37115",
    "gebiet": 5
  },
  {
    "plz": "37120",
    "gebiet": 5
  },
  {
    "plz": "37127",
    "gebiet": 5
  },
  {
    "plz": "37130",
    "gebiet": 5
  },
  {
    "plz": "37133",
    "gebiet": 5
  },
  {
    "plz": "37136",
    "gebiet": 5
  },
  {
    "plz": "37139",
    "gebiet": 5
  },
  {
    "plz": "37154",
    "gebiet": 5
  },
  {
    "plz": "37170",
    "gebiet": 2
  },
  {
    "plz": "37176",
    "gebiet": 5
  },
  {
    "plz": "37181",
    "gebiet": 5
  },
  {
    "plz": "37197",
    "gebiet": 5
  },
  {
    "plz": "37213",
    "gebiet": 5
  },
  {
    "plz": "37217",
    "gebiet": 5
  },
  {
    "plz": "37218",
    "gebiet": 5
  },
  {
    "plz": "37242",
    "gebiet": 5
  },
  {
    "plz": "37249",
    "gebiet": 5
  },
  {
    "plz": "37269",
    "gebiet": 5
  },
  {
    "plz": "37276",
    "gebiet": 5
  },
  {
    "plz": "37284",
    "gebiet": 5
  },
  {
    "plz": "37287",
    "gebiet": 5
  },
  {
    "plz": "37293",
    "gebiet": 5
  },
  {
    "plz": "37308",
    "gebiet": 5
  },
  {
    "plz": "37318",
    "gebiet": 5
  },
  {
    "plz": "37327",
    "gebiet": 5
  },
  {
    "plz": "37339",
    "gebiet": 5
  },
  {
    "plz": "37359",
    "gebiet": 5
  },
  {
    "plz": "37412",
    "gebiet": 5
  },
  {
    "plz": "37431",
    "gebiet": 5
  },
  {
    "plz": "37434",
    "gebiet": 5
  },
  {
    "plz": "37520",
    "gebiet": 5
  },
  {
    "plz": "37539",
    "gebiet": 5
  },
  {
    "plz": "37574",
    "gebiet": 5
  },
  {
    "plz": "37581",
    "gebiet": 5
  },
  {
    "plz": "37603",
    "gebiet": 2
  },
  {
    "plz": "37627",
    "gebiet": 2
  },
  {
    "plz": "37632",
    "gebiet": 2
  },
  {
    "plz": "37647",
    "gebiet": 2
  },
  {
    "plz": "37671",
    "gebiet": 2
  },
  {
    "plz": "37688",
    "gebiet": 2
  },
  {
    "plz": "37696",
    "gebiet": 2
  },
  {
    "plz": "38100",
    "gebiet": 2
  },
  {
    "plz": "38102",
    "gebiet": 2
  },
  {
    "plz": "38104",
    "gebiet": 2
  },
  {
    "plz": "38106",
    "gebiet": 2
  },
  {
    "plz": "38108",
    "gebiet": 2
  },
  {
    "plz": "38110",
    "gebiet": 2
  },
  {
    "plz": "38114",
    "gebiet": 2
  },
  {
    "plz": "38116",
    "gebiet": 2
  },
  {
    "plz": "38118",
    "gebiet": 2
  },
  {
    "plz": "38120",
    "gebiet": 2
  },
  {
    "plz": "38124",
    "gebiet": 2
  },
  {
    "plz": "38154",
    "gebiet": 2
  },
  {
    "plz": "38159",
    "gebiet": 2
  },
  {
    "plz": "38162",
    "gebiet": 2
  },
  {
    "plz": "38165",
    "gebiet": 2
  },
  {
    "plz": "38174",
    "gebiet": 2
  },
  {
    "plz": "38176",
    "gebiet": 2
  },
  {
    "plz": "38179",
    "gebiet": 2
  },
  {
    "plz": "38226",
    "gebiet": 2
  },
  {
    "plz": "38229",
    "gebiet": 2
  },
  {
    "plz": "38239",
    "gebiet": 2
  },
  {
    "plz": "38245",
    "gebiet": 2
  },
  {
    "plz": "38259",
    "gebiet": 2
  },
  {
    "plz": "38268",
    "gebiet": 2
  },
  {
    "plz": "38272",
    "gebiet": 2
  },
  {
    "plz": "38300",
    "gebiet": 2
  },
  {
    "plz": "38302",
    "gebiet": 2
  },
  {
    "plz": "38304",
    "gebiet": 2
  },
  {
    "plz": "38364",
    "gebiet": 2
  },
  {
    "plz": "38440",
    "gebiet": 2
  },
  {
    "plz": "38442",
    "gebiet": 2
  },
  {
    "plz": "38448",
    "gebiet": 2
  },
  {
    "plz": "38468",
    "gebiet": 2
  },
  {
    "plz": "38477",
    "gebiet": 2
  },
  {
    "plz": "38518",
    "gebiet": 2
  },
  {
    "plz": "38542",
    "gebiet": 2
  },
  {
    "plz": "38550",
    "gebiet": 2
  },
  {
    "plz": "38557",
    "gebiet": 2
  },
  {
    "plz": "38640",
    "gebiet": 5
  },
  {
    "plz": "38642",
    "gebiet": 5
  },
  {
    "plz": "38644",
    "gebiet": 5
  },
  {
    "plz": "38667",
    "gebiet": 5
  },
  {
    "plz": "38685",
    "gebiet": 5
  },
  {
    "plz": "38690",
    "gebiet": 5
  },
  {
    "plz": "38704",
    "gebiet": 5
  },
  {
    "plz": "38723",
    "gebiet": 5
  },
  {
    "plz": "38729",
    "gebiet": 5
  },
  {
    "plz": "38820",
    "gebiet": 5
  },
  {
    "plz": "38838",
    "gebiet": 5
  },
  {
    "plz": "38855",
    "gebiet": 5
  },
  {
    "plz": "38871",
    "gebiet": 5
  },
  {
    "plz": "38879",
    "gebiet": 5
  },
  {
    "plz": "38889",
    "gebiet": 5
  },
  {
    "plz": "38895",
    "gebiet": 5
  },
  {
    "plz": "38899",
    "gebiet": 5
  },
  {
    "plz": "39104",
    "gebiet": 3
  },
  {
    "plz": "39108",
    "gebiet": 3
  },
  {
    "plz": "39110",
    "gebiet": 3
  },
  {
    "plz": "39112",
    "gebiet": 3
  },
  {
    "plz": "39114",
    "gebiet": 3
  },
  {
    "plz": "39116",
    "gebiet": 3
  },
  {
    "plz": "39118",
    "gebiet": 3
  },
  {
    "plz": "39120",
    "gebiet": 3
  },
  {
    "plz": "39122",
    "gebiet": 3
  },
  {
    "plz": "39124",
    "gebiet": 3
  },
  {
    "plz": "39128",
    "gebiet": 3
  },
  {
    "plz": "39130",
    "gebiet": 3
  },
  {
    "plz": "39164",
    "gebiet": 3
  },
  {
    "plz": "39167",
    "gebiet": 3
  },
  {
    "plz": "39171",
    "gebiet": 3
  },
  {
    "plz": "39175",
    "gebiet": 3
  },
  {
    "plz": "39179",
    "gebiet": 3
  },
  {
    "plz": "39217",
    "gebiet": 3
  },
  {
    "plz": "39218",
    "gebiet": 3
  },
  {
    "plz": "39221",
    "gebiet": 3
  },
  {
    "plz": "39240",
    "gebiet": 3
  },
  {
    "plz": "39245",
    "gebiet": 3
  },
  {
    "plz": "39249",
    "gebiet": 3
  },
  {
    "plz": "39261",
    "gebiet": 3
  },
  {
    "plz": "39264",
    "gebiet": 3
  },
  {
    "plz": "39288",
    "gebiet": 3
  },
  {
    "plz": "39291",
    "gebiet": 3
  },
  {
    "plz": "39307",
    "gebiet": 3
  },
  {
    "plz": "39317",
    "gebiet": 3
  },
  {
    "plz": "39326",
    "gebiet": 3
  },
  {
    "plz": "39340",
    "gebiet": 3
  },
  {
    "plz": "39387",
    "gebiet": 3
  },
  {
    "plz": "39397",
    "gebiet": 3
  },
  {
    "plz": "39418",
    "gebiet": 3
  },
  {
    "plz": "39439",
    "gebiet": 3
  },
  {
    "plz": "39443",
    "gebiet": 3
  },
  {
    "plz": "39517",
    "gebiet": 3
  },
  {
    "plz": "39576",
    "gebiet": 3
  },
  {
    "plz": "39579",
    "gebiet": 3
  },
  {
    "plz": "39606",
    "gebiet": 3
  },
  {
    "plz": "39638",
    "gebiet": 3
  },
  {
    "plz": "40017",
    "gebiet": 4
  },
  {
    "plz": "40031",
    "gebiet": 4
  },
  {
    "plz": "40101",
    "gebiet": 4
  },
  {
    "plz": "40110",
    "gebiet": 4
  },
  {
    "plz": "40210",
    "gebiet": 4
  },
  {
    "plz": "40211",
    "gebiet": 4
  },
  {
    "plz": "40212",
    "gebiet": 4
  },
  {
    "plz": "40213",
    "gebiet": 4
  },
  {
    "plz": "40215",
    "gebiet": 4
  },
  {
    "plz": "40217",
    "gebiet": 4
  },
  {
    "plz": "40221",
    "gebiet": 4
  },
  {
    "plz": "40223",
    "gebiet": 4
  },
  {
    "plz": "40227",
    "gebiet": 4
  },
  {
    "plz": "40229",
    "gebiet": 4
  },
  {
    "plz": "40231",
    "gebiet": 4
  },
  {
    "plz": "40233",
    "gebiet": 4
  },
  {
    "plz": "40235",
    "gebiet": 4
  },
  {
    "plz": "40237",
    "gebiet": 4
  },
  {
    "plz": "40239",
    "gebiet": 4
  },
  {
    "plz": "40402",
    "gebiet": 4
  },
  {
    "plz": "40434",
    "gebiet": 4
  },
  {
    "plz": "40437",
    "gebiet": 4
  },
  {
    "plz": "40468",
    "gebiet": 4
  },
  {
    "plz": "40470",
    "gebiet": 4
  },
  {
    "plz": "40472",
    "gebiet": 4
  },
  {
    "plz": "40474",
    "gebiet": 4
  },
  {
    "plz": "40476",
    "gebiet": 4
  },
  {
    "plz": "40477",
    "gebiet": 4
  },
  {
    "plz": "40479",
    "gebiet": 4
  },
  {
    "plz": "40489",
    "gebiet": 4
  },
  {
    "plz": "40508",
    "gebiet": 4
  },
  {
    "plz": "40545",
    "gebiet": 4
  },
  {
    "plz": "40547",
    "gebiet": 4
  },
  {
    "plz": "40549",
    "gebiet": 4
  },
  {
    "plz": "40589",
    "gebiet": 4
  },
  {
    "plz": "40591",
    "gebiet": 4
  },
  {
    "plz": "40595",
    "gebiet": 4
  },
  {
    "plz": "40597",
    "gebiet": 4
  },
  {
    "plz": "40599",
    "gebiet": 4
  },
  {
    "plz": "40625",
    "gebiet": 4
  },
  {
    "plz": "40627",
    "gebiet": 4
  },
  {
    "plz": "40629",
    "gebiet": 4
  },
  {
    "plz": "40667",
    "gebiet": 4
  },
  {
    "plz": "40668",
    "gebiet": 4
  },
  {
    "plz": "40670",
    "gebiet": 4
  },
  {
    "plz": "40699",
    "gebiet": 4
  },
  {
    "plz": "40721",
    "gebiet": 4
  },
  {
    "plz": "40723",
    "gebiet": 4
  },
  {
    "plz": "40724",
    "gebiet": 4
  },
  {
    "plz": "40764",
    "gebiet": 4
  },
  {
    "plz": "40789",
    "gebiet": 4
  },
  {
    "plz": "40822",
    "gebiet": 4
  },
  {
    "plz": "40878",
    "gebiet": 4
  },
  {
    "plz": "40880",
    "gebiet": 4
  },
  {
    "plz": "40883",
    "gebiet": 4
  },
  {
    "plz": "40885",
    "gebiet": 4
  },
  {
    "plz": "41061",
    "gebiet": 4
  },
  {
    "plz": "41063",
    "gebiet": 4
  },
  {
    "plz": "41065",
    "gebiet": 4
  },
  {
    "plz": "41066",
    "gebiet": 4
  },
  {
    "plz": "41068",
    "gebiet": 4
  },
  {
    "plz": "41169",
    "gebiet": 4
  },
  {
    "plz": "41179",
    "gebiet": 4
  },
  {
    "plz": "41189",
    "gebiet": 4
  },
  {
    "plz": "41199",
    "gebiet": 4
  },
  {
    "plz": "41236",
    "gebiet": 4
  },
  {
    "plz": "41238",
    "gebiet": 4
  },
  {
    "plz": "41334",
    "gebiet": 4
  },
  {
    "plz": "41352",
    "gebiet": 4
  },
  {
    "plz": "41363",
    "gebiet": 4
  },
  {
    "plz": "41366",
    "gebiet": 4
  },
  {
    "plz": "41372",
    "gebiet": 4
  },
  {
    "plz": "41379",
    "gebiet": 4
  },
  {
    "plz": "41460",
    "gebiet": 4
  },
  {
    "plz": "41462",
    "gebiet": 4
  },
  {
    "plz": "41464",
    "gebiet": 4
  },
  {
    "plz": "41466",
    "gebiet": 4
  },
  {
    "plz": "41468",
    "gebiet": 4
  },
  {
    "plz": "41469",
    "gebiet": 4
  },
  {
    "plz": "41470",
    "gebiet": 4
  },
  {
    "plz": "41472",
    "gebiet": 4
  },
  {
    "plz": "41515",
    "gebiet": 4
  },
  {
    "plz": "41516",
    "gebiet": 4
  },
  {
    "plz": "41539",
    "gebiet": 4
  },
  {
    "plz": "41540",
    "gebiet": 4
  },
  {
    "plz": "41541",
    "gebiet": 4
  },
  {
    "plz": "41542",
    "gebiet": 4
  },
  {
    "plz": "41564",
    "gebiet": 4
  },
  {
    "plz": "41702",
    "gebiet": 4
  },
  {
    "plz": "41719",
    "gebiet": 4
  },
  {
    "plz": "41725",
    "gebiet": 4
  },
  {
    "plz": "41747",
    "gebiet": 4
  },
  {
    "plz": "41751",
    "gebiet": 4
  },
  {
    "plz": "41812",
    "gebiet": 4
  },
  {
    "plz": "41836",
    "gebiet": 4
  },
  {
    "plz": "41844",
    "gebiet": 4
  },
  {
    "plz": "41849",
    "gebiet": 4
  },
  {
    "plz": "42103",
    "gebiet": 4
  },
  {
    "plz": "42109",
    "gebiet": 4
  },
  {
    "plz": "42111",
    "gebiet": 4
  },
  {
    "plz": "42113",
    "gebiet": 4
  },
  {
    "plz": "42115",
    "gebiet": 4
  },
  {
    "plz": "42117",
    "gebiet": 4
  },
  {
    "plz": "42119",
    "gebiet": 4
  },
  {
    "plz": "42219",
    "gebiet": 4
  },
  {
    "plz": "42243",
    "gebiet": 4
  },
  {
    "plz": "42275",
    "gebiet": 4
  },
  {
    "plz": "42277",
    "gebiet": 4
  },
  {
    "plz": "42279",
    "gebiet": 4
  },
  {
    "plz": "42281",
    "gebiet": 4
  },
  {
    "plz": "42283",
    "gebiet": 4
  },
  {
    "plz": "42285",
    "gebiet": 4
  },
  {
    "plz": "42289",
    "gebiet": 4
  },
  {
    "plz": "42327",
    "gebiet": 4
  },
  {
    "plz": "42329",
    "gebiet": 4
  },
  {
    "plz": "42332",
    "gebiet": 4
  },
  {
    "plz": "42349",
    "gebiet": 4
  },
  {
    "plz": "42369",
    "gebiet": 4
  },
  {
    "plz": "42389",
    "gebiet": 4
  },
  {
    "plz": "42477",
    "gebiet": 4
  },
  {
    "plz": "42489",
    "gebiet": 4
  },
  {
    "plz": "42499",
    "gebiet": 4
  },
  {
    "plz": "42520",
    "gebiet": 4
  },
  {
    "plz": "42549",
    "gebiet": 4
  },
  {
    "plz": "42551",
    "gebiet": 4
  },
  {
    "plz": "42555",
    "gebiet": 4
  },
  {
    "plz": "42579",
    "gebiet": 4
  },
  {
    "plz": "42631",
    "gebiet": 4
  },
  {
    "plz": "42653",
    "gebiet": 4
  },
  {
    "plz": "42657",
    "gebiet": 4
  },
  {
    "plz": "42659",
    "gebiet": 4
  },
  {
    "plz": "42697",
    "gebiet": 4
  },
  {
    "plz": "42699",
    "gebiet": 4
  },
  {
    "plz": "42781",
    "gebiet": 4
  },
  {
    "plz": "42799",
    "gebiet": 4
  },
  {
    "plz": "42853",
    "gebiet": 4
  },
  {
    "plz": "42857",
    "gebiet": 4
  },
  {
    "plz": "42859",
    "gebiet": 4
  },
  {
    "plz": "42897",
    "gebiet": 4
  },
  {
    "plz": "42929",
    "gebiet": 4
  },
  {
    "plz": "44135",
    "gebiet": 2
  },
  {
    "plz": "44137",
    "gebiet": 2
  },
  {
    "plz": "44139",
    "gebiet": 4
  },
  {
    "plz": "44141",
    "gebiet": 4
  },
  {
    "plz": "44143",
    "gebiet": 2
  },
  {
    "plz": "44149",
    "gebiet": 2
  },
  {
    "plz": "44225",
    "gebiet": 4
  },
  {
    "plz": "44227",
    "gebiet": 4
  },
  {
    "plz": "44229",
    "gebiet": 4
  },
  {
    "plz": "44241",
    "gebiet": 4
  },
  {
    "plz": "44263",
    "gebiet": 4
  },
  {
    "plz": "44265",
    "gebiet": 4
  },
  {
    "plz": "44267",
    "gebiet": 4
  },
  {
    "plz": "44269",
    "gebiet": 4
  },
  {
    "plz": "44287",
    "gebiet": 4
  },
  {
    "plz": "44289",
    "gebiet": 4
  },
  {
    "plz": "44319",
    "gebiet": 2
  },
  {
    "plz": "44328",
    "gebiet": 2
  },
  {
    "plz": "44329",
    "gebiet": 2
  },
  {
    "plz": "44339",
    "gebiet": 2
  },
  {
    "plz": "44359",
    "gebiet": 2
  },
  {
    "plz": "44361",
    "gebiet": 2
  },
  {
    "plz": "44369",
    "gebiet": 2
  },
  {
    "plz": "44379",
    "gebiet": 2
  },
  {
    "plz": "44388",
    "gebiet": 2
  },
  {
    "plz": "44532",
    "gebiet": 2
  },
  {
    "plz": "44536",
    "gebiet": 2
  },
  {
    "plz": "44575",
    "gebiet": 2
  },
  {
    "plz": "44577",
    "gebiet": 2
  },
  {
    "plz": "44579",
    "gebiet": 2
  },
  {
    "plz": "44623",
    "gebiet": 2
  },
  {
    "plz": "44625",
    "gebiet": 2
  },
  {
    "plz": "44627",
    "gebiet": 2
  },
  {
    "plz": "44628",
    "gebiet": 2
  },
  {
    "plz": "44629",
    "gebiet": 2
  },
  {
    "plz": "44649",
    "gebiet": 2
  },
  {
    "plz": "44651",
    "gebiet": 2
  },
  {
    "plz": "44652",
    "gebiet": 2
  },
  {
    "plz": "44787",
    "gebiet": 2
  },
  {
    "plz": "44789",
    "gebiet": 2
  },
  {
    "plz": "44791",
    "gebiet": 2
  },
  {
    "plz": "44793",
    "gebiet": 2
  },
  {
    "plz": "44795",
    "gebiet": 4
  },
  {
    "plz": "44797",
    "gebiet": 4
  },
  {
    "plz": "44799",
    "gebiet": 4
  },
  {
    "plz": "44801",
    "gebiet": 4
  },
  {
    "plz": "44803",
    "gebiet": 2
  },
  {
    "plz": "44805",
    "gebiet": 2
  },
  {
    "plz": "44866",
    "gebiet": 2
  },
  {
    "plz": "44867",
    "gebiet": 4
  },
  {
    "plz": "44869",
    "gebiet": 4
  },
  {
    "plz": "44879",
    "gebiet": 4
  },
  {
    "plz": "44892",
    "gebiet": 4
  },
  {
    "plz": "44894",
    "gebiet": 2
  },
  {
    "plz": "45127",
    "gebiet": 2
  },
  {
    "plz": "45128",
    "gebiet": 4
  },
  {
    "plz": "45130",
    "gebiet": 4
  },
  {
    "plz": "45131",
    "gebiet": 4
  },
  {
    "plz": "45133",
    "gebiet": 4
  },
  {
    "plz": "45134",
    "gebiet": 4
  },
  {
    "plz": "45136",
    "gebiet": 4
  },
  {
    "plz": "45138",
    "gebiet": 4
  },
  {
    "plz": "45139",
    "gebiet": 4
  },
  {
    "plz": "45141",
    "gebiet": 2
  },
  {
    "plz": "45143",
    "gebiet": 2
  },
  {
    "plz": "45145",
    "gebiet": 4
  },
  {
    "plz": "45147",
    "gebiet": 4
  },
  {
    "plz": "45219",
    "gebiet": 4
  },
  {
    "plz": "45239",
    "gebiet": 4
  },
  {
    "plz": "45257",
    "gebiet": 4
  },
  {
    "plz": "45259",
    "gebiet": 4
  },
  {
    "plz": "45276",
    "gebiet": 4
  },
  {
    "plz": "45277",
    "gebiet": 4
  },
  {
    "plz": "45279",
    "gebiet": 4
  },
  {
    "plz": "45289",
    "gebiet": 4
  },
  {
    "plz": "45307",
    "gebiet": 2
  },
  {
    "plz": "45309",
    "gebiet": 2
  },
  {
    "plz": "45326",
    "gebiet": 2
  },
  {
    "plz": "45327",
    "gebiet": 2
  },
  {
    "plz": "45329",
    "gebiet": 2
  },
  {
    "plz": "45355",
    "gebiet": 2
  },
  {
    "plz": "45356",
    "gebiet": 2
  },
  {
    "plz": "45357",
    "gebiet": 2
  },
  {
    "plz": "45359",
    "gebiet": 2
  },
  {
    "plz": "45409",
    "gebiet": 2
  },
  {
    "plz": "45468",
    "gebiet": 4
  },
  {
    "plz": "45472",
    "gebiet": 4
  },
  {
    "plz": "45473",
    "gebiet": 4
  },
  {
    "plz": "45475",
    "gebiet": 2
  },
  {
    "plz": "45478",
    "gebiet": 4
  },
  {
    "plz": "45481",
    "gebiet": 4
  },
  {
    "plz": "45525",
    "gebiet": 4
  },
  {
    "plz": "45527",
    "gebiet": 4
  },
  {
    "plz": "45529",
    "gebiet": 4
  },
  {
    "plz": "45549",
    "gebiet": 4
  },
  {
    "plz": "45657",
    "gebiet": 2
  },
  {
    "plz": "45659",
    "gebiet": 2
  },
  {
    "plz": "45661",
    "gebiet": 2
  },
  {
    "plz": "45663",
    "gebiet": 2
  },
  {
    "plz": "45665",
    "gebiet": 2
  },
  {
    "plz": "45699",
    "gebiet": 2
  },
  {
    "plz": "45711",
    "gebiet": 2
  },
  {
    "plz": "45721",
    "gebiet": 2
  },
  {
    "plz": "45731",
    "gebiet": 2
  },
  {
    "plz": "45733",
    "gebiet": 2
  },
  {
    "plz": "45739",
    "gebiet": 2
  },
  {
    "plz": "45760",
    "gebiet": 2
  },
  {
    "plz": "45768",
    "gebiet": 2
  },
  {
    "plz": "45770",
    "gebiet": 2
  },
  {
    "plz": "45772",
    "gebiet": 2
  },
  {
    "plz": "45879",
    "gebiet": 2
  },
  {
    "plz": "45881",
    "gebiet": 2
  },
  {
    "plz": "45884",
    "gebiet": 2
  },
  {
    "plz": "45886",
    "gebiet": 2
  },
  {
    "plz": "45888",
    "gebiet": 2
  },
  {
    "plz": "45891",
    "gebiet": 2
  },
  {
    "plz": "45892",
    "gebiet": 2
  },
  {
    "plz": "45894",
    "gebiet": 2
  },
  {
    "plz": "45896",
    "gebiet": 2
  },
  {
    "plz": "45897",
    "gebiet": 2
  },
  {
    "plz": "45899",
    "gebiet": 2
  },
  {
    "plz": "45964",
    "gebiet": 2
  },
  {
    "plz": "45966",
    "gebiet": 2
  },
  {
    "plz": "45968",
    "gebiet": 2
  },
  {
    "plz": "46045",
    "gebiet": 2
  },
  {
    "plz": "46047",
    "gebiet": 2
  },
  {
    "plz": "46049",
    "gebiet": 2
  },
  {
    "plz": "46117",
    "gebiet": 2
  },
  {
    "plz": "46119",
    "gebiet": 2
  },
  {
    "plz": "46145",
    "gebiet": 2
  },
  {
    "plz": "46147",
    "gebiet": 2
  },
  {
    "plz": "46149",
    "gebiet": 2
  },
  {
    "plz": "46236",
    "gebiet": 2
  },
  {
    "plz": "46238",
    "gebiet": 2
  },
  {
    "plz": "46240",
    "gebiet": 2
  },
  {
    "plz": "46242",
    "gebiet": 2
  },
  {
    "plz": "46282",
    "gebiet": 2
  },
  {
    "plz": "46284",
    "gebiet": 2
  },
  {
    "plz": "46286",
    "gebiet": 2
  },
  {
    "plz": "46325",
    "gebiet": 2
  },
  {
    "plz": "46342",
    "gebiet": 2
  },
  {
    "plz": "46348",
    "gebiet": 2
  },
  {
    "plz": "46395",
    "gebiet": 2
  },
  {
    "plz": "46399",
    "gebiet": 2
  },
  {
    "plz": "46414",
    "gebiet": 2
  },
  {
    "plz": "46419",
    "gebiet": 2
  },
  {
    "plz": "46446",
    "gebiet": 2
  },
  {
    "plz": "46459",
    "gebiet": 2
  },
  {
    "plz": "46483",
    "gebiet": 2
  },
  {
    "plz": "46485",
    "gebiet": 2
  },
  {
    "plz": "46487",
    "gebiet": 2
  },
  {
    "plz": "46499",
    "gebiet": 2
  },
  {
    "plz": "46509",
    "gebiet": 2
  },
  {
    "plz": "46519",
    "gebiet": 2
  },
  {
    "plz": "46535",
    "gebiet": 2
  },
  {
    "plz": "46537",
    "gebiet": 2
  },
  {
    "plz": "46539",
    "gebiet": 2
  },
  {
    "plz": "46562",
    "gebiet": 2
  },
  {
    "plz": "46569",
    "gebiet": 2
  },
  {
    "plz": "47051",
    "gebiet": 4
  },
  {
    "plz": "47053",
    "gebiet": 4
  },
  {
    "plz": "47055",
    "gebiet": 4
  },
  {
    "plz": "47057",
    "gebiet": 4
  },
  {
    "plz": "47058",
    "gebiet": 4
  },
  {
    "plz": "47059",
    "gebiet": 4
  },
  {
    "plz": "47119",
    "gebiet": 4
  },
  {
    "plz": "47121",
    "gebiet": 4
  },
  {
    "plz": "47137",
    "gebiet": 2
  },
  {
    "plz": "47138",
    "gebiet": 2
  },
  {
    "plz": "47167",
    "gebiet": 2
  },
  {
    "plz": "47169",
    "gebiet": 2
  },
  {
    "plz": "47178",
    "gebiet": 2
  },
  {
    "plz": "47198",
    "gebiet": 4
  },
  {
    "plz": "47199",
    "gebiet": 2
  },
  {
    "plz": "47226",
    "gebiet": 4
  },
  {
    "plz": "47228",
    "gebiet": 4
  },
  {
    "plz": "47239",
    "gebiet": 4
  },
  {
    "plz": "47249",
    "gebiet": 4
  },
  {
    "plz": "47259",
    "gebiet": 4
  },
  {
    "plz": "47269",
    "gebiet": 4
  },
  {
    "plz": "47279",
    "gebiet": 4
  },
  {
    "plz": "47441",
    "gebiet": 4
  },
  {
    "plz": "47443",
    "gebiet": 4
  },
  {
    "plz": "47445",
    "gebiet": 4
  },
  {
    "plz": "47447",
    "gebiet": 4
  },
  {
    "plz": "47475",
    "gebiet": 2
  },
  {
    "plz": "47495",
    "gebiet": 2
  },
  {
    "plz": "47506",
    "gebiet": 4
  },
  {
    "plz": "47533",
    "gebiet": 4
  },
  {
    "plz": "47546",
    "gebiet": 4
  },
  {
    "plz": "47551",
    "gebiet": 2
  },
  {
    "plz": "47559",
    "gebiet": 2
  },
  {
    "plz": "47574",
    "gebiet": 2
  },
  {
    "plz": "47589",
    "gebiet": 4
  },
  {
    "plz": "47608",
    "gebiet": 4
  },
  {
    "plz": "47623",
    "gebiet": 2
  },
  {
    "plz": "47624",
    "gebiet": 2
  },
  {
    "plz": "47625",
    "gebiet": 2
  },
  {
    "plz": "47626",
    "gebiet": 2
  },
  {
    "plz": "47638",
    "gebiet": 2
  },
  {
    "plz": "47647",
    "gebiet": 2
  },
  {
    "plz": "47661",
    "gebiet": 2
  },
  {
    "plz": "47665",
    "gebiet": 2
  },
  {
    "plz": "47669",
    "gebiet": 4
  },
  {
    "plz": "47718",
    "gebiet": 4
  },
  {
    "plz": "47798",
    "gebiet": 4
  },
  {
    "plz": "47799",
    "gebiet": 4
  },
  {
    "plz": "47800",
    "gebiet": 4
  },
  {
    "plz": "47802",
    "gebiet": 4
  },
  {
    "plz": "47803",
    "gebiet": 4
  },
  {
    "plz": "47804",
    "gebiet": 4
  },
  {
    "plz": "47805",
    "gebiet": 4
  },
  {
    "plz": "47807",
    "gebiet": 4
  },
  {
    "plz": "47809",
    "gebiet": 4
  },
  {
    "plz": "47829",
    "gebiet": 4
  },
  {
    "plz": "47839",
    "gebiet": 4
  },
  {
    "plz": "47862",
    "gebiet": 4
  },
  {
    "plz": "47877",
    "gebiet": 4
  },
  {
    "plz": "47906",
    "gebiet": 4
  },
  {
    "plz": "47918",
    "gebiet": 4
  },
  {
    "plz": "47929",
    "gebiet": 4
  },
  {
    "plz": "48001",
    "gebiet": 2
  },
  {
    "plz": "48078",
    "gebiet": 2
  },
  {
    "plz": "48143",
    "gebiet": 2
  },
  {
    "plz": "48145",
    "gebiet": 2
  },
  {
    "plz": "48147",
    "gebiet": 2
  },
  {
    "plz": "48149",
    "gebiet": 2
  },
  {
    "plz": "48151",
    "gebiet": 2
  },
  {
    "plz": "48153",
    "gebiet": 2
  },
  {
    "plz": "48155",
    "gebiet": 2
  },
  {
    "plz": "48157",
    "gebiet": 2
  },
  {
    "plz": "48159",
    "gebiet": 2
  },
  {
    "plz": "48161",
    "gebiet": 2
  },
  {
    "plz": "48163",
    "gebiet": 2
  },
  {
    "plz": "48165",
    "gebiet": 2
  },
  {
    "plz": "48167",
    "gebiet": 2
  },
  {
    "plz": "48205",
    "gebiet": 2
  },
  {
    "plz": "48231",
    "gebiet": 2
  },
  {
    "plz": "48249",
    "gebiet": 2
  },
  {
    "plz": "48268",
    "gebiet": 2
  },
  {
    "plz": "48282",
    "gebiet": 2
  },
  {
    "plz": "48291",
    "gebiet": 2
  },
  {
    "plz": "48301",
    "gebiet": 2
  },
  {
    "plz": "48317",
    "gebiet": 2
  },
  {
    "plz": "48329",
    "gebiet": 2
  },
  {
    "plz": "48336",
    "gebiet": 2
  },
  {
    "plz": "48341",
    "gebiet": 2
  },
  {
    "plz": "48356",
    "gebiet": 2
  },
  {
    "plz": "48361",
    "gebiet": 2
  },
  {
    "plz": "48366",
    "gebiet": 2
  },
  {
    "plz": "48429",
    "gebiet": 2
  },
  {
    "plz": "48431",
    "gebiet": 2
  },
  {
    "plz": "48455",
    "gebiet": 2
  },
  {
    "plz": "48465",
    "gebiet": 2
  },
  {
    "plz": "48480",
    "gebiet": 2
  },
  {
    "plz": "48488",
    "gebiet": 2
  },
  {
    "plz": "48493",
    "gebiet": 2
  },
  {
    "plz": "48527",
    "gebiet": 2
  },
  {
    "plz": "48529",
    "gebiet": 2
  },
  {
    "plz": "48531",
    "gebiet": 2
  },
  {
    "plz": "48565",
    "gebiet": 2
  },
  {
    "plz": "48599",
    "gebiet": 2
  },
  {
    "plz": "48607",
    "gebiet": 2
  },
  {
    "plz": "48629",
    "gebiet": 2
  },
  {
    "plz": "48653",
    "gebiet": 2
  },
  {
    "plz": "48683",
    "gebiet": 2
  },
  {
    "plz": "48691",
    "gebiet": 2
  },
  {
    "plz": "48703",
    "gebiet": 2
  },
  {
    "plz": "48712",
    "gebiet": 2
  },
  {
    "plz": "48727",
    "gebiet": 2
  },
  {
    "plz": "48734",
    "gebiet": 2
  },
  {
    "plz": "49074",
    "gebiet": 2
  },
  {
    "plz": "49076",
    "gebiet": 2
  },
  {
    "plz": "49078",
    "gebiet": 2
  },
  {
    "plz": "49080",
    "gebiet": 2
  },
  {
    "plz": "49082",
    "gebiet": 2
  },
  {
    "plz": "49084",
    "gebiet": 2
  },
  {
    "plz": "49086",
    "gebiet": 2
  },
  {
    "plz": "49088",
    "gebiet": 2
  },
  {
    "plz": "49090",
    "gebiet": 2
  },
  {
    "plz": "49124",
    "gebiet": 2
  },
  {
    "plz": "49134",
    "gebiet": 2
  },
  {
    "plz": "49143",
    "gebiet": 2
  },
  {
    "plz": "49152",
    "gebiet": 2
  },
  {
    "plz": "49170",
    "gebiet": 2
  },
  {
    "plz": "49171",
    "gebiet": 2
  },
  {
    "plz": "49176",
    "gebiet": 2
  },
  {
    "plz": "49186",
    "gebiet": 2
  },
  {
    "plz": "49201",
    "gebiet": 2
  },
  {
    "plz": "49205",
    "gebiet": 2
  },
  {
    "plz": "49214",
    "gebiet": 2
  },
  {
    "plz": "49324",
    "gebiet": 2
  },
  {
    "plz": "49328",
    "gebiet": 2
  },
  {
    "plz": "49356",
    "gebiet": 2
  },
  {
    "plz": "49377",
    "gebiet": 2
  },
  {
    "plz": "49393",
    "gebiet": 2
  },
  {
    "plz": "49401",
    "gebiet": 2
  },
  {
    "plz": "49406",
    "gebiet": 2
  },
  {
    "plz": "49413",
    "gebiet": 2
  },
  {
    "plz": "49424",
    "gebiet": 2
  },
  {
    "plz": "49429",
    "gebiet": 2
  },
  {
    "plz": "49434",
    "gebiet": 2
  },
  {
    "plz": "49448",
    "gebiet": 2
  },
  {
    "plz": "49451",
    "gebiet": 2
  },
  {
    "plz": "49453",
    "gebiet": 2
  },
  {
    "plz": "49477",
    "gebiet": 2
  },
  {
    "plz": "49479",
    "gebiet": 2
  },
  {
    "plz": "49492",
    "gebiet": 2
  },
  {
    "plz": "49497",
    "gebiet": 2
  },
  {
    "plz": "49504",
    "gebiet": 2
  },
  {
    "plz": "49509",
    "gebiet": 2
  },
  {
    "plz": "49525",
    "gebiet": 2
  },
  {
    "plz": "49536",
    "gebiet": 2
  },
  {
    "plz": "49549",
    "gebiet": 2
  },
  {
    "plz": "49565",
    "gebiet": 2
  },
  {
    "plz": "49577",
    "gebiet": 2
  },
  {
    "plz": "49586",
    "gebiet": 2
  },
  {
    "plz": "49593",
    "gebiet": 2
  },
  {
    "plz": "49599",
    "gebiet": 2
  },
  {
    "plz": "49610",
    "gebiet": 2
  },
  {
    "plz": "49624",
    "gebiet": 2
  },
  {
    "plz": "49626",
    "gebiet": 2
  },
  {
    "plz": "49632",
    "gebiet": 2
  },
  {
    "plz": "49635",
    "gebiet": 2
  },
  {
    "plz": "49661",
    "gebiet": 2
  },
  {
    "plz": "49681",
    "gebiet": 2
  },
  {
    "plz": "49685",
    "gebiet": 2
  },
  {
    "plz": "49688",
    "gebiet": 2
  },
  {
    "plz": "49692",
    "gebiet": 2
  },
  {
    "plz": "49693",
    "gebiet": 2
  },
  {
    "plz": "49696",
    "gebiet": 2
  },
  {
    "plz": "49716",
    "gebiet": 2
  },
  {
    "plz": "49733",
    "gebiet": 2
  },
  {
    "plz": "49740",
    "gebiet": 2
  },
  {
    "plz": "49744",
    "gebiet": 2
  },
  {
    "plz": "49751",
    "gebiet": 2
  },
  {
    "plz": "49757",
    "gebiet": 2
  },
  {
    "plz": "49767",
    "gebiet": 2
  },
  {
    "plz": "49808",
    "gebiet": 2
  },
  {
    "plz": "49809",
    "gebiet": 2
  },
  {
    "plz": "49811",
    "gebiet": 2
  },
  {
    "plz": "49820",
    "gebiet": 2
  },
  {
    "plz": "49824",
    "gebiet": 2
  },
  {
    "plz": "49835",
    "gebiet": 2
  },
  {
    "plz": "49847",
    "gebiet": 2
  },
  {
    "plz": "50126",
    "gebiet": 4
  },
  {
    "plz": "50127",
    "gebiet": 4
  },
  {
    "plz": "50129",
    "gebiet": 4
  },
  {
    "plz": "50169",
    "gebiet": 4
  },
  {
    "plz": "50170",
    "gebiet": 4
  },
  {
    "plz": "50171",
    "gebiet": 6
  },
  {
    "plz": "50181",
    "gebiet": 4
  },
  {
    "plz": "50182",
    "gebiet": 4
  },
  {
    "plz": "50189",
    "gebiet": 4
  },
  {
    "plz": "50226",
    "gebiet": 4
  },
  {
    "plz": "50259",
    "gebiet": 4
  },
  {
    "plz": "50321",
    "gebiet": 6
  },
  {
    "plz": "50354",
    "gebiet": 4
  },
  {
    "plz": "50362",
    "gebiet": 4
  },
  {
    "plz": "50374",
    "gebiet": 6
  },
  {
    "plz": "50389",
    "gebiet": 6
  },
  {
    "plz": "50442",
    "gebiet": 4
  },
  {
    "plz": "50500",
    "gebiet": 4
  },
  {
    "plz": "50520",
    "gebiet": 4
  },
  {
    "plz": "50667",
    "gebiet": 4
  },
  {
    "plz": "50668",
    "gebiet": 4
  },
  {
    "plz": "50670",
    "gebiet": 4
  },
  {
    "plz": "50672",
    "gebiet": 4
  },
  {
    "plz": "50674",
    "gebiet": 4
  },
  {
    "plz": "50676",
    "gebiet": 4
  },
  {
    "plz": "50677",
    "gebiet": 4
  },
  {
    "plz": "50678",
    "gebiet": 4
  },
  {
    "plz": "50679",
    "gebiet": 4
  },
  {
    "plz": "50733",
    "gebiet": 4
  },
  {
    "plz": "50735",
    "gebiet": 4
  },
  {
    "plz": "50737",
    "gebiet": 4
  },
  {
    "plz": "50739",
    "gebiet": 4
  },
  {
    "plz": "50756",
    "gebiet": 4
  },
  {
    "plz": "50765",
    "gebiet": 4
  },
  {
    "plz": "50767",
    "gebiet": 4
  },
  {
    "plz": "50795",
    "gebiet": 4
  },
  {
    "plz": "50825",
    "gebiet": 4
  },
  {
    "plz": "50827",
    "gebiet": 4
  },
  {
    "plz": "50829",
    "gebiet": 4
  },
  {
    "plz": "50858",
    "gebiet": 4
  },
  {
    "plz": "50859",
    "gebiet": 4
  },
  {
    "plz": "50931",
    "gebiet": 4
  },
  {
    "plz": "50933",
    "gebiet": 4
  },
  {
    "plz": "50935",
    "gebiet": 4
  },
  {
    "plz": "50937",
    "gebiet": 4
  },
  {
    "plz": "50939",
    "gebiet": 4
  },
  {
    "plz": "50968",
    "gebiet": 4
  },
  {
    "plz": "50969",
    "gebiet": 4
  },
  {
    "plz": "50996",
    "gebiet": 4
  },
  {
    "plz": "50997",
    "gebiet": 4
  },
  {
    "plz": "50999",
    "gebiet": 4
  },
  {
    "plz": "51061",
    "gebiet": 4
  },
  {
    "plz": "51063",
    "gebiet": 4
  },
  {
    "plz": "51065",
    "gebiet": 4
  },
  {
    "plz": "51069",
    "gebiet": 4
  },
  {
    "plz": "51078",
    "gebiet": 4
  },
  {
    "plz": "51105",
    "gebiet": 4
  },
  {
    "plz": "51107",
    "gebiet": 4
  },
  {
    "plz": "51109",
    "gebiet": 4
  },
  {
    "plz": "51145",
    "gebiet": 4
  },
  {
    "plz": "51147",
    "gebiet": 4
  },
  {
    "plz": "51149",
    "gebiet": 4
  },
  {
    "plz": "51371",
    "gebiet": 4
  },
  {
    "plz": "51373",
    "gebiet": 4
  },
  {
    "plz": "51375",
    "gebiet": 4
  },
  {
    "plz": "51377",
    "gebiet": 4
  },
  {
    "plz": "51379",
    "gebiet": 4
  },
  {
    "plz": "51381",
    "gebiet": 4
  },
  {
    "plz": "51399",
    "gebiet": 4
  },
  {
    "plz": "51427",
    "gebiet": 4
  },
  {
    "plz": "51429",
    "gebiet": 4
  },
  {
    "plz": "51467",
    "gebiet": 4
  },
  {
    "plz": "51469",
    "gebiet": 4
  },
  {
    "plz": "51481",
    "gebiet": 4
  },
  {
    "plz": "51491",
    "gebiet": 4
  },
  {
    "plz": "51503",
    "gebiet": 4
  },
  {
    "plz": "51515",
    "gebiet": 4
  },
  {
    "plz": "51519",
    "gebiet": 4
  },
  {
    "plz": "51545",
    "gebiet": 6
  },
  {
    "plz": "51570",
    "gebiet": 6
  },
  {
    "plz": "51580",
    "gebiet": 4
  },
  {
    "plz": "51588",
    "gebiet": 6
  },
  {
    "plz": "51597",
    "gebiet": 6
  },
  {
    "plz": "51645",
    "gebiet": 4
  },
  {
    "plz": "51647",
    "gebiet": 4
  },
  {
    "plz": "51674",
    "gebiet": 4
  },
  {
    "plz": "51702",
    "gebiet": 4
  },
  {
    "plz": "51709",
    "gebiet": 4
  },
  {
    "plz": "51766",
    "gebiet": 4
  },
  {
    "plz": "51789",
    "gebiet": 4
  },
  {
    "plz": "52062",
    "gebiet": 4
  },
  {
    "plz": "52064",
    "gebiet": 4
  },
  {
    "plz": "52066",
    "gebiet": 4
  },
  {
    "plz": "52068",
    "gebiet": 4
  },
  {
    "plz": "52070",
    "gebiet": 4
  },
  {
    "plz": "52072",
    "gebiet": 4
  },
  {
    "plz": "52074",
    "gebiet": 4
  },
  {
    "plz": "52076",
    "gebiet": 4
  },
  {
    "plz": "52078",
    "gebiet": 4
  },
  {
    "plz": "52080",
    "gebiet": 4
  },
  {
    "plz": "52134",
    "gebiet": 4
  },
  {
    "plz": "52146",
    "gebiet": 4
  },
  {
    "plz": "52147",
    "gebiet": 4
  },
  {
    "plz": "52152",
    "gebiet": 6
  },
  {
    "plz": "52156",
    "gebiet": 6
  },
  {
    "plz": "52159",
    "gebiet": 6
  },
  {
    "plz": "52222",
    "gebiet": 4
  },
  {
    "plz": "52223",
    "gebiet": 4
  },
  {
    "plz": "52224",
    "gebiet": 6
  },
  {
    "plz": "52249",
    "gebiet": 4
  },
  {
    "plz": "52315",
    "gebiet": 4
  },
  {
    "plz": "52349",
    "gebiet": 6
  },
  {
    "plz": "52351",
    "gebiet": 6
  },
  {
    "plz": "52353",
    "gebiet": 6
  },
  {
    "plz": "52355",
    "gebiet": 6
  },
  {
    "plz": "52372",
    "gebiet": 6
  },
  {
    "plz": "52379",
    "gebiet": 6
  },
  {
    "plz": "52382",
    "gebiet": 4
  },
  {
    "plz": "52385",
    "gebiet": 6
  },
  {
    "plz": "52388",
    "gebiet": 6
  },
  {
    "plz": "52391",
    "gebiet": 6
  },
  {
    "plz": "52393",
    "gebiet": 6
  },
  {
    "plz": "52428",
    "gebiet": 4
  },
  {
    "plz": "52441",
    "gebiet": 4
  },
  {
    "plz": "52445",
    "gebiet": 4
  },
  {
    "plz": "52457",
    "gebiet": 4
  },
  {
    "plz": "52459",
    "gebiet": 6
  },
  {
    "plz": "52477",
    "gebiet": 4
  },
  {
    "plz": "52499",
    "gebiet": 4
  },
  {
    "plz": "52511",
    "gebiet": 4
  },
  {
    "plz": "52525",
    "gebiet": 4
  },
  {
    "plz": "52531",
    "gebiet": 4
  },
  {
    "plz": "52538",
    "gebiet": 4
  },
  {
    "plz": "53027",
    "gebiet": 4
  },
  {
    "plz": "53111",
    "gebiet": 6
  },
  {
    "plz": "53113",
    "gebiet": 6
  },
  {
    "plz": "53115",
    "gebiet": 6
  },
  {
    "plz": "53117",
    "gebiet": 6
  },
  {
    "plz": "53119",
    "gebiet": 6
  },
  {
    "plz": "53121",
    "gebiet": 6
  },
  {
    "plz": "53123",
    "gebiet": 6
  },
  {
    "plz": "53125",
    "gebiet": 6
  },
  {
    "plz": "53127",
    "gebiet": 6
  },
  {
    "plz": "53129",
    "gebiet": 6
  },
  {
    "plz": "53143",
    "gebiet": 6
  },
  {
    "plz": "53173",
    "gebiet": 6
  },
  {
    "plz": "53175",
    "gebiet": 6
  },
  {
    "plz": "53177",
    "gebiet": 6
  },
  {
    "plz": "53179",
    "gebiet": 6
  },
  {
    "plz": "53225",
    "gebiet": 6
  },
  {
    "plz": "53227",
    "gebiet": 6
  },
  {
    "plz": "53229",
    "gebiet": 6
  },
  {
    "plz": "53332",
    "gebiet": 6
  },
  {
    "plz": "53333",
    "gebiet": 6
  },
  {
    "plz": "53340",
    "gebiet": 6
  },
  {
    "plz": "53343",
    "gebiet": 6
  },
  {
    "plz": "53359",
    "gebiet": 6
  },
  {
    "plz": "53424",
    "gebiet": 6
  },
  {
    "plz": "53426",
    "gebiet": 6
  },
  {
    "plz": "53474",
    "gebiet": 6
  },
  {
    "plz": "53489",
    "gebiet": 6
  },
  {
    "plz": "53501",
    "gebiet": 6
  },
  {
    "plz": "53506",
    "gebiet": 6
  },
  {
    "plz": "53547",
    "gebiet": 6
  },
  {
    "plz": "53560",
    "gebiet": 6
  },
  {
    "plz": "53567",
    "gebiet": 6
  },
  {
    "plz": "53572",
    "gebiet": 6
  },
  {
    "plz": "53578",
    "gebiet": 6
  },
  {
    "plz": "53604",
    "gebiet": 6
  },
  {
    "plz": "53619",
    "gebiet": 6
  },
  {
    "plz": "53639",
    "gebiet": 6
  },
  {
    "plz": "53721",
    "gebiet": 6
  },
  {
    "plz": "53757",
    "gebiet": 6
  },
  {
    "plz": "53773",
    "gebiet": 6
  },
  {
    "plz": "53783",
    "gebiet": 6
  },
  {
    "plz": "53797",
    "gebiet": 6
  },
  {
    "plz": "53804",
    "gebiet": 6
  },
  {
    "plz": "53819",
    "gebiet": 6
  },
  {
    "plz": "53822",
    "gebiet": 6
  },
  {
    "plz": "53832",
    "gebiet": 6
  },
  {
    "plz": "53840",
    "gebiet": 6
  },
  {
    "plz": "53842",
    "gebiet": 6
  },
  {
    "plz": "53844",
    "gebiet": 6
  },
  {
    "plz": "53859",
    "gebiet": 6
  },
  {
    "plz": "53879",
    "gebiet": 6
  },
  {
    "plz": "53881",
    "gebiet": 6
  },
  {
    "plz": "53886",
    "gebiet": 6
  },
  {
    "plz": "53894",
    "gebiet": 6
  },
  {
    "plz": "53902",
    "gebiet": 6
  },
  {
    "plz": "53909",
    "gebiet": 6
  },
  {
    "plz": "53919",
    "gebiet": 6
  },
  {
    "plz": "53925",
    "gebiet": 6
  },
  {
    "plz": "53937",
    "gebiet": 6
  },
  {
    "plz": "53940",
    "gebiet": 6
  },
  {
    "plz": "53945",
    "gebiet": 6
  },
  {
    "plz": "53947",
    "gebiet": 6
  },
  {
    "plz": "54221",
    "gebiet": 6
  },
  {
    "plz": "54290",
    "gebiet": 6
  },
  {
    "plz": "54292",
    "gebiet": 6
  },
  {
    "plz": "54294",
    "gebiet": 6
  },
  {
    "plz": "54295",
    "gebiet": 6
  },
  {
    "plz": "54296",
    "gebiet": 6
  },
  {
    "plz": "54311",
    "gebiet": 6
  },
  {
    "plz": "54314",
    "gebiet": 6
  },
  {
    "plz": "54317",
    "gebiet": 6
  },
  {
    "plz": "54329",
    "gebiet": 6
  },
  {
    "plz": "54338",
    "gebiet": 6
  },
  {
    "plz": "54340",
    "gebiet": 6
  },
  {
    "plz": "54343",
    "gebiet": 6
  },
  {
    "plz": "54346",
    "gebiet": 6
  },
  {
    "plz": "54411",
    "gebiet": 6
  },
  {
    "plz": "54441",
    "gebiet": 6
  },
  {
    "plz": "54459",
    "gebiet": 6
  },
  {
    "plz": "54472",
    "gebiet": 6
  },
  {
    "plz": "54516",
    "gebiet": 6
  },
  {
    "plz": "54534",
    "gebiet": 6
  },
  {
    "plz": "54538",
    "gebiet": 6
  },
  {
    "plz": "54550",
    "gebiet": 6
  },
  {
    "plz": "54552",
    "gebiet": 6
  },
  {
    "plz": "54578",
    "gebiet": 6
  },
  {
    "plz": "54595",
    "gebiet": 6
  },
  {
    "plz": "54597",
    "gebiet": 6
  },
  {
    "plz": "54612",
    "gebiet": 6
  },
  {
    "plz": "54628",
    "gebiet": 6
  },
  {
    "plz": "54634",
    "gebiet": 6
  },
  {
    "plz": "54636",
    "gebiet": 6
  },
  {
    "plz": "54649",
    "gebiet": 6
  },
  {
    "plz": "54655",
    "gebiet": 6
  },
  {
    "plz": "54668",
    "gebiet": 6
  },
  {
    "plz": "55052",
    "gebiet": 6
  },
  {
    "plz": "55116",
    "gebiet": 6
  },
  {
    "plz": "55118",
    "gebiet": 6
  },
  {
    "plz": "55120",
    "gebiet": 6
  },
  {
    "plz": "55122",
    "gebiet": 6
  },
  {
    "plz": "55124",
    "gebiet": 6
  },
  {
    "plz": "55126",
    "gebiet": 6
  },
  {
    "plz": "55127",
    "gebiet": 6
  },
  {
    "plz": "55128",
    "gebiet": 6
  },
  {
    "plz": "55129",
    "gebiet": 6
  },
  {
    "plz": "55130",
    "gebiet": 6
  },
  {
    "plz": "55131",
    "gebiet": 6
  },
  {
    "plz": "55218",
    "gebiet": 6
  },
  {
    "plz": "55232",
    "gebiet": 6
  },
  {
    "plz": "55234",
    "gebiet": 6
  },
  {
    "plz": "55238",
    "gebiet": 6
  },
  {
    "plz": "55246",
    "gebiet": 6
  },
  {
    "plz": "55257",
    "gebiet": 6
  },
  {
    "plz": "55268",
    "gebiet": 6
  },
  {
    "plz": "55270",
    "gebiet": 6
  },
  {
    "plz": "55271",
    "gebiet": 6
  },
  {
    "plz": "55278",
    "gebiet": 6
  },
  {
    "plz": "55283",
    "gebiet": 6
  },
  {
    "plz": "55286",
    "gebiet": 6
  },
  {
    "plz": "55288",
    "gebiet": 6
  },
  {
    "plz": "55291",
    "gebiet": 6
  },
  {
    "plz": "55296",
    "gebiet": 6
  },
  {
    "plz": "55299",
    "gebiet": 6
  },
  {
    "plz": "55411",
    "gebiet": 6
  },
  {
    "plz": "55413",
    "gebiet": 6
  },
  {
    "plz": "55444",
    "gebiet": 6
  },
  {
    "plz": "55450",
    "gebiet": 6
  },
  {
    "plz": "55452",
    "gebiet": 6
  },
  {
    "plz": "55469",
    "gebiet": 6
  },
  {
    "plz": "55471",
    "gebiet": 6
  },
  {
    "plz": "55481",
    "gebiet": 6
  },
  {
    "plz": "55487",
    "gebiet": 6
  },
  {
    "plz": "55543",
    "gebiet": 6
  },
  {
    "plz": "55545",
    "gebiet": 6
  },
  {
    "plz": "55546",
    "gebiet": 6
  },
  {
    "plz": "55559",
    "gebiet": 6
  },
  {
    "plz": "55566",
    "gebiet": 6
  },
  {
    "plz": "55576",
    "gebiet": 6
  },
  {
    "plz": "55578",
    "gebiet": 6
  },
  {
    "plz": "55583",
    "gebiet": 6
  },
  {
    "plz": "55593",
    "gebiet": 6
  },
  {
    "plz": "55595",
    "gebiet": 6
  },
  {
    "plz": "55606",
    "gebiet": 6
  },
  {
    "plz": "55743",
    "gebiet": 6
  },
  {
    "plz": "55758",
    "gebiet": 6
  },
  {
    "plz": "55768",
    "gebiet": 6
  },
  {
    "plz": "56068",
    "gebiet": 6
  },
  {
    "plz": "56070",
    "gebiet": 6
  },
  {
    "plz": "56072",
    "gebiet": 6
  },
  {
    "plz": "56073",
    "gebiet": 6
  },
  {
    "plz": "56076",
    "gebiet": 6
  },
  {
    "plz": "56077",
    "gebiet": 6
  },
  {
    "plz": "56112",
    "gebiet": 6
  },
  {
    "plz": "56130",
    "gebiet": 6
  },
  {
    "plz": "56132",
    "gebiet": 6
  },
  {
    "plz": "56133",
    "gebiet": 6
  },
  {
    "plz": "56179",
    "gebiet": 6
  },
  {
    "plz": "56203",
    "gebiet": 6
  },
  {
    "plz": "56210",
    "gebiet": 6
  },
  {
    "plz": "56218",
    "gebiet": 6
  },
  {
    "plz": "56220",
    "gebiet": 6
  },
  {
    "plz": "56235",
    "gebiet": 6
  },
  {
    "plz": "56237",
    "gebiet": 6
  },
  {
    "plz": "56244",
    "gebiet": 6
  },
  {
    "plz": "56249",
    "gebiet": 6
  },
  {
    "plz": "56264",
    "gebiet": 6
  },
  {
    "plz": "56281",
    "gebiet": 6
  },
  {
    "plz": "56288",
    "gebiet": 6
  },
  {
    "plz": "56291",
    "gebiet": 6
  },
  {
    "plz": "56295",
    "gebiet": 6
  },
  {
    "plz": "56321",
    "gebiet": 6
  },
  {
    "plz": "56322",
    "gebiet": 6
  },
  {
    "plz": "56323",
    "gebiet": 6
  },
  {
    "plz": "56329",
    "gebiet": 6
  },
  {
    "plz": "56332",
    "gebiet": 6
  },
  {
    "plz": "56337",
    "gebiet": 6
  },
  {
    "plz": "56349",
    "gebiet": 6
  },
  {
    "plz": "56355",
    "gebiet": 6
  },
  {
    "plz": "56357",
    "gebiet": 6
  },
  {
    "plz": "56370",
    "gebiet": 6
  },
  {
    "plz": "56377",
    "gebiet": 6
  },
  {
    "plz": "56379",
    "gebiet": 6
  },
  {
    "plz": "56403",
    "gebiet": 6
  },
  {
    "plz": "56410",
    "gebiet": 6
  },
  {
    "plz": "56414",
    "gebiet": 6
  },
  {
    "plz": "56422",
    "gebiet": 6
  },
  {
    "plz": "56457",
    "gebiet": 6
  },
  {
    "plz": "56459",
    "gebiet": 6
  },
  {
    "plz": "56477",
    "gebiet": 6
  },
  {
    "plz": "56479",
    "gebiet": 6
  },
  {
    "plz": "56564",
    "gebiet": 6
  },
  {
    "plz": "56566",
    "gebiet": 6
  },
  {
    "plz": "56567",
    "gebiet": 6
  },
  {
    "plz": "56575",
    "gebiet": 6
  },
  {
    "plz": "56584",
    "gebiet": 6
  },
  {
    "plz": "56587",
    "gebiet": 6
  },
  {
    "plz": "56626",
    "gebiet": 6
  },
  {
    "plz": "56648",
    "gebiet": 6
  },
  {
    "plz": "56727",
    "gebiet": 6
  },
  {
    "plz": "56729",
    "gebiet": 6
  },
  {
    "plz": "56736",
    "gebiet": 6
  },
  {
    "plz": "56743",
    "gebiet": 6
  },
  {
    "plz": "56751",
    "gebiet": 6
  },
  {
    "plz": "56766",
    "gebiet": 6
  },
  {
    "plz": "56812",
    "gebiet": 6
  },
  {
    "plz": "56820",
    "gebiet": 6
  },
  {
    "plz": "56841",
    "gebiet": 6
  },
  {
    "plz": "56843",
    "gebiet": 6
  },
  {
    "plz": "56864",
    "gebiet": 6
  },
  {
    "plz": "56865",
    "gebiet": 6
  },
  {
    "plz": "57072",
    "gebiet": 6
  },
  {
    "plz": "57076",
    "gebiet": 6
  },
  {
    "plz": "57078",
    "gebiet": 6
  },
  {
    "plz": "57080",
    "gebiet": 6
  },
  {
    "plz": "57223",
    "gebiet": 4
  },
  {
    "plz": "57234",
    "gebiet": 5
  },
  {
    "plz": "57250",
    "gebiet": 5
  },
  {
    "plz": "57251",
    "gebiet": 5
  },
  {
    "plz": "57258",
    "gebiet": 6
  },
  {
    "plz": "57271",
    "gebiet": 5
  },
  {
    "plz": "57290",
    "gebiet": 6
  },
  {
    "plz": "57319",
    "gebiet": 5
  },
  {
    "plz": "57334",
    "gebiet": 5
  },
  {
    "plz": "57368",
    "gebiet": 5
  },
  {
    "plz": "57392",
    "gebiet": 5
  },
  {
    "plz": "57399",
    "gebiet": 5
  },
  {
    "plz": "57462",
    "gebiet": 4
  },
  {
    "plz": "57489",
    "gebiet": 4
  },
  {
    "plz": "57518",
    "gebiet": 6
  },
  {
    "plz": "57520",
    "gebiet": 6
  },
  {
    "plz": "57537",
    "gebiet": 6
  },
  {
    "plz": "57548",
    "gebiet": 6
  },
  {
    "plz": "57555",
    "gebiet": 6
  },
  {
    "plz": "57578",
    "gebiet": 6
  },
  {
    "plz": "57583",
    "gebiet": 6
  },
  {
    "plz": "57589",
    "gebiet": 6
  },
  {
    "plz": "57610",
    "gebiet": 6
  },
  {
    "plz": "57627",
    "gebiet": 6
  },
  {
    "plz": "57629",
    "gebiet": 6
  },
  {
    "plz": "57632",
    "gebiet": 6
  },
  {
    "plz": "57635",
    "gebiet": 6
  },
  {
    "plz": "57638",
    "gebiet": 6
  },
  {
    "plz": "57641",
    "gebiet": 6
  },
  {
    "plz": "57647",
    "gebiet": 6
  },
  {
    "plz": "58089",
    "gebiet": 2
  },
  {
    "plz": "58091",
    "gebiet": 2
  },
  {
    "plz": "58093",
    "gebiet": 2
  },
  {
    "plz": "58095",
    "gebiet": 2
  },
  {
    "plz": "58097",
    "gebiet": 2
  },
  {
    "plz": "58099",
    "gebiet": 2
  },
  {
    "plz": "58119",
    "gebiet": 2
  },
  {
    "plz": "58135",
    "gebiet": 2
  },
  {
    "plz": "58239",
    "gebiet": 4
  },
  {
    "plz": "58256",
    "gebiet": 4
  },
  {
    "plz": "58285",
    "gebiet": 4
  },
  {
    "plz": "58300",
    "gebiet": 4
  },
  {
    "plz": "58313",
    "gebiet": 4
  },
  {
    "plz": "58314",
    "gebiet": 4
  },
  {
    "plz": "58332",
    "gebiet": 4
  },
  {
    "plz": "58339",
    "gebiet": 4
  },
  {
    "plz": "58452",
    "gebiet": 4
  },
  {
    "plz": "58453",
    "gebiet": 4
  },
  {
    "plz": "58454",
    "gebiet": 4
  },
  {
    "plz": "58455",
    "gebiet": 4
  },
  {
    "plz": "58456",
    "gebiet": 4
  },
  {
    "plz": "58507",
    "gebiet": 4
  },
  {
    "plz": "58509",
    "gebiet": 4
  },
  {
    "plz": "58511",
    "gebiet": 4
  },
  {
    "plz": "58513",
    "gebiet": 4
  },
  {
    "plz": "58540",
    "gebiet": 4
  },
  {
    "plz": "58553",
    "gebiet": 4
  },
  {
    "plz": "58636",
    "gebiet": 2
  },
  {
    "plz": "58638",
    "gebiet": 2
  },
  {
    "plz": "58640",
    "gebiet": 2
  },
  {
    "plz": "58642",
    "gebiet": 2
  },
  {
    "plz": "58644",
    "gebiet": 2
  },
  {
    "plz": "58675",
    "gebiet": 4
  },
  {
    "plz": "58706",
    "gebiet": 4
  },
  {
    "plz": "58708",
    "gebiet": 4
  },
  {
    "plz": "58710",
    "gebiet": 4
  },
  {
    "plz": "58730",
    "gebiet": 4
  },
  {
    "plz": "58739",
    "gebiet": 4
  },
  {
    "plz": "58762",
    "gebiet": 4
  },
  {
    "plz": "58791",
    "gebiet": 4
  },
  {
    "plz": "58840",
    "gebiet": 4
  },
  {
    "plz": "59063",
    "gebiet": 2
  },
  {
    "plz": "59065",
    "gebiet": 2
  },
  {
    "plz": "59067",
    "gebiet": 2
  },
  {
    "plz": "59069",
    "gebiet": 2
  },
  {
    "plz": "59071",
    "gebiet": 2
  },
  {
    "plz": "59073",
    "gebiet": 2
  },
  {
    "plz": "59075",
    "gebiet": 2
  },
  {
    "plz": "59077",
    "gebiet": 2
  },
  {
    "plz": "59174",
    "gebiet": 2
  },
  {
    "plz": "59192",
    "gebiet": 2
  },
  {
    "plz": "59227",
    "gebiet": 2
  },
  {
    "plz": "59229",
    "gebiet": 2
  },
  {
    "plz": "59269",
    "gebiet": 2
  },
  {
    "plz": "59302",
    "gebiet": 2
  },
  {
    "plz": "59320",
    "gebiet": 2
  },
  {
    "plz": "59329",
    "gebiet": 2
  },
  {
    "plz": "59348",
    "gebiet": 2
  },
  {
    "plz": "59356",
    "gebiet": 2
  },
  {
    "plz": "59368",
    "gebiet": 2
  },
  {
    "plz": "59379",
    "gebiet": 2
  },
  {
    "plz": "59387",
    "gebiet": 2
  },
  {
    "plz": "59394",
    "gebiet": 2
  },
  {
    "plz": "59399",
    "gebiet": 2
  },
  {
    "plz": "59423",
    "gebiet": 2
  },
  {
    "plz": "59425",
    "gebiet": 2
  },
  {
    "plz": "59427",
    "gebiet": 2
  },
  {
    "plz": "59439",
    "gebiet": 4
  },
  {
    "plz": "59457",
    "gebiet": 2
  },
  {
    "plz": "59469",
    "gebiet": 4
  },
  {
    "plz": "59473",
    "gebiet": 4
  },
  {
    "plz": "59494",
    "gebiet": 2
  },
  {
    "plz": "59510",
    "gebiet": 2
  },
  {
    "plz": "59514",
    "gebiet": 2
  },
  {
    "plz": "59555",
    "gebiet": 2
  },
  {
    "plz": "59556",
    "gebiet": 2
  },
  {
    "plz": "59557",
    "gebiet": 2
  },
  {
    "plz": "59558",
    "gebiet": 2
  },
  {
    "plz": "59581",
    "gebiet": 5
  },
  {
    "plz": "59590",
    "gebiet": 2
  },
  {
    "plz": "59602",
    "gebiet": 5
  },
  {
    "plz": "59609",
    "gebiet": 2
  },
  {
    "plz": "59755",
    "gebiet": 2
  },
  {
    "plz": "59757",
    "gebiet": 2
  },
  {
    "plz": "59821",
    "gebiet": 2
  },
  {
    "plz": "59823",
    "gebiet": 2
  },
  {
    "plz": "59846",
    "gebiet": 4
  },
  {
    "plz": "59872",
    "gebiet": 5
  },
  {
    "plz": "59889",
    "gebiet": 5
  },
  {
    "plz": "59909",
    "gebiet": 5
  },
  {
    "plz": "59929",
    "gebiet": 5
  },
  {
    "plz": "59939",
    "gebiet": 5
  },
  {
    "plz": "59955",
    "gebiet": 5
  },
  {
    "plz": "59964",
    "gebiet": 5
  },
  {
    "plz": "60078",
    "gebiet": 5
  },
  {
    "plz": "60084",
    "gebiet": 5
  },
  {
    "plz": "60313",
    "gebiet": 6
  },
  {
    "plz": "60316",
    "gebiet": 6
  },
  {
    "plz": "60318",
    "gebiet": 6
  },
  {
    "plz": "60320",
    "gebiet": 6
  },
  {
    "plz": "60323",
    "gebiet": 6
  },
  {
    "plz": "60325",
    "gebiet": 6
  },
  {
    "plz": "60327",
    "gebiet": 6
  },
  {
    "plz": "60388",
    "gebiet": 6
  },
  {
    "plz": "60389",
    "gebiet": 6
  },
  {
    "plz": "60402",
    "gebiet": 6
  },
  {
    "plz": "60431",
    "gebiet": 6
  },
  {
    "plz": "60433",
    "gebiet": 6
  },
  {
    "plz": "60435",
    "gebiet": 6
  },
  {
    "plz": "60437",
    "gebiet": 6
  },
  {
    "plz": "60439",
    "gebiet": 6
  },
  {
    "plz": "60486",
    "gebiet": 6
  },
  {
    "plz": "60487",
    "gebiet": 6
  },
  {
    "plz": "60489",
    "gebiet": 6
  },
  {
    "plz": "60528",
    "gebiet": 6
  },
  {
    "plz": "60594",
    "gebiet": 6
  },
  {
    "plz": "60596",
    "gebiet": 6
  },
  {
    "plz": "60598",
    "gebiet": 6
  },
  {
    "plz": "60599",
    "gebiet": 6
  },
  {
    "plz": "61118",
    "gebiet": 6
  },
  {
    "plz": "61130",
    "gebiet": 6
  },
  {
    "plz": "61137",
    "gebiet": 6
  },
  {
    "plz": "61138",
    "gebiet": 6
  },
  {
    "plz": "61150",
    "gebiet": 6
  },
  {
    "plz": "61169",
    "gebiet": 6
  },
  {
    "plz": "61184",
    "gebiet": 6
  },
  {
    "plz": "61191",
    "gebiet": 6
  },
  {
    "plz": "61194",
    "gebiet": 6
  },
  {
    "plz": "61197",
    "gebiet": 6
  },
  {
    "plz": "61203",
    "gebiet": 6
  },
  {
    "plz": "61231",
    "gebiet": 6
  },
  {
    "plz": "61250",
    "gebiet": 6
  },
  {
    "plz": "61267",
    "gebiet": 6
  },
  {
    "plz": "61273",
    "gebiet": 6
  },
  {
    "plz": "61348",
    "gebiet": 6
  },
  {
    "plz": "61350",
    "gebiet": 6
  },
  {
    "plz": "61352",
    "gebiet": 6
  },
  {
    "plz": "61381",
    "gebiet": 6
  },
  {
    "plz": "61389",
    "gebiet": 6
  },
  {
    "plz": "61406",
    "gebiet": 6
  },
  {
    "plz": "61440",
    "gebiet": 6
  },
  {
    "plz": "61451",
    "gebiet": 6
  },
  {
    "plz": "61462",
    "gebiet": 6
  },
  {
    "plz": "61476",
    "gebiet": 6
  },
  {
    "plz": "61479",
    "gebiet": 6
  },
  {
    "plz": "63002",
    "gebiet": 6
  },
  {
    "plz": "63065",
    "gebiet": 6
  },
  {
    "plz": "63067",
    "gebiet": 6
  },
  {
    "plz": "63069",
    "gebiet": 6
  },
  {
    "plz": "63071",
    "gebiet": 6
  },
  {
    "plz": "63075",
    "gebiet": 6
  },
  {
    "plz": "63110",
    "gebiet": 6
  },
  {
    "plz": "63128",
    "gebiet": 6
  },
  {
    "plz": "63150",
    "gebiet": 6
  },
  {
    "plz": "63165",
    "gebiet": 6
  },
  {
    "plz": "63179",
    "gebiet": 6
  },
  {
    "plz": "63225",
    "gebiet": 6
  },
  {
    "plz": "63263",
    "gebiet": 6
  },
  {
    "plz": "63303",
    "gebiet": 6
  },
  {
    "plz": "63322",
    "gebiet": 6
  },
  {
    "plz": "63329",
    "gebiet": 6
  },
  {
    "plz": "63450",
    "gebiet": 6
  },
  {
    "plz": "63452",
    "gebiet": 6
  },
  {
    "plz": "63454",
    "gebiet": 6
  },
  {
    "plz": "63456",
    "gebiet": 6
  },
  {
    "plz": "63457",
    "gebiet": 6
  },
  {
    "plz": "63477",
    "gebiet": 6
  },
  {
    "plz": "63486",
    "gebiet": 6
  },
  {
    "plz": "63500",
    "gebiet": 6
  },
  {
    "plz": "63512",
    "gebiet": 6
  },
  {
    "plz": "63517",
    "gebiet": 6
  },
  {
    "plz": "63526",
    "gebiet": 6
  },
  {
    "plz": "63533",
    "gebiet": 6
  },
  {
    "plz": "63546",
    "gebiet": 6
  },
  {
    "plz": "63571",
    "gebiet": 6
  },
  {
    "plz": "63579",
    "gebiet": 6
  },
  {
    "plz": "63584",
    "gebiet": 6
  },
  {
    "plz": "63594",
    "gebiet": 6
  },
  {
    "plz": "63599",
    "gebiet": 6
  },
  {
    "plz": "63607",
    "gebiet": 6
  },
  {
    "plz": "63619",
    "gebiet": 6
  },
  {
    "plz": "63628",
    "gebiet": 6
  },
  {
    "plz": "63654",
    "gebiet": 6
  },
  {
    "plz": "63667",
    "gebiet": 6
  },
  {
    "plz": "63674",
    "gebiet": 6
  },
  {
    "plz": "63683",
    "gebiet": 6
  },
  {
    "plz": "63694",
    "gebiet": 6
  },
  {
    "plz": "63699",
    "gebiet": 6
  },
  {
    "plz": "63739",
    "gebiet": 6
  },
  {
    "plz": "63741",
    "gebiet": 6
  },
  {
    "plz": "63743",
    "gebiet": 6
  },
  {
    "plz": "63755",
    "gebiet": 6
  },
  {
    "plz": "63762",
    "gebiet": 6
  },
  {
    "plz": "63773",
    "gebiet": 6
  },
  {
    "plz": "63776",
    "gebiet": 6
  },
  {
    "plz": "63785",
    "gebiet": 6
  },
  {
    "plz": "63791",
    "gebiet": 6
  },
  {
    "plz": "63796",
    "gebiet": 6
  },
  {
    "plz": "63808",
    "gebiet": 6
  },
  {
    "plz": "63811",
    "gebiet": 6
  },
  {
    "plz": "63812",
    "gebiet": 6
  },
  {
    "plz": "63814",
    "gebiet": 6
  },
  {
    "plz": "63820",
    "gebiet": 6
  },
  {
    "plz": "63825",
    "gebiet": 6
  },
  {
    "plz": "63834",
    "gebiet": 6
  },
  {
    "plz": "63839",
    "gebiet": 6
  },
  {
    "plz": "63843",
    "gebiet": 6
  },
  {
    "plz": "63846",
    "gebiet": 6
  },
  {
    "plz": "63853",
    "gebiet": 6
  },
  {
    "plz": "63856",
    "gebiet": 6
  },
  {
    "plz": "63857",
    "gebiet": 6
  },
  {
    "plz": "63868",
    "gebiet": 6
  },
  {
    "plz": "63874",
    "gebiet": 6
  },
  {
    "plz": "63897",
    "gebiet": 7
  },
  {
    "plz": "63911",
    "gebiet": 6
  },
  {
    "plz": "63916",
    "gebiet": 7
  },
  {
    "plz": "63925",
    "gebiet": 6
  },
  {
    "plz": "63927",
    "gebiet": 7
  },
  {
    "plz": "63928",
    "gebiet": 7
  },
  {
    "plz": "63930",
    "gebiet": 7
  },
  {
    "plz": "63933",
    "gebiet": 6
  },
  {
    "plz": "63937",
    "gebiet": 7
  },
  {
    "plz": "63939",
    "gebiet": 6
  },
  {
    "plz": "64243",
    "gebiet": 6
  },
  {
    "plz": "64283",
    "gebiet": 6
  },
  {
    "plz": "64285",
    "gebiet": 6
  },
  {
    "plz": "64287",
    "gebiet": 6
  },
  {
    "plz": "64289",
    "gebiet": 6
  },
  {
    "plz": "64291",
    "gebiet": 6
  },
  {
    "plz": "64293",
    "gebiet": 6
  },
  {
    "plz": "64295",
    "gebiet": 6
  },
  {
    "plz": "64297",
    "gebiet": 6
  },
  {
    "plz": "64319",
    "gebiet": 6
  },
  {
    "plz": "64331",
    "gebiet": 6
  },
  {
    "plz": "64342",
    "gebiet": 6
  },
  {
    "plz": "64347",
    "gebiet": 6
  },
  {
    "plz": "64372",
    "gebiet": 6
  },
  {
    "plz": "64380",
    "gebiet": 6
  },
  {
    "plz": "64404",
    "gebiet": 6
  },
  {
    "plz": "64409",
    "gebiet": 6
  },
  {
    "plz": "64521",
    "gebiet": 6
  },
  {
    "plz": "64560",
    "gebiet": 6
  },
  {
    "plz": "64572",
    "gebiet": 6
  },
  {
    "plz": "64579",
    "gebiet": 6
  },
  {
    "plz": "64584",
    "gebiet": 6
  },
  {
    "plz": "64625",
    "gebiet": 6
  },
  {
    "plz": "64646",
    "gebiet": 6
  },
  {
    "plz": "64653",
    "gebiet": 6
  },
  {
    "plz": "64658",
    "gebiet": 6
  },
  {
    "plz": "64665",
    "gebiet": 6
  },
  {
    "plz": "64683",
    "gebiet": 6
  },
  {
    "plz": "64689",
    "gebiet": 6
  },
  {
    "plz": "64711",
    "gebiet": 6
  },
  {
    "plz": "64720",
    "gebiet": 6
  },
  {
    "plz": "64739",
    "gebiet": 6
  },
  {
    "plz": "64747",
    "gebiet": 6
  },
  {
    "plz": "64750",
    "gebiet": 6
  },
  {
    "plz": "64823",
    "gebiet": 6
  },
  {
    "plz": "64832",
    "gebiet": 6
  },
  {
    "plz": "64839",
    "gebiet": 6
  },
  {
    "plz": "64846",
    "gebiet": 6
  },
  {
    "plz": "64850",
    "gebiet": 6
  },
  {
    "plz": "64859",
    "gebiet": 6
  },
  {
    "plz": "65025",
    "gebiet": 6
  },
  {
    "plz": "65102",
    "gebiet": 6
  },
  {
    "plz": "65183",
    "gebiet": 6
  },
  {
    "plz": "65185",
    "gebiet": 6
  },
  {
    "plz": "65187",
    "gebiet": 6
  },
  {
    "plz": "65189",
    "gebiet": 6
  },
  {
    "plz": "65191",
    "gebiet": 6
  },
  {
    "plz": "65193",
    "gebiet": 6
  },
  {
    "plz": "65195",
    "gebiet": 6
  },
  {
    "plz": "65199",
    "gebiet": 6
  },
  {
    "plz": "65201",
    "gebiet": 6
  },
  {
    "plz": "65203",
    "gebiet": 6
  },
  {
    "plz": "65205",
    "gebiet": 6
  },
  {
    "plz": "65207",
    "gebiet": 6
  },
  {
    "plz": "65210",
    "gebiet": 6
  },
  {
    "plz": "65232",
    "gebiet": 6
  },
  {
    "plz": "65239",
    "gebiet": 6
  },
  {
    "plz": "65307",
    "gebiet": 6
  },
  {
    "plz": "65326",
    "gebiet": 6
  },
  {
    "plz": "65343",
    "gebiet": 6
  },
  {
    "plz": "65346",
    "gebiet": 6
  },
  {
    "plz": "65366",
    "gebiet": 6
  },
  {
    "plz": "65375",
    "gebiet": 6
  },
  {
    "plz": "65399",
    "gebiet": 6
  },
  {
    "plz": "65428",
    "gebiet": 6
  },
  {
    "plz": "65439",
    "gebiet": 6
  },
  {
    "plz": "65462",
    "gebiet": 6
  },
  {
    "plz": "65468",
    "gebiet": 6
  },
  {
    "plz": "65474",
    "gebiet": 6
  },
  {
    "plz": "65479",
    "gebiet": 6
  },
  {
    "plz": "65510",
    "gebiet": 6
  },
  {
    "plz": "65520",
    "gebiet": 6
  },
  {
    "plz": "65527",
    "gebiet": 6
  },
  {
    "plz": "65549",
    "gebiet": 6
  },
  {
    "plz": "65550",
    "gebiet": 6
  },
  {
    "plz": "65552",
    "gebiet": 6
  },
  {
    "plz": "65553",
    "gebiet": 6
  },
  {
    "plz": "65556",
    "gebiet": 6
  },
  {
    "plz": "65558",
    "gebiet": 6
  },
  {
    "plz": "65582",
    "gebiet": 6
  },
  {
    "plz": "65589",
    "gebiet": 6
  },
  {
    "plz": "65594",
    "gebiet": 6
  },
  {
    "plz": "65597",
    "gebiet": 6
  },
  {
    "plz": "65599",
    "gebiet": 6
  },
  {
    "plz": "65604",
    "gebiet": 6
  },
  {
    "plz": "65606",
    "gebiet": 6
  },
  {
    "plz": "65611",
    "gebiet": 6
  },
  {
    "plz": "65618",
    "gebiet": 6
  },
  {
    "plz": "65620",
    "gebiet": 6
  },
  {
    "plz": "65623",
    "gebiet": 6
  },
  {
    "plz": "65719",
    "gebiet": 6
  },
  {
    "plz": "65760",
    "gebiet": 6
  },
  {
    "plz": "65779",
    "gebiet": 6
  },
  {
    "plz": "65781",
    "gebiet": 6
  },
  {
    "plz": "65795",
    "gebiet": 6
  },
  {
    "plz": "65812",
    "gebiet": 6
  },
  {
    "plz": "65817",
    "gebiet": 6
  },
  {
    "plz": "65824",
    "gebiet": 6
  },
  {
    "plz": "65830",
    "gebiet": 6
  },
  {
    "plz": "65835",
    "gebiet": 6
  },
  {
    "plz": "65843",
    "gebiet": 6
  },
  {
    "plz": "65931",
    "gebiet": 6
  },
  {
    "plz": "65936",
    "gebiet": 6
  },
  {
    "plz": "66057",
    "gebiet": 6
  },
  {
    "plz": "66111",
    "gebiet": 8
  },
  {
    "plz": "66113",
    "gebiet": 8
  },
  {
    "plz": "66115",
    "gebiet": 8
  },
  {
    "plz": "66117",
    "gebiet": 8
  },
  {
    "plz": "66119",
    "gebiet": 8
  },
  {
    "plz": "66121",
    "gebiet": 8
  },
  {
    "plz": "66123",
    "gebiet": 8
  },
  {
    "plz": "66127",
    "gebiet": 8
  },
  {
    "plz": "66128",
    "gebiet": 8
  },
  {
    "plz": "66129",
    "gebiet": 8
  },
  {
    "plz": "66130",
    "gebiet": 8
  },
  {
    "plz": "66132",
    "gebiet": 8
  },
  {
    "plz": "66133",
    "gebiet": 8
  },
  {
    "plz": "66265",
    "gebiet": 8
  },
  {
    "plz": "66271",
    "gebiet": 8
  },
  {
    "plz": "66287",
    "gebiet": 8
  },
  {
    "plz": "66292",
    "gebiet": 8
  },
  {
    "plz": "66299",
    "gebiet": 8
  },
  {
    "plz": "66333",
    "gebiet": 8
  },
  {
    "plz": "66346",
    "gebiet": 8
  },
  {
    "plz": "66352",
    "gebiet": 8
  },
  {
    "plz": "66359",
    "gebiet": 8
  },
  {
    "plz": "66377",
    "gebiet": 8
  },
  {
    "plz": "66386",
    "gebiet": 8
  },
  {
    "plz": "66424",
    "gebiet": 8
  },
  {
    "plz": "66440",
    "gebiet": 8
  },
  {
    "plz": "66450",
    "gebiet": 8
  },
  {
    "plz": "66453",
    "gebiet": 8
  },
  {
    "plz": "66459",
    "gebiet": 8
  },
  {
    "plz": "66482",
    "gebiet": 8
  },
  {
    "plz": "66497",
    "gebiet": 8
  },
  {
    "plz": "66538",
    "gebiet": 8
  },
  {
    "plz": "66539",
    "gebiet": 8
  },
  {
    "plz": "66540",
    "gebiet": 8
  },
  {
    "plz": "66557",
    "gebiet": 8
  },
  {
    "plz": "66564",
    "gebiet": 8
  },
  {
    "plz": "66571",
    "gebiet": 8
  },
  {
    "plz": "66578",
    "gebiet": 8
  },
  {
    "plz": "66583",
    "gebiet": 8
  },
  {
    "plz": "66589",
    "gebiet": 8
  },
  {
    "plz": "66606",
    "gebiet": 8
  },
  {
    "plz": "66620",
    "gebiet": 6
  },
  {
    "plz": "66629",
    "gebiet": 6
  },
  {
    "plz": "66636",
    "gebiet": 6
  },
  {
    "plz": "66646",
    "gebiet": 8
  },
  {
    "plz": "66649",
    "gebiet": 6
  },
  {
    "plz": "66663",
    "gebiet": 8
  },
  {
    "plz": "66679",
    "gebiet": 6
  },
  {
    "plz": "66687",
    "gebiet": 6
  },
  {
    "plz": "66693",
    "gebiet": 6
  },
  {
    "plz": "66709",
    "gebiet": 6
  },
  {
    "plz": "66740",
    "gebiet": 8
  },
  {
    "plz": "66763",
    "gebiet": 8
  },
  {
    "plz": "66773",
    "gebiet": 8
  },
  {
    "plz": "66780",
    "gebiet": 8
  },
  {
    "plz": "66787",
    "gebiet": 8
  },
  {
    "plz": "66793",
    "gebiet": 8
  },
  {
    "plz": "66798",
    "gebiet": 8
  },
  {
    "plz": "66800",
    "gebiet": 8
  },
  {
    "plz": "66802",
    "gebiet": 8
  },
  {
    "plz": "66809",
    "gebiet": 8
  },
  {
    "plz": "66822",
    "gebiet": 8
  },
  {
    "plz": "66839",
    "gebiet": 8
  },
  {
    "plz": "66849",
    "gebiet": 8
  },
  {
    "plz": "66851",
    "gebiet": 8
  },
  {
    "plz": "66877",
    "gebiet": 8
  },
  {
    "plz": "66885",
    "gebiet": 6
  },
  {
    "plz": "66894",
    "gebiet": 8
  },
  {
    "plz": "66901",
    "gebiet": 8
  },
  {
    "plz": "66916",
    "gebiet": 8
  },
  {
    "plz": "66953",
    "gebiet": 8
  },
  {
    "plz": "66954",
    "gebiet": 8
  },
  {
    "plz": "66955",
    "gebiet": 8
  },
  {
    "plz": "66957",
    "gebiet": 8
  },
  {
    "plz": "66976",
    "gebiet": 8
  },
  {
    "plz": "66994",
    "gebiet": 8
  },
  {
    "plz": "66996",
    "gebiet": 8
  },
  {
    "plz": "67059",
    "gebiet": 8
  },
  {
    "plz": "67061",
    "gebiet": 8
  },
  {
    "plz": "67063",
    "gebiet": 8
  },
  {
    "plz": "67067",
    "gebiet": 8
  },
  {
    "plz": "67069",
    "gebiet": 8
  },
  {
    "plz": "67071",
    "gebiet": 8
  },
  {
    "plz": "67098",
    "gebiet": 8
  },
  {
    "plz": "67105",
    "gebiet": 8
  },
  {
    "plz": "67117",
    "gebiet": 8
  },
  {
    "plz": "67122",
    "gebiet": 8
  },
  {
    "plz": "67125",
    "gebiet": 8
  },
  {
    "plz": "67133",
    "gebiet": 8
  },
  {
    "plz": "67149",
    "gebiet": 8
  },
  {
    "plz": "67157",
    "gebiet": 8
  },
  {
    "plz": "67166",
    "gebiet": 8
  },
  {
    "plz": "67227",
    "gebiet": 8
  },
  {
    "plz": "67245",
    "gebiet": 8
  },
  {
    "plz": "67246",
    "gebiet": 6
  },
  {
    "plz": "67251",
    "gebiet": 8
  },
  {
    "plz": "67269",
    "gebiet": 6
  },
  {
    "plz": "67271",
    "gebiet": 8
  },
  {
    "plz": "67273",
    "gebiet": 8
  },
  {
    "plz": "67280",
    "gebiet": 6
  },
  {
    "plz": "67292",
    "gebiet": 6
  },
  {
    "plz": "67294",
    "gebiet": 6
  },
  {
    "plz": "67304",
    "gebiet": 6
  },
  {
    "plz": "67308",
    "gebiet": 6
  },
  {
    "plz": "67346",
    "gebiet": 8
  },
  {
    "plz": "67360",
    "gebiet": 8
  },
  {
    "plz": "67366",
    "gebiet": 8
  },
  {
    "plz": "67433",
    "gebiet": 8
  },
  {
    "plz": "67434",
    "gebiet": 8
  },
  {
    "plz": "67435",
    "gebiet": 8
  },
  {
    "plz": "67454",
    "gebiet": 8
  },
  {
    "plz": "67459",
    "gebiet": 8
  },
  {
    "plz": "67482",
    "gebiet": 8
  },
  {
    "plz": "67483",
    "gebiet": 8
  },
  {
    "plz": "67487",
    "gebiet": 8
  },
  {
    "plz": "67547",
    "gebiet": 6
  },
  {
    "plz": "67549",
    "gebiet": 6
  },
  {
    "plz": "67550",
    "gebiet": 6
  },
  {
    "plz": "67551",
    "gebiet": 6
  },
  {
    "plz": "67566",
    "gebiet": 6
  },
  {
    "plz": "67574",
    "gebiet": 6
  },
  {
    "plz": "67575",
    "gebiet": 6
  },
  {
    "plz": "67591",
    "gebiet": 6
  },
  {
    "plz": "67592",
    "gebiet": 6
  },
  {
    "plz": "67606",
    "gebiet": 6
  },
  {
    "plz": "67620",
    "gebiet": 6
  },
  {
    "plz": "67655",
    "gebiet": 8
  },
  {
    "plz": "67657",
    "gebiet": 8
  },
  {
    "plz": "67659",
    "gebiet": 8
  },
  {
    "plz": "67661",
    "gebiet": 8
  },
  {
    "plz": "67663",
    "gebiet": 8
  },
  {
    "plz": "67685",
    "gebiet": 8
  },
  {
    "plz": "67691",
    "gebiet": 8
  },
  {
    "plz": "67700",
    "gebiet": 6
  },
  {
    "plz": "67705",
    "gebiet": 8
  },
  {
    "plz": "67722",
    "gebiet": 6
  },
  {
    "plz": "67727",
    "gebiet": 6
  },
  {
    "plz": "67742",
    "gebiet": 6
  },
  {
    "plz": "67744",
    "gebiet": 6
  },
  {
    "plz": "67752",
    "gebiet": 6
  },
  {
    "plz": "67806",
    "gebiet": 6
  },
  {
    "plz": "67822",
    "gebiet": 6
  },
  {
    "plz": "68159",
    "gebiet": 8
  },
  {
    "plz": "68161",
    "gebiet": 8
  },
  {
    "plz": "68163",
    "gebiet": 8
  },
  {
    "plz": "68165",
    "gebiet": 8
  },
  {
    "plz": "68167",
    "gebiet": 8
  },
  {
    "plz": "68182",
    "gebiet": 8
  },
  {
    "plz": "68199",
    "gebiet": 8
  },
  {
    "plz": "68219",
    "gebiet": 8
  },
  {
    "plz": "68239",
    "gebiet": 8
  },
  {
    "plz": "68259",
    "gebiet": 8
  },
  {
    "plz": "68305",
    "gebiet": 8
  },
  {
    "plz": "68307",
    "gebiet": 6
  },
  {
    "plz": "68309",
    "gebiet": 8
  },
  {
    "plz": "68519",
    "gebiet": 6
  },
  {
    "plz": "68526",
    "gebiet": 8
  },
  {
    "plz": "68535",
    "gebiet": 8
  },
  {
    "plz": "68542",
    "gebiet": 8
  },
  {
    "plz": "68549",
    "gebiet": 8
  },
  {
    "plz": "68623",
    "gebiet": 6
  },
  {
    "plz": "68647",
    "gebiet": 6
  },
  {
    "plz": "68723",
    "gebiet": 8
  },
  {
    "plz": "68753",
    "gebiet": 8
  },
  {
    "plz": "68766",
    "gebiet": 8
  },
  {
    "plz": "68775",
    "gebiet": 8
  },
  {
    "plz": "68782",
    "gebiet": 8
  },
  {
    "plz": "68789",
    "gebiet": 8
  },
  {
    "plz": "68794",
    "gebiet": 8
  },
  {
    "plz": "68799",
    "gebiet": 8
  },
  {
    "plz": "68804",
    "gebiet": 8
  },
  {
    "plz": "68809",
    "gebiet": 8
  },
  {
    "plz": "69115",
    "gebiet": 8
  },
  {
    "plz": "69117",
    "gebiet": 8
  },
  {
    "plz": "69120",
    "gebiet": 8
  },
  {
    "plz": "69121",
    "gebiet": 8
  },
  {
    "plz": "69123",
    "gebiet": 8
  },
  {
    "plz": "69124",
    "gebiet": 8
  },
  {
    "plz": "69126",
    "gebiet": 8
  },
  {
    "plz": "69151",
    "gebiet": 8
  },
  {
    "plz": "69168",
    "gebiet": 8
  },
  {
    "plz": "69181",
    "gebiet": 8
  },
  {
    "plz": "69190",
    "gebiet": 8
  },
  {
    "plz": "69198",
    "gebiet": 8
  },
  {
    "plz": "69207",
    "gebiet": 8
  },
  {
    "plz": "69214",
    "gebiet": 8
  },
  {
    "plz": "69226",
    "gebiet": 8
  },
  {
    "plz": "69231",
    "gebiet": 8
  },
  {
    "plz": "69234",
    "gebiet": 8
  },
  {
    "plz": "69239",
    "gebiet": 7
  },
  {
    "plz": "69242",
    "gebiet": 8
  },
  {
    "plz": "69245",
    "gebiet": 8
  },
  {
    "plz": "69253",
    "gebiet": 7
  },
  {
    "plz": "69259",
    "gebiet": 8
  },
  {
    "plz": "69412",
    "gebiet": 8
  },
  {
    "plz": "69436",
    "gebiet": 7
  },
  {
    "plz": "69469",
    "gebiet": 6
  },
  {
    "plz": "69483",
    "gebiet": 7
  },
  {
    "plz": "69488",
    "gebiet": 7
  },
  {
    "plz": "69493",
    "gebiet": 8
  },
  {
    "plz": "69502",
    "gebiet": 6
  },
  {
    "plz": "69509",
    "gebiet": 7
  },
  {
    "plz": "69514",
    "gebiet": 6
  },
  {
    "plz": "70075",
    "gebiet": 6
  },
  {
    "plz": "70173",
    "gebiet": 8
  },
  {
    "plz": "70174",
    "gebiet": 8
  },
  {
    "plz": "70176",
    "gebiet": 8
  },
  {
    "plz": "70178",
    "gebiet": 8
  },
  {
    "plz": "70180",
    "gebiet": 8
  },
  {
    "plz": "70184",
    "gebiet": 8
  },
  {
    "plz": "70188",
    "gebiet": 8
  },
  {
    "plz": "70190",
    "gebiet": 8
  },
  {
    "plz": "70191",
    "gebiet": 8
  },
  {
    "plz": "70192",
    "gebiet": 8
  },
  {
    "plz": "70193",
    "gebiet": 8
  },
  {
    "plz": "70195",
    "gebiet": 8
  },
  {
    "plz": "70199",
    "gebiet": 8
  },
  {
    "plz": "70327",
    "gebiet": 8
  },
  {
    "plz": "70329",
    "gebiet": 8
  },
  {
    "plz": "70372",
    "gebiet": 8
  },
  {
    "plz": "70374",
    "gebiet": 8
  },
  {
    "plz": "70376",
    "gebiet": 8
  },
  {
    "plz": "70378",
    "gebiet": 8
  },
  {
    "plz": "70437",
    "gebiet": 8
  },
  {
    "plz": "70439",
    "gebiet": 8
  },
  {
    "plz": "70449",
    "gebiet": 8
  },
  {
    "plz": "70469",
    "gebiet": 8
  },
  {
    "plz": "70477",
    "gebiet": 8
  },
  {
    "plz": "70499",
    "gebiet": 8
  },
  {
    "plz": "70506",
    "gebiet": 8
  },
  {
    "plz": "70563",
    "gebiet": 8
  },
  {
    "plz": "70565",
    "gebiet": 8
  },
  {
    "plz": "70567",
    "gebiet": 8
  },
  {
    "plz": "70569",
    "gebiet": 8
  },
  {
    "plz": "70597",
    "gebiet": 8
  },
  {
    "plz": "70619",
    "gebiet": 8
  },
  {
    "plz": "70734",
    "gebiet": 8
  },
  {
    "plz": "70736",
    "gebiet": 8
  },
  {
    "plz": "70771",
    "gebiet": 8
  },
  {
    "plz": "70794",
    "gebiet": 8
  },
  {
    "plz": "70806",
    "gebiet": 8
  },
  {
    "plz": "70825",
    "gebiet": 8
  },
  {
    "plz": "70839",
    "gebiet": 8
  },
  {
    "plz": "71032",
    "gebiet": 8
  },
  {
    "plz": "71063",
    "gebiet": 8
  },
  {
    "plz": "71067",
    "gebiet": 8
  },
  {
    "plz": "71083",
    "gebiet": 8
  },
  {
    "plz": "71088",
    "gebiet": 8
  },
  {
    "plz": "71101",
    "gebiet": 8
  },
  {
    "plz": "71111",
    "gebiet": 8
  },
  {
    "plz": "71116",
    "gebiet": 8
  },
  {
    "plz": "71120",
    "gebiet": 8
  },
  {
    "plz": "71126",
    "gebiet": 8
  },
  {
    "plz": "71134",
    "gebiet": 8
  },
  {
    "plz": "71144",
    "gebiet": 8
  },
  {
    "plz": "71154",
    "gebiet": 8
  },
  {
    "plz": "71157",
    "gebiet": 8
  },
  {
    "plz": "71229",
    "gebiet": 8
  },
  {
    "plz": "71254",
    "gebiet": 8
  },
  {
    "plz": "71263",
    "gebiet": 8
  },
  {
    "plz": "71272",
    "gebiet": 8
  },
  {
    "plz": "71277",
    "gebiet": 8
  },
  {
    "plz": "71282",
    "gebiet": 8
  },
  {
    "plz": "71287",
    "gebiet": 8
  },
  {
    "plz": "71297",
    "gebiet": 8
  },
  {
    "plz": "71305",
    "gebiet": 8
  },
  {
    "plz": "71332",
    "gebiet": 8
  },
  {
    "plz": "71334",
    "gebiet": 8
  },
  {
    "plz": "71336",
    "gebiet": 8
  },
  {
    "plz": "71364",
    "gebiet": 8
  },
  {
    "plz": "71384",
    "gebiet": 8
  },
  {
    "plz": "71394",
    "gebiet": 8
  },
  {
    "plz": "71397",
    "gebiet": 8
  },
  {
    "plz": "71409",
    "gebiet": 8
  },
  {
    "plz": "71522",
    "gebiet": 8
  },
  {
    "plz": "71540",
    "gebiet": 7
  },
  {
    "plz": "71543",
    "gebiet": 7
  },
  {
    "plz": "71549",
    "gebiet": 8
  },
  {
    "plz": "71554",
    "gebiet": 8
  },
  {
    "plz": "71563",
    "gebiet": 8
  },
  {
    "plz": "71566",
    "gebiet": 9
  },
  {
    "plz": "71577",
    "gebiet": 7
  },
  {
    "plz": "71579",
    "gebiet": 7
  },
  {
    "plz": "71634",
    "gebiet": 8
  },
  {
    "plz": "71636",
    "gebiet": 8
  },
  {
    "plz": "71638",
    "gebiet": 8
  },
  {
    "plz": "71640",
    "gebiet": 8
  },
  {
    "plz": "71642",
    "gebiet": 8
  },
  {
    "plz": "71665",
    "gebiet": 8
  },
  {
    "plz": "71672",
    "gebiet": 8
  },
  {
    "plz": "71686",
    "gebiet": 8
  },
  {
    "plz": "71691",
    "gebiet": 8
  },
  {
    "plz": "71696",
    "gebiet": 8
  },
  {
    "plz": "71701",
    "gebiet": 8
  },
  {
    "plz": "71706",
    "gebiet": 8
  },
  {
    "plz": "71711",
    "gebiet": 8
  },
  {
    "plz": "71720",
    "gebiet": 8
  },
  {
    "plz": "71723",
    "gebiet": 8
  },
  {
    "plz": "71726",
    "gebiet": 8
  },
  {
    "plz": "71732",
    "gebiet": 8
  },
  {
    "plz": "71739",
    "gebiet": 8
  },
  {
    "plz": "72070",
    "gebiet": 8
  },
  {
    "plz": "72072",
    "gebiet": 8
  },
  {
    "plz": "72074",
    "gebiet": 8
  },
  {
    "plz": "72076",
    "gebiet": 8
  },
  {
    "plz": "72108",
    "gebiet": 8
  },
  {
    "plz": "72116",
    "gebiet": 8
  },
  {
    "plz": "72119",
    "gebiet": 8
  },
  {
    "plz": "72127",
    "gebiet": 8
  },
  {
    "plz": "72135",
    "gebiet": 8
  },
  {
    "plz": "72138",
    "gebiet": 8
  },
  {
    "plz": "72144",
    "gebiet": 8
  },
  {
    "plz": "72147",
    "gebiet": 8
  },
  {
    "plz": "72149",
    "gebiet": 8
  },
  {
    "plz": "72160",
    "gebiet": 8
  },
  {
    "plz": "72172",
    "gebiet": 8
  },
  {
    "plz": "72175",
    "gebiet": 8
  },
  {
    "plz": "72178",
    "gebiet": 8
  },
  {
    "plz": "72186",
    "gebiet": 8
  },
  {
    "plz": "72189",
    "gebiet": 8
  },
  {
    "plz": "72202",
    "gebiet": 8
  },
  {
    "plz": "72213",
    "gebiet": 8
  },
  {
    "plz": "72218",
    "gebiet": 8
  },
  {
    "plz": "72250",
    "gebiet": 8
  },
  {
    "plz": "72270",
    "gebiet": 8
  },
  {
    "plz": "72275",
    "gebiet": 8
  },
  {
    "plz": "72296",
    "gebiet": 8
  },
  {
    "plz": "72336",
    "gebiet": 8
  },
  {
    "plz": "72348",
    "gebiet": 8
  },
  {
    "plz": "72351",
    "gebiet": 8
  },
  {
    "plz": "72379",
    "gebiet": 8
  },
  {
    "plz": "72393",
    "gebiet": 8
  },
  {
    "plz": "72401",
    "gebiet": 8
  },
  {
    "plz": "72406",
    "gebiet": 8
  },
  {
    "plz": "72417",
    "gebiet": 8
  },
  {
    "plz": "72458",
    "gebiet": 8
  },
  {
    "plz": "72459",
    "gebiet": 8
  },
  {
    "plz": "72461",
    "gebiet": 8
  },
  {
    "plz": "72469",
    "gebiet": 8
  },
  {
    "plz": "72474",
    "gebiet": 8
  },
  {
    "plz": "72488",
    "gebiet": 8
  },
  {
    "plz": "72505",
    "gebiet": 8
  },
  {
    "plz": "72519",
    "gebiet": 8
  },
  {
    "plz": "72535",
    "gebiet": 9
  },
  {
    "plz": "72537",
    "gebiet": 9
  },
  {
    "plz": "72555",
    "gebiet": 8
  },
  {
    "plz": "72581",
    "gebiet": 9
  },
  {
    "plz": "72622",
    "gebiet": 8
  },
  {
    "plz": "72636",
    "gebiet": 8
  },
  {
    "plz": "72644",
    "gebiet": 8
  },
  {
    "plz": "72646",
    "gebiet": 8
  },
  {
    "plz": "72649",
    "gebiet": 8
  },
  {
    "plz": "72654",
    "gebiet": 8
  },
  {
    "plz": "72657",
    "gebiet": 8
  },
  {
    "plz": "72658",
    "gebiet": 8
  },
  {
    "plz": "72666",
    "gebiet": 8
  },
  {
    "plz": "72667",
    "gebiet": 8
  },
  {
    "plz": "72669",
    "gebiet": 8
  },
  {
    "plz": "72719",
    "gebiet": 8
  },
  {
    "plz": "72734",
    "gebiet": 8
  },
  {
    "plz": "72760",
    "gebiet": 8
  },
  {
    "plz": "72762",
    "gebiet": 8
  },
  {
    "plz": "72764",
    "gebiet": 8
  },
  {
    "plz": "72768",
    "gebiet": 8
  },
  {
    "plz": "72770",
    "gebiet": 8
  },
  {
    "plz": "72774",
    "gebiet": 8
  },
  {
    "plz": "72793",
    "gebiet": 8
  },
  {
    "plz": "72800",
    "gebiet": 8
  },
  {
    "plz": "72805",
    "gebiet": 8
  },
  {
    "plz": "72810",
    "gebiet": 8
  },
  {
    "plz": "72820",
    "gebiet": 8
  },
  {
    "plz": "72829",
    "gebiet": 9
  },
  {
    "plz": "73035",
    "gebiet": 9
  },
  {
    "plz": "73037",
    "gebiet": 9
  },
  {
    "plz": "73054",
    "gebiet": 9
  },
  {
    "plz": "73061",
    "gebiet": 9
  },
  {
    "plz": "73066",
    "gebiet": 9
  },
  {
    "plz": "73072",
    "gebiet": 9
  },
  {
    "plz": "73084",
    "gebiet": 9
  },
  {
    "plz": "73087",
    "gebiet": 9
  },
  {
    "plz": "73107",
    "gebiet": 9
  },
  {
    "plz": "73108",
    "gebiet": 9
  },
  {
    "plz": "73110",
    "gebiet": 9
  },
  {
    "plz": "73111",
    "gebiet": 9
  },
  {
    "plz": "73113",
    "gebiet": 9
  },
  {
    "plz": "73117",
    "gebiet": 9
  },
  {
    "plz": "73119",
    "gebiet": 9
  },
  {
    "plz": "73207",
    "gebiet": 8
  },
  {
    "plz": "73223",
    "gebiet": 9
  },
  {
    "plz": "73230",
    "gebiet": 9
  },
  {
    "plz": "73240",
    "gebiet": 8
  },
  {
    "plz": "73274",
    "gebiet": 8
  },
  {
    "plz": "73275",
    "gebiet": 9
  },
  {
    "plz": "73277",
    "gebiet": 9
  },
  {
    "plz": "73278",
    "gebiet": 9
  },
  {
    "plz": "73312",
    "gebiet": 9
  },
  {
    "plz": "73326",
    "gebiet": 9
  },
  {
    "plz": "73337",
    "gebiet": 9
  },
  {
    "plz": "73430",
    "gebiet": 7
  },
  {
    "plz": "73431",
    "gebiet": 7
  },
  {
    "plz": "73432",
    "gebiet": 7
  },
  {
    "plz": "73433",
    "gebiet": 7
  },
  {
    "plz": "73434",
    "gebiet": 7
  },
  {
    "plz": "73447",
    "gebiet": 7
  },
  {
    "plz": "73450",
    "gebiet": 7
  },
  {
    "plz": "73453",
    "gebiet": 7
  },
  {
    "plz": "73457",
    "gebiet": 7
  },
  {
    "plz": "73460",
    "gebiet": 7
  },
  {
    "plz": "73466",
    "gebiet": 7
  },
  {
    "plz": "73479",
    "gebiet": 7
  },
  {
    "plz": "73488",
    "gebiet": 7
  },
  {
    "plz": "73497",
    "gebiet": 7
  },
  {
    "plz": "73525",
    "gebiet": 9
  },
  {
    "plz": "73527",
    "gebiet": 7
  },
  {
    "plz": "73529",
    "gebiet": 9
  },
  {
    "plz": "73540",
    "gebiet": 7
  },
  {
    "plz": "73547",
    "gebiet": 9
  },
  {
    "plz": "73550",
    "gebiet": 9
  },
  {
    "plz": "73557",
    "gebiet": 7
  },
  {
    "plz": "73560",
    "gebiet": 7
  },
  {
    "plz": "73614",
    "gebiet": 9
  },
  {
    "plz": "73630",
    "gebiet": 8
  },
  {
    "plz": "73635",
    "gebiet": 9
  },
  {
    "plz": "73650",
    "gebiet": 8
  },
  {
    "plz": "73655",
    "gebiet": 9
  },
  {
    "plz": "73660",
    "gebiet": 9
  },
  {
    "plz": "73663",
    "gebiet": 8
  },
  {
    "plz": "73666",
    "gebiet": 8
  },
  {
    "plz": "73667",
    "gebiet": 7
  },
  {
    "plz": "73669",
    "gebiet": 8
  },
  {
    "plz": "73728",
    "gebiet": 8
  },
  {
    "plz": "73730",
    "gebiet": 8
  },
  {
    "plz": "73732",
    "gebiet": 8
  },
  {
    "plz": "73733",
    "gebiet": 8
  },
  {
    "plz": "73734",
    "gebiet": 8
  },
  {
    "plz": "73751",
    "gebiet": 8
  },
  {
    "plz": "73752",
    "gebiet": 8
  },
  {
    "plz": "73760",
    "gebiet": 8
  },
  {
    "plz": "73765",
    "gebiet": 8
  },
  {
    "plz": "73773",
    "gebiet": 8
  },
  {
    "plz": "74007",
    "gebiet": 8
  },
  {
    "plz": "74072",
    "gebiet": 8
  },
  {
    "plz": "74074",
    "gebiet": 8
  },
  {
    "plz": "74076",
    "gebiet": 8
  },
  {
    "plz": "74078",
    "gebiet": 7
  },
  {
    "plz": "74080",
    "gebiet": 8
  },
  {
    "plz": "74081",
    "gebiet": 8
  },
  {
    "plz": "74177",
    "gebiet": 7
  },
  {
    "plz": "74182",
    "gebiet": 7
  },
  {
    "plz": "74193",
    "gebiet": 8
  },
  {
    "plz": "74196",
    "gebiet": 7
  },
  {
    "plz": "74199",
    "gebiet": 8
  },
  {
    "plz": "74206",
    "gebiet": 7
  },
  {
    "plz": "74211",
    "gebiet": 8
  },
  {
    "plz": "74219",
    "gebiet": 7
  },
  {
    "plz": "74223",
    "gebiet": 8
  },
  {
    "plz": "74226",
    "gebiet": 8
  },
  {
    "plz": "74235",
    "gebiet": 7
  },
  {
    "plz": "74255",
    "gebiet": 7
  },
  {
    "plz": "74257",
    "gebiet": 7
  },
  {
    "plz": "74301",
    "gebiet": 7
  },
  {
    "plz": "74303",
    "gebiet": 7
  },
  {
    "plz": "74321",
    "gebiet": 8
  },
  {
    "plz": "74336",
    "gebiet": 8
  },
  {
    "plz": "74348",
    "gebiet": 8
  },
  {
    "plz": "74354",
    "gebiet": 8
  },
  {
    "plz": "74360",
    "gebiet": 8
  },
  {
    "plz": "74379",
    "gebiet": 8
  },
  {
    "plz": "74385",
    "gebiet": 8
  },
  {
    "plz": "74391",
    "gebiet": 8
  },
  {
    "plz": "74395",
    "gebiet": 8
  },
  {
    "plz": "74405",
    "gebiet": 7
  },
  {
    "plz": "74420",
    "gebiet": 7
  },
  {
    "plz": "74423",
    "gebiet": 7
  },
  {
    "plz": "74424",
    "gebiet": 7
  },
  {
    "plz": "74523",
    "gebiet": 7
  },
  {
    "plz": "74532",
    "gebiet": 7
  },
  {
    "plz": "74538",
    "gebiet": 7
  },
  {
    "plz": "74545",
    "gebiet": 7
  },
  {
    "plz": "74549",
    "gebiet": 7
  },
  {
    "plz": "74564",
    "gebiet": 7
  },
  {
    "plz": "74579",
    "gebiet": 7
  },
  {
    "plz": "74585",
    "gebiet": 7
  },
  {
    "plz": "74597",
    "gebiet": 7
  },
  {
    "plz": "74613",
    "gebiet": 7
  },
  {
    "plz": "74626",
    "gebiet": 7
  },
  {
    "plz": "74629",
    "gebiet": 7
  },
  {
    "plz": "74632",
    "gebiet": 7
  },
  {
    "plz": "74638",
    "gebiet": 7
  },
  {
    "plz": "74653",
    "gebiet": 7
  },
  {
    "plz": "74670",
    "gebiet": 8
  },
  {
    "plz": "74673",
    "gebiet": 7
  },
  {
    "plz": "74722",
    "gebiet": 7
  },
  {
    "plz": "74731",
    "gebiet": 7
  },
  {
    "plz": "74740",
    "gebiet": 7
  },
  {
    "plz": "74743",
    "gebiet": 7
  },
  {
    "plz": "74749",
    "gebiet": 7
  },
  {
    "plz": "74821",
    "gebiet": 7
  },
  {
    "plz": "74838",
    "gebiet": 7
  },
  {
    "plz": "74847",
    "gebiet": 7
  },
  {
    "plz": "74862",
    "gebiet": 7
  },
  {
    "plz": "74869",
    "gebiet": 7
  },
  {
    "plz": "74889",
    "gebiet": 8
  },
  {
    "plz": "74906",
    "gebiet": 7
  },
  {
    "plz": "74909",
    "gebiet": 8
  },
  {
    "plz": "74912",
    "gebiet": 8
  },
  {
    "plz": "74915",
    "gebiet": 8
  },
  {
    "plz": "74918",
    "gebiet": 8
  },
  {
    "plz": "74921",
    "gebiet": 7
  },
  {
    "plz": "74924",
    "gebiet": 7
  },
  {
    "plz": "74931",
    "gebiet": 8
  },
  {
    "plz": "74934",
    "gebiet": 7
  },
  {
    "plz": "75015",
    "gebiet": 8
  },
  {
    "plz": "75021",
    "gebiet": 8
  },
  {
    "plz": "75031",
    "gebiet": 8
  },
  {
    "plz": "75038",
    "gebiet": 8
  },
  {
    "plz": "75050",
    "gebiet": 8
  },
  {
    "plz": "75053",
    "gebiet": 8
  },
  {
    "plz": "75091",
    "gebiet": 8
  },
  {
    "plz": "75172",
    "gebiet": 8
  },
  {
    "plz": "75173",
    "gebiet": 8
  },
  {
    "plz": "75175",
    "gebiet": 8
  },
  {
    "plz": "75177",
    "gebiet": 8
  },
  {
    "plz": "75179",
    "gebiet": 8
  },
  {
    "plz": "75180",
    "gebiet": 8
  },
  {
    "plz": "75181",
    "gebiet": 8
  },
  {
    "plz": "75196",
    "gebiet": 8
  },
  {
    "plz": "75217",
    "gebiet": 8
  },
  {
    "plz": "75228",
    "gebiet": 8
  },
  {
    "plz": "75233",
    "gebiet": 8
  },
  {
    "plz": "75236",
    "gebiet": 8
  },
  {
    "plz": "75245",
    "gebiet": 8
  },
  {
    "plz": "75249",
    "gebiet": 8
  },
  {
    "plz": "75305",
    "gebiet": 8
  },
  {
    "plz": "75323",
    "gebiet": 8
  },
  {
    "plz": "75328",
    "gebiet": 8
  },
  {
    "plz": "75365",
    "gebiet": 8
  },
  {
    "plz": "75380",
    "gebiet": 8
  },
  {
    "plz": "75392",
    "gebiet": 8
  },
  {
    "plz": "75417",
    "gebiet": 8
  },
  {
    "plz": "75438",
    "gebiet": 8
  },
  {
    "plz": "76131",
    "gebiet": 8
  },
  {
    "plz": "76133",
    "gebiet": 8
  },
  {
    "plz": "76135",
    "gebiet": 8
  },
  {
    "plz": "76137",
    "gebiet": 8
  },
  {
    "plz": "76139",
    "gebiet": 8
  },
  {
    "plz": "76149",
    "gebiet": 8
  },
  {
    "plz": "76185",
    "gebiet": 8
  },
  {
    "plz": "76189",
    "gebiet": 8
  },
  {
    "plz": "76191",
    "gebiet": 8
  },
  {
    "plz": "76199",
    "gebiet": 8
  },
  {
    "plz": "76227",
    "gebiet": 8
  },
  {
    "plz": "76228",
    "gebiet": 8
  },
  {
    "plz": "76275",
    "gebiet": 8
  },
  {
    "plz": "76287",
    "gebiet": 8
  },
  {
    "plz": "76297",
    "gebiet": 8
  },
  {
    "plz": "76307",
    "gebiet": 8
  },
  {
    "plz": "76316",
    "gebiet": 8
  },
  {
    "plz": "76327",
    "gebiet": 8
  },
  {
    "plz": "76337",
    "gebiet": 8
  },
  {
    "plz": "76344",
    "gebiet": 8
  },
  {
    "plz": "76347",
    "gebiet": 8
  },
  {
    "plz": "76351",
    "gebiet": 8
  },
  {
    "plz": "76356",
    "gebiet": 8
  },
  {
    "plz": "76437",
    "gebiet": 8
  },
  {
    "plz": "76448",
    "gebiet": 8
  },
  {
    "plz": "76461",
    "gebiet": 8
  },
  {
    "plz": "76474",
    "gebiet": 8
  },
  {
    "plz": "76479",
    "gebiet": 8
  },
  {
    "plz": "76530",
    "gebiet": 8
  },
  {
    "plz": "76532",
    "gebiet": 8
  },
  {
    "plz": "76534",
    "gebiet": 8
  },
  {
    "plz": "76547",
    "gebiet": 8
  },
  {
    "plz": "76571",
    "gebiet": 8
  },
  {
    "plz": "76593",
    "gebiet": 8
  },
  {
    "plz": "76597",
    "gebiet": 8
  },
  {
    "plz": "76646",
    "gebiet": 8
  },
  {
    "plz": "76661",
    "gebiet": 8
  },
  {
    "plz": "76684",
    "gebiet": 8
  },
  {
    "plz": "76689",
    "gebiet": 8
  },
  {
    "plz": "76694",
    "gebiet": 8
  },
  {
    "plz": "76698",
    "gebiet": 8
  },
  {
    "plz": "76703",
    "gebiet": 8
  },
  {
    "plz": "76706",
    "gebiet": 8
  },
  {
    "plz": "76707",
    "gebiet": 8
  },
  {
    "plz": "76709",
    "gebiet": 8
  },
  {
    "plz": "76726",
    "gebiet": 8
  },
  {
    "plz": "76744",
    "gebiet": 8
  },
  {
    "plz": "76751",
    "gebiet": 8
  },
  {
    "plz": "76764",
    "gebiet": 8
  },
  {
    "plz": "76774",
    "gebiet": 8
  },
  {
    "plz": "76829",
    "gebiet": 8
  },
  {
    "plz": "76831",
    "gebiet": 8
  },
  {
    "plz": "76835",
    "gebiet": 8
  },
  {
    "plz": "76855",
    "gebiet": 8
  },
  {
    "plz": "76857",
    "gebiet": 8
  },
  {
    "plz": "76863",
    "gebiet": 8
  },
  {
    "plz": "76870",
    "gebiet": 8
  },
  {
    "plz": "76877",
    "gebiet": 8
  },
  {
    "plz": "76887",
    "gebiet": 8
  },
  {
    "plz": "77652",
    "gebiet": 8
  },
  {
    "plz": "77654",
    "gebiet": 8
  },
  {
    "plz": "77656",
    "gebiet": 8
  },
  {
    "plz": "77694",
    "gebiet": 8
  },
  {
    "plz": "77704",
    "gebiet": 8
  },
  {
    "plz": "77716",
    "gebiet": 8
  },
  {
    "plz": "77723",
    "gebiet": 8
  },
  {
    "plz": "77728",
    "gebiet": 8
  },
  {
    "plz": "77731",
    "gebiet": 8
  },
  {
    "plz": "77736",
    "gebiet": 8
  },
  {
    "plz": "77743",
    "gebiet": 8
  },
  {
    "plz": "77746",
    "gebiet": 8
  },
  {
    "plz": "77749",
    "gebiet": 8
  },
  {
    "plz": "77767",
    "gebiet": 8
  },
  {
    "plz": "77770",
    "gebiet": 8
  },
  {
    "plz": "77781",
    "gebiet": 8
  },
  {
    "plz": "77793",
    "gebiet": 8
  },
  {
    "plz": "77796",
    "gebiet": 8
  },
  {
    "plz": "77799",
    "gebiet": 8
  },
  {
    "plz": "77815",
    "gebiet": 8
  },
  {
    "plz": "77830",
    "gebiet": 8
  },
  {
    "plz": "77836",
    "gebiet": 8
  },
  {
    "plz": "77855",
    "gebiet": 8
  },
  {
    "plz": "77866",
    "gebiet": 8
  },
  {
    "plz": "77871",
    "gebiet": 8
  },
  {
    "plz": "77876",
    "gebiet": 8
  },
  {
    "plz": "77933",
    "gebiet": 8
  },
  {
    "plz": "77955",
    "gebiet": 8
  },
  {
    "plz": "77963",
    "gebiet": 8
  },
  {
    "plz": "77971",
    "gebiet": 8
  },
  {
    "plz": "78048",
    "gebiet": 8
  },
  {
    "plz": "78050",
    "gebiet": 8
  },
  {
    "plz": "78052",
    "gebiet": 8
  },
  {
    "plz": "78054",
    "gebiet": 8
  },
  {
    "plz": "78056",
    "gebiet": 8
  },
  {
    "plz": "78073",
    "gebiet": 8
  },
  {
    "plz": "78083",
    "gebiet": 8
  },
  {
    "plz": "78089",
    "gebiet": 8
  },
  {
    "plz": "78098",
    "gebiet": 8
  },
  {
    "plz": "78120",
    "gebiet": 8
  },
  {
    "plz": "78126",
    "gebiet": 8
  },
  {
    "plz": "78136",
    "gebiet": 8
  },
  {
    "plz": "78166",
    "gebiet": 8
  },
  {
    "plz": "78176",
    "gebiet": 8
  },
  {
    "plz": "78194",
    "gebiet": 8
  },
  {
    "plz": "78199",
    "gebiet": 8
  },
  {
    "plz": "78224",
    "gebiet": 8
  },
  {
    "plz": "78234",
    "gebiet": 8
  },
  {
    "plz": "78244",
    "gebiet": 8
  },
  {
    "plz": "78247",
    "gebiet": 8
  },
  {
    "plz": "78253",
    "gebiet": 8
  },
  {
    "plz": "78315",
    "gebiet": 8
  },
  {
    "plz": "78333",
    "gebiet": 8
  },
  {
    "plz": "78337",
    "gebiet": 8
  },
  {
    "plz": "78351",
    "gebiet": 8
  },
  {
    "plz": "78462",
    "gebiet": 8
  },
  {
    "plz": "78464",
    "gebiet": 8
  },
  {
    "plz": "78467",
    "gebiet": 8
  },
  {
    "plz": "78476",
    "gebiet": 8
  },
  {
    "plz": "78532",
    "gebiet": 8
  },
  {
    "plz": "78549",
    "gebiet": 8
  },
  {
    "plz": "78554",
    "gebiet": 8
  },
  {
    "plz": "78576",
    "gebiet": 8
  },
  {
    "plz": "78579",
    "gebiet": 8
  },
  {
    "plz": "78611",
    "gebiet": 8
  },
  {
    "plz": "78628",
    "gebiet": 8
  },
  {
    "plz": "78647",
    "gebiet": 8
  },
  {
    "plz": "78655",
    "gebiet": 8
  },
  {
    "plz": "78661",
    "gebiet": 8
  },
  {
    "plz": "78664",
    "gebiet": 8
  },
  {
    "plz": "78667",
    "gebiet": 8
  },
  {
    "plz": "78713",
    "gebiet": 8
  },
  {
    "plz": "78727",
    "gebiet": 8
  },
  {
    "plz": "78739",
    "gebiet": 8
  },
  {
    "plz": "79098",
    "gebiet": 8
  },
  {
    "plz": "79100",
    "gebiet": 8
  },
  {
    "plz": "79104",
    "gebiet": 8
  },
  {
    "plz": "79106",
    "gebiet": 8
  },
  {
    "plz": "79108",
    "gebiet": 8
  },
  {
    "plz": "79110",
    "gebiet": 8
  },
  {
    "plz": "79111",
    "gebiet": 8
  },
  {
    "plz": "79114",
    "gebiet": 8
  },
  {
    "plz": "79115",
    "gebiet": 8
  },
  {
    "plz": "79117",
    "gebiet": 8
  },
  {
    "plz": "79183",
    "gebiet": 8
  },
  {
    "plz": "79189",
    "gebiet": 8
  },
  {
    "plz": "79194",
    "gebiet": 8
  },
  {
    "plz": "79206",
    "gebiet": 8
  },
  {
    "plz": "79211",
    "gebiet": 8
  },
  {
    "plz": "79219",
    "gebiet": 8
  },
  {
    "plz": "79224",
    "gebiet": 8
  },
  {
    "plz": "79227",
    "gebiet": 8
  },
  {
    "plz": "79232",
    "gebiet": 8
  },
  {
    "plz": "79238",
    "gebiet": 8
  },
  {
    "plz": "79241",
    "gebiet": 8
  },
  {
    "plz": "79244",
    "gebiet": 8
  },
  {
    "plz": "79252",
    "gebiet": 8
  },
  {
    "plz": "79256",
    "gebiet": 8
  },
  {
    "plz": "79258",
    "gebiet": 8
  },
  {
    "plz": "79261",
    "gebiet": 8
  },
  {
    "plz": "79279",
    "gebiet": 8
  },
  {
    "plz": "79282",
    "gebiet": 8
  },
  {
    "plz": "79283",
    "gebiet": 8
  },
  {
    "plz": "79285",
    "gebiet": 8
  },
  {
    "plz": "79291",
    "gebiet": 8
  },
  {
    "plz": "79292",
    "gebiet": 8
  },
  {
    "plz": "79295",
    "gebiet": 8
  },
  {
    "plz": "79297",
    "gebiet": 8
  },
  {
    "plz": "79312",
    "gebiet": 8
  },
  {
    "plz": "79331",
    "gebiet": 8
  },
  {
    "plz": "79336",
    "gebiet": 8
  },
  {
    "plz": "79341",
    "gebiet": 8
  },
  {
    "plz": "79342",
    "gebiet": 8
  },
  {
    "plz": "79346",
    "gebiet": 8
  },
  {
    "plz": "79348",
    "gebiet": 8
  },
  {
    "plz": "79350",
    "gebiet": 8
  },
  {
    "plz": "79353",
    "gebiet": 8
  },
  {
    "plz": "79356",
    "gebiet": 8
  },
  {
    "plz": "79359",
    "gebiet": 8
  },
  {
    "plz": "79364",
    "gebiet": 8
  },
  {
    "plz": "79365",
    "gebiet": 8
  },
  {
    "plz": "79379",
    "gebiet": 8
  },
  {
    "plz": "79395",
    "gebiet": 8
  },
  {
    "plz": "79400",
    "gebiet": 8
  },
  {
    "plz": "79418",
    "gebiet": 8
  },
  {
    "plz": "79423",
    "gebiet": 8
  },
  {
    "plz": "79426",
    "gebiet": 8
  },
  {
    "plz": "79427",
    "gebiet": 8
  },
  {
    "plz": "79539",
    "gebiet": 8
  },
  {
    "plz": "79540",
    "gebiet": 8
  },
  {
    "plz": "79541",
    "gebiet": 8
  },
  {
    "plz": "79576",
    "gebiet": 8
  },
  {
    "plz": "79585",
    "gebiet": 8
  },
  {
    "plz": "79588",
    "gebiet": 8
  },
  {
    "plz": "79589",
    "gebiet": 8
  },
  {
    "plz": "79591",
    "gebiet": 8
  },
  {
    "plz": "79595",
    "gebiet": 8
  },
  {
    "plz": "79618",
    "gebiet": 8
  },
  {
    "plz": "79650",
    "gebiet": 8
  },
  {
    "plz": "79664",
    "gebiet": 8
  },
  {
    "plz": "79674",
    "gebiet": 8
  },
  {
    "plz": "79677",
    "gebiet": 8
  },
  {
    "plz": "79701",
    "gebiet": 8
  },
  {
    "plz": "79713",
    "gebiet": 8
  },
  {
    "plz": "79725",
    "gebiet": 8
  },
  {
    "plz": "79730",
    "gebiet": 8
  },
  {
    "plz": "79733",
    "gebiet": 8
  },
  {
    "plz": "79736",
    "gebiet": 8
  },
  {
    "plz": "79761",
    "gebiet": 8
  },
  {
    "plz": "79771",
    "gebiet": 8
  },
  {
    "plz": "79777",
    "gebiet": 8
  },
  {
    "plz": "79780",
    "gebiet": 8
  },
  {
    "plz": "79787",
    "gebiet": 8
  },
  {
    "plz": "79790",
    "gebiet": 8
  },
  {
    "plz": "79798",
    "gebiet": 8
  },
  {
    "plz": "79801",
    "gebiet": 8
  },
  {
    "plz": "79822",
    "gebiet": 8
  },
  {
    "plz": "79843",
    "gebiet": 8
  },
  {
    "plz": "79862",
    "gebiet": 8
  },
  {
    "plz": "79875",
    "gebiet": 8
  },
  {
    "plz": "80042",
    "gebiet": 8
  },
  {
    "plz": "80048",
    "gebiet": 8
  },
  {
    "plz": "80331",
    "gebiet": 9
  },
  {
    "plz": "80335",
    "gebiet": 9
  },
  {
    "plz": "80336",
    "gebiet": 9
  },
  {
    "plz": "80337",
    "gebiet": 9
  },
  {
    "plz": "80339",
    "gebiet": 9
  },
  {
    "plz": "80469",
    "gebiet": 9
  },
  {
    "plz": "80538",
    "gebiet": 9
  },
  {
    "plz": "80539",
    "gebiet": 9
  },
  {
    "plz": "80634",
    "gebiet": 9
  },
  {
    "plz": "80636",
    "gebiet": 9
  },
  {
    "plz": "80637",
    "gebiet": 9
  },
  {
    "plz": "80639",
    "gebiet": 9
  },
  {
    "plz": "80686",
    "gebiet": 9
  },
  {
    "plz": "80687",
    "gebiet": 9
  },
  {
    "plz": "80689",
    "gebiet": 9
  },
  {
    "plz": "80707",
    "gebiet": 9
  },
  {
    "plz": "80796",
    "gebiet": 9
  },
  {
    "plz": "80797",
    "gebiet": 9
  },
  {
    "plz": "80798",
    "gebiet": 9
  },
  {
    "plz": "80799",
    "gebiet": 9
  },
  {
    "plz": "80801",
    "gebiet": 9
  },
  {
    "plz": "80802",
    "gebiet": 9
  },
  {
    "plz": "80803",
    "gebiet": 9
  },
  {
    "plz": "80804",
    "gebiet": 9
  },
  {
    "plz": "80805",
    "gebiet": 9
  },
  {
    "plz": "80807",
    "gebiet": 9
  },
  {
    "plz": "80809",
    "gebiet": 9
  },
  {
    "plz": "80933",
    "gebiet": 9
  },
  {
    "plz": "80935",
    "gebiet": 9
  },
  {
    "plz": "80939",
    "gebiet": 9
  },
  {
    "plz": "80992",
    "gebiet": 9
  },
  {
    "plz": "80993",
    "gebiet": 9
  },
  {
    "plz": "80997",
    "gebiet": 9
  },
  {
    "plz": "80999",
    "gebiet": 9
  },
  {
    "plz": "81241",
    "gebiet": 9
  },
  {
    "plz": "81243",
    "gebiet": 9
  },
  {
    "plz": "81245",
    "gebiet": 9
  },
  {
    "plz": "81247",
    "gebiet": 9
  },
  {
    "plz": "81249",
    "gebiet": 9
  },
  {
    "plz": "81369",
    "gebiet": 9
  },
  {
    "plz": "81371",
    "gebiet": 9
  },
  {
    "plz": "81373",
    "gebiet": 9
  },
  {
    "plz": "81375",
    "gebiet": 9
  },
  {
    "plz": "81377",
    "gebiet": 9
  },
  {
    "plz": "81379",
    "gebiet": 9
  },
  {
    "plz": "81476",
    "gebiet": 9
  },
  {
    "plz": "81477",
    "gebiet": 9
  },
  {
    "plz": "81539",
    "gebiet": 9
  },
  {
    "plz": "81541",
    "gebiet": 9
  },
  {
    "plz": "81543",
    "gebiet": 9
  },
  {
    "plz": "81545",
    "gebiet": 9
  },
  {
    "plz": "81547",
    "gebiet": 9
  },
  {
    "plz": "81549",
    "gebiet": 9
  },
  {
    "plz": "81633",
    "gebiet": 9
  },
  {
    "plz": "81634",
    "gebiet": 9
  },
  {
    "plz": "81669",
    "gebiet": 9
  },
  {
    "plz": "81671",
    "gebiet": 9
  },
  {
    "plz": "81673",
    "gebiet": 9
  },
  {
    "plz": "81675",
    "gebiet": 9
  },
  {
    "plz": "81677",
    "gebiet": 9
  },
  {
    "plz": "81679",
    "gebiet": 9
  },
  {
    "plz": "81707",
    "gebiet": 9
  },
  {
    "plz": "81735",
    "gebiet": 9
  },
  {
    "plz": "81737",
    "gebiet": 9
  },
  {
    "plz": "81739",
    "gebiet": 9
  },
  {
    "plz": "81825",
    "gebiet": 9
  },
  {
    "plz": "81827",
    "gebiet": 9
  },
  {
    "plz": "81829",
    "gebiet": 9
  },
  {
    "plz": "81925",
    "gebiet": 9
  },
  {
    "plz": "81927",
    "gebiet": 9
  },
  {
    "plz": "81929",
    "gebiet": 9
  },
  {
    "plz": "82002",
    "gebiet": 9
  },
  {
    "plz": "82008",
    "gebiet": 9
  },
  {
    "plz": "82018",
    "gebiet": 9
  },
  {
    "plz": "82024",
    "gebiet": 9
  },
  {
    "plz": "82031",
    "gebiet": 9
  },
  {
    "plz": "82041",
    "gebiet": 9
  },
  {
    "plz": "82054",
    "gebiet": 9
  },
  {
    "plz": "82057",
    "gebiet": 9
  },
  {
    "plz": "82061",
    "gebiet": 9
  },
  {
    "plz": "82065",
    "gebiet": 9
  },
  {
    "plz": "82110",
    "gebiet": 9
  },
  {
    "plz": "82131",
    "gebiet": 9
  },
  {
    "plz": "82140",
    "gebiet": 9
  },
  {
    "plz": "82152",
    "gebiet": 9
  },
  {
    "plz": "82166",
    "gebiet": 9
  },
  {
    "plz": "82178",
    "gebiet": 9
  },
  {
    "plz": "82181",
    "gebiet": 9
  },
  {
    "plz": "82194",
    "gebiet": 9
  },
  {
    "plz": "82205",
    "gebiet": 9
  },
  {
    "plz": "82211",
    "gebiet": 9
  },
  {
    "plz": "82216",
    "gebiet": 9
  },
  {
    "plz": "82223",
    "gebiet": 9
  },
  {
    "plz": "82229",
    "gebiet": 9
  },
  {
    "plz": "82237",
    "gebiet": 9
  },
  {
    "plz": "82239",
    "gebiet": 9
  },
  {
    "plz": "82256",
    "gebiet": 9
  },
  {
    "plz": "82266",
    "gebiet": 9
  },
  {
    "plz": "82272",
    "gebiet": 9
  },
  {
    "plz": "82275",
    "gebiet": 9
  },
  {
    "plz": "82284",
    "gebiet": 9
  },
  {
    "plz": "82291",
    "gebiet": 9
  },
  {
    "plz": "82299",
    "gebiet": 9
  },
  {
    "plz": "82319",
    "gebiet": 9
  },
  {
    "plz": "82327",
    "gebiet": 9
  },
  {
    "plz": "82335",
    "gebiet": 9
  },
  {
    "plz": "82340",
    "gebiet": 9
  },
  {
    "plz": "82362",
    "gebiet": 9
  },
  {
    "plz": "82373",
    "gebiet": 9
  },
  {
    "plz": "82377",
    "gebiet": 9
  },
  {
    "plz": "82380",
    "gebiet": 9
  },
  {
    "plz": "82383",
    "gebiet": 9
  },
  {
    "plz": "82389",
    "gebiet": 9
  },
  {
    "plz": "82390",
    "gebiet": 9
  },
  {
    "plz": "82393",
    "gebiet": 9
  },
  {
    "plz": "82396",
    "gebiet": 9
  },
  {
    "plz": "82398",
    "gebiet": 9
  },
  {
    "plz": "82405",
    "gebiet": 9
  },
  {
    "plz": "82418",
    "gebiet": 9
  },
  {
    "plz": "82432",
    "gebiet": 9
  },
  {
    "plz": "82467",
    "gebiet": 9
  },
  {
    "plz": "82477",
    "gebiet": 9
  },
  {
    "plz": "82488",
    "gebiet": 9
  },
  {
    "plz": "82515",
    "gebiet": 9
  },
  {
    "plz": "82538",
    "gebiet": 9
  },
  {
    "plz": "82541",
    "gebiet": 9
  },
  {
    "plz": "82547",
    "gebiet": 9
  },
  {
    "plz": "83022",
    "gebiet": 9
  },
  {
    "plz": "83024",
    "gebiet": 9
  },
  {
    "plz": "83026",
    "gebiet": 9
  },
  {
    "plz": "83043",
    "gebiet": 9
  },
  {
    "plz": "83044",
    "gebiet": 9
  },
  {
    "plz": "83052",
    "gebiet": 9
  },
  {
    "plz": "83059",
    "gebiet": 9
  },
  {
    "plz": "83064",
    "gebiet": 9
  },
  {
    "plz": "83071",
    "gebiet": 9
  },
  {
    "plz": "83083",
    "gebiet": 9
  },
  {
    "plz": "83093",
    "gebiet": 9
  },
  {
    "plz": "83098",
    "gebiet": 9
  },
  {
    "plz": "83101",
    "gebiet": 9
  },
  {
    "plz": "83104",
    "gebiet": 9
  },
  {
    "plz": "83134",
    "gebiet": 9
  },
  {
    "plz": "83137",
    "gebiet": 9
  },
  {
    "plz": "83209",
    "gebiet": 9
  },
  {
    "plz": "83224",
    "gebiet": 9
  },
  {
    "plz": "83229",
    "gebiet": 9
  },
  {
    "plz": "83236",
    "gebiet": 9
  },
  {
    "plz": "83242",
    "gebiet": 9
  },
  {
    "plz": "83246",
    "gebiet": 9
  },
  {
    "plz": "83250",
    "gebiet": 9
  },
  {
    "plz": "83278",
    "gebiet": 9
  },
  {
    "plz": "83301",
    "gebiet": 9
  },
  {
    "plz": "83308",
    "gebiet": 9
  },
  {
    "plz": "83313",
    "gebiet": 9
  },
  {
    "plz": "83317",
    "gebiet": 9
  },
  {
    "plz": "83324",
    "gebiet": 9
  },
  {
    "plz": "83329",
    "gebiet": 9
  },
  {
    "plz": "83339",
    "gebiet": 9
  },
  {
    "plz": "83346",
    "gebiet": 9
  },
  {
    "plz": "83362",
    "gebiet": 9
  },
  {
    "plz": "83370",
    "gebiet": 9
  },
  {
    "plz": "83374",
    "gebiet": 9
  },
  {
    "plz": "83376",
    "gebiet": 9
  },
  {
    "plz": "83379",
    "gebiet": 9
  },
  {
    "plz": "83395",
    "gebiet": 9
  },
  {
    "plz": "83404",
    "gebiet": 9
  },
  {
    "plz": "83410",
    "gebiet": 9
  },
  {
    "plz": "83416",
    "gebiet": 9
  },
  {
    "plz": "83435",
    "gebiet": 9
  },
  {
    "plz": "83454",
    "gebiet": 9
  },
  {
    "plz": "83471",
    "gebiet": 9
  },
  {
    "plz": "83483",
    "gebiet": 9
  },
  {
    "plz": "83512",
    "gebiet": 9
  },
  {
    "plz": "83527",
    "gebiet": 9
  },
  {
    "plz": "83530",
    "gebiet": 9
  },
  {
    "plz": "83533",
    "gebiet": 9
  },
  {
    "plz": "83539",
    "gebiet": 9
  },
  {
    "plz": "83544",
    "gebiet": 9
  },
  {
    "plz": "83549",
    "gebiet": 9
  },
  {
    "plz": "83550",
    "gebiet": 9
  },
  {
    "plz": "83555",
    "gebiet": 9
  },
  {
    "plz": "83556",
    "gebiet": 9
  },
  {
    "plz": "83561",
    "gebiet": 9
  },
  {
    "plz": "83562",
    "gebiet": 9
  },
  {
    "plz": "83569",
    "gebiet": 9
  },
  {
    "plz": "83601",
    "gebiet": 9
  },
  {
    "plz": "83607",
    "gebiet": 9
  },
  {
    "plz": "83620",
    "gebiet": 9
  },
  {
    "plz": "83626",
    "gebiet": 9
  },
  {
    "plz": "83627",
    "gebiet": 9
  },
  {
    "plz": "83646",
    "gebiet": 9
  },
  {
    "plz": "83661",
    "gebiet": 9
  },
  {
    "plz": "83666",
    "gebiet": 9
  },
  {
    "plz": "83674",
    "gebiet": 9
  },
  {
    "plz": "83679",
    "gebiet": 9
  },
  {
    "plz": "83684",
    "gebiet": 9
  },
  {
    "plz": "83700",
    "gebiet": 9
  },
  {
    "plz": "83714",
    "gebiet": 9
  },
  {
    "plz": "83727",
    "gebiet": 9
  },
  {
    "plz": "83734",
    "gebiet": 9
  },
  {
    "plz": "83737",
    "gebiet": 9
  },
  {
    "plz": "84028",
    "gebiet": 7
  },
  {
    "plz": "84030",
    "gebiet": 7
  },
  {
    "plz": "84032",
    "gebiet": 7
  },
  {
    "plz": "84034",
    "gebiet": 7
  },
  {
    "plz": "84036",
    "gebiet": 7
  },
  {
    "plz": "84056",
    "gebiet": 7
  },
  {
    "plz": "84066",
    "gebiet": 7
  },
  {
    "plz": "84069",
    "gebiet": 7
  },
  {
    "plz": "84076",
    "gebiet": 7
  },
  {
    "plz": "84082",
    "gebiet": 7
  },
  {
    "plz": "84088",
    "gebiet": 7
  },
  {
    "plz": "84089",
    "gebiet": 7
  },
  {
    "plz": "84095",
    "gebiet": 7
  },
  {
    "plz": "84098",
    "gebiet": 7
  },
  {
    "plz": "84104",
    "gebiet": 7
  },
  {
    "plz": "84109",
    "gebiet": 7
  },
  {
    "plz": "84130",
    "gebiet": 7
  },
  {
    "plz": "84137",
    "gebiet": 7
  },
  {
    "plz": "84140",
    "gebiet": 7
  },
  {
    "plz": "84149",
    "gebiet": 7
  },
  {
    "plz": "84160",
    "gebiet": 7
  },
  {
    "plz": "84163",
    "gebiet": 7
  },
  {
    "plz": "84174",
    "gebiet": 7
  },
  {
    "plz": "84178",
    "gebiet": 7
  },
  {
    "plz": "84183",
    "gebiet": 7
  },
  {
    "plz": "84307",
    "gebiet": 9
  },
  {
    "plz": "84332",
    "gebiet": 9
  },
  {
    "plz": "84335",
    "gebiet": 9
  },
  {
    "plz": "84339",
    "gebiet": 9
  },
  {
    "plz": "84347",
    "gebiet": 9
  },
  {
    "plz": "84359",
    "gebiet": 9
  },
  {
    "plz": "84367",
    "gebiet": 9
  },
  {
    "plz": "84371",
    "gebiet": 9
  },
  {
    "plz": "84381",
    "gebiet": 9
  },
  {
    "plz": "84387",
    "gebiet": 9
  },
  {
    "plz": "84405",
    "gebiet": 9
  },
  {
    "plz": "84416",
    "gebiet": 9
  },
  {
    "plz": "84419",
    "gebiet": 9
  },
  {
    "plz": "84427",
    "gebiet": 9
  },
  {
    "plz": "84453",
    "gebiet": 9
  },
  {
    "plz": "84478",
    "gebiet": 9
  },
  {
    "plz": "84489",
    "gebiet": 9
  },
  {
    "plz": "84494",
    "gebiet": 9
  },
  {
    "plz": "84503",
    "gebiet": 9
  },
  {
    "plz": "84508",
    "gebiet": 9
  },
  {
    "plz": "84513",
    "gebiet": 9
  },
  {
    "plz": "84529",
    "gebiet": 9
  },
  {
    "plz": "84533",
    "gebiet": 9
  },
  {
    "plz": "84543",
    "gebiet": 9
  },
  {
    "plz": "84547",
    "gebiet": 9
  },
  {
    "plz": "84550",
    "gebiet": 9
  },
  {
    "plz": "84556",
    "gebiet": 9
  },
  {
    "plz": "84559",
    "gebiet": 9
  },
  {
    "plz": "84562",
    "gebiet": 9
  },
  {
    "plz": "84567",
    "gebiet": 9
  },
  {
    "plz": "84570",
    "gebiet": 9
  },
  {
    "plz": "84577",
    "gebiet": 9
  },
  {
    "plz": "85049",
    "gebiet": 7
  },
  {
    "plz": "85051",
    "gebiet": 7
  },
  {
    "plz": "85053",
    "gebiet": 7
  },
  {
    "plz": "85055",
    "gebiet": 7
  },
  {
    "plz": "85057",
    "gebiet": 7
  },
  {
    "plz": "85072",
    "gebiet": 7
  },
  {
    "plz": "85077",
    "gebiet": 7
  },
  {
    "plz": "85084",
    "gebiet": 7
  },
  {
    "plz": "85088",
    "gebiet": 7
  },
  {
    "plz": "85092",
    "gebiet": 7
  },
  {
    "plz": "85095",
    "gebiet": 7
  },
  {
    "plz": "85101",
    "gebiet": 7
  },
  {
    "plz": "85110",
    "gebiet": 7
  },
  {
    "plz": "85114",
    "gebiet": 7
  },
  {
    "plz": "85116",
    "gebiet": 7
  },
  {
    "plz": "85117",
    "gebiet": 7
  },
  {
    "plz": "85123",
    "gebiet": 7
  },
  {
    "plz": "85131",
    "gebiet": 7
  },
  {
    "plz": "85221",
    "gebiet": 9
  },
  {
    "plz": "85229",
    "gebiet": 9
  },
  {
    "plz": "85232",
    "gebiet": 9
  },
  {
    "plz": "85250",
    "gebiet": 9
  },
  {
    "plz": "85256",
    "gebiet": 9
  },
  {
    "plz": "85259",
    "gebiet": 9
  },
  {
    "plz": "85261",
    "gebiet": 9
  },
  {
    "plz": "85276",
    "gebiet": 9
  },
  {
    "plz": "85283",
    "gebiet": 9
  },
  {
    "plz": "85290",
    "gebiet": 9
  },
  {
    "plz": "85293",
    "gebiet": 9
  },
  {
    "plz": "85298",
    "gebiet": 9
  },
  {
    "plz": "85301",
    "gebiet": 9
  },
  {
    "plz": "85302",
    "gebiet": 9
  },
  {
    "plz": "85307",
    "gebiet": 9
  },
  {
    "plz": "85354",
    "gebiet": 9
  },
  {
    "plz": "85368",
    "gebiet": 9
  },
  {
    "plz": "85375",
    "gebiet": 9
  },
  {
    "plz": "85376",
    "gebiet": 9
  },
  {
    "plz": "85386",
    "gebiet": 9
  },
  {
    "plz": "85399",
    "gebiet": 9
  },
  {
    "plz": "85405",
    "gebiet": 9
  },
  {
    "plz": "85406",
    "gebiet": 9
  },
  {
    "plz": "85408",
    "gebiet": 9
  },
  {
    "plz": "85419",
    "gebiet": 9
  },
  {
    "plz": "85435",
    "gebiet": 9
  },
  {
    "plz": "85445",
    "gebiet": 9
  },
  {
    "plz": "85452",
    "gebiet": 9
  },
  {
    "plz": "85461",
    "gebiet": 9
  },
  {
    "plz": "85464",
    "gebiet": 9
  },
  {
    "plz": "85521",
    "gebiet": 9
  },
  {
    "plz": "85540",
    "gebiet": 9
  },
  {
    "plz": "85551",
    "gebiet": 9
  },
  {
    "plz": "85560",
    "gebiet": 9
  },
  {
    "plz": "85567",
    "gebiet": 9
  },
  {
    "plz": "85570",
    "gebiet": 9
  },
  {
    "plz": "85579",
    "gebiet": 9
  },
  {
    "plz": "85586",
    "gebiet": 9
  },
  {
    "plz": "85591",
    "gebiet": 9
  },
  {
    "plz": "85599",
    "gebiet": 9
  },
  {
    "plz": "85604",
    "gebiet": 9
  },
  {
    "plz": "85609",
    "gebiet": 9
  },
  {
    "plz": "85614",
    "gebiet": 9
  },
  {
    "plz": "85617",
    "gebiet": 9
  },
  {
    "plz": "85622",
    "gebiet": 9
  },
  {
    "plz": "85630",
    "gebiet": 9
  },
  {
    "plz": "85635",
    "gebiet": 9
  },
  {
    "plz": "85640",
    "gebiet": 9
  },
  {
    "plz": "85646",
    "gebiet": 9
  },
  {
    "plz": "85649",
    "gebiet": 9
  },
  {
    "plz": "85652",
    "gebiet": 9
  },
  {
    "plz": "85658",
    "gebiet": 9
  },
  {
    "plz": "85659",
    "gebiet": 9
  },
  {
    "plz": "85662",
    "gebiet": 9
  },
  {
    "plz": "85664",
    "gebiet": 9
  },
  {
    "plz": "85716",
    "gebiet": 9
  },
  {
    "plz": "85737",
    "gebiet": 9
  },
  {
    "plz": "85748",
    "gebiet": 9
  },
  {
    "plz": "85757",
    "gebiet": 9
  },
  {
    "plz": "85764",
    "gebiet": 9
  },
  {
    "plz": "85774",
    "gebiet": 9
  },
  {
    "plz": "85777",
    "gebiet": 9
  },
  {
    "plz": "86150",
    "gebiet": 9
  },
  {
    "plz": "86152",
    "gebiet": 9
  },
  {
    "plz": "86153",
    "gebiet": 9
  },
  {
    "plz": "86156",
    "gebiet": 9
  },
  {
    "plz": "86157",
    "gebiet": 9
  },
  {
    "plz": "86159",
    "gebiet": 9
  },
  {
    "plz": "86161",
    "gebiet": 9
  },
  {
    "plz": "86163",
    "gebiet": 9
  },
  {
    "plz": "86167",
    "gebiet": 9
  },
  {
    "plz": "86179",
    "gebiet": 9
  },
  {
    "plz": "86199",
    "gebiet": 9
  },
  {
    "plz": "86316",
    "gebiet": 9
  },
  {
    "plz": "86343",
    "gebiet": 9
  },
  {
    "plz": "86356",
    "gebiet": 9
  },
  {
    "plz": "86368",
    "gebiet": 9
  },
  {
    "plz": "86381",
    "gebiet": 9
  },
  {
    "plz": "86391",
    "gebiet": 9
  },
  {
    "plz": "86399",
    "gebiet": 9
  },
  {
    "plz": "86405",
    "gebiet": 9
  },
  {
    "plz": "86415",
    "gebiet": 9
  },
  {
    "plz": "86420",
    "gebiet": 9
  },
  {
    "plz": "86438",
    "gebiet": 9
  },
  {
    "plz": "86441",
    "gebiet": 9
  },
  {
    "plz": "86447",
    "gebiet": 9
  },
  {
    "plz": "86453",
    "gebiet": 9
  },
  {
    "plz": "86456",
    "gebiet": 9
  },
  {
    "plz": "86462",
    "gebiet": 9
  },
  {
    "plz": "86465",
    "gebiet": 9
  },
  {
    "plz": "86473",
    "gebiet": 9
  },
  {
    "plz": "86477",
    "gebiet": 9
  },
  {
    "plz": "86485",
    "gebiet": 9
  },
  {
    "plz": "86486",
    "gebiet": 9
  },
  {
    "plz": "86492",
    "gebiet": 9
  },
  {
    "plz": "86497",
    "gebiet": 9
  },
  {
    "plz": "86507",
    "gebiet": 9
  },
  {
    "plz": "86508",
    "gebiet": 9
  },
  {
    "plz": "86514",
    "gebiet": 9
  },
  {
    "plz": "86519",
    "gebiet": 9
  },
  {
    "plz": "86529",
    "gebiet": 9
  },
  {
    "plz": "86551",
    "gebiet": 9
  },
  {
    "plz": "86554",
    "gebiet": 9
  },
  {
    "plz": "86556",
    "gebiet": 9
  },
  {
    "plz": "86559",
    "gebiet": 9
  },
  {
    "plz": "86565",
    "gebiet": 9
  },
  {
    "plz": "86570",
    "gebiet": 9
  },
  {
    "plz": "86577",
    "gebiet": 9
  },
  {
    "plz": "86609",
    "gebiet": 9
  },
  {
    "plz": "86633",
    "gebiet": 9
  },
  {
    "plz": "86637",
    "gebiet": 9
  },
  {
    "plz": "86655",
    "gebiet": 9
  },
  {
    "plz": "86663",
    "gebiet": 9
  },
  {
    "plz": "86669",
    "gebiet": 9
  },
  {
    "plz": "86673",
    "gebiet": 9
  },
  {
    "plz": "86675",
    "gebiet": 9
  },
  {
    "plz": "86676",
    "gebiet": 9
  },
  {
    "plz": "86679",
    "gebiet": 9
  },
  {
    "plz": "86682",
    "gebiet": 9
  },
  {
    "plz": "86684",
    "gebiet": 9
  },
  {
    "plz": "86690",
    "gebiet": 9
  },
  {
    "plz": "86695",
    "gebiet": 9
  },
  {
    "plz": "86698",
    "gebiet": 9
  },
  {
    "plz": "86701",
    "gebiet": 9
  },
  {
    "plz": "86720",
    "gebiet": 7
  },
  {
    "plz": "86732",
    "gebiet": 7
  },
  {
    "plz": "86748",
    "gebiet": 7
  },
  {
    "plz": "86756",
    "gebiet": 7
  },
  {
    "plz": "86757",
    "gebiet": 7
  },
  {
    "plz": "86807",
    "gebiet": 9
  },
  {
    "plz": "86825",
    "gebiet": 9
  },
  {
    "plz": "86830",
    "gebiet": 9
  },
  {
    "plz": "86833",
    "gebiet": 9
  },
  {
    "plz": "86836",
    "gebiet": 9
  },
  {
    "plz": "86842",
    "gebiet": 9
  },
  {
    "plz": "86850",
    "gebiet": 9
  },
  {
    "plz": "86859",
    "gebiet": 9
  },
  {
    "plz": "86872",
    "gebiet": 9
  },
  {
    "plz": "86874",
    "gebiet": 9
  },
  {
    "plz": "86881",
    "gebiet": 9
  },
  {
    "plz": "86899",
    "gebiet": 9
  },
  {
    "plz": "86911",
    "gebiet": 9
  },
  {
    "plz": "86919",
    "gebiet": 9
  },
  {
    "plz": "86923",
    "gebiet": 9
  },
  {
    "plz": "86925",
    "gebiet": 9
  },
  {
    "plz": "86931",
    "gebiet": 9
  },
  {
    "plz": "86938",
    "gebiet": 9
  },
  {
    "plz": "86946",
    "gebiet": 9
  },
  {
    "plz": "86956",
    "gebiet": 9
  },
  {
    "plz": "86971",
    "gebiet": 9
  },
  {
    "plz": "86983",
    "gebiet": 9
  },
  {
    "plz": "87435",
    "gebiet": 9
  },
  {
    "plz": "87437",
    "gebiet": 9
  },
  {
    "plz": "87439",
    "gebiet": 9
  },
  {
    "plz": "87452",
    "gebiet": 9
  },
  {
    "plz": "87463",
    "gebiet": 9
  },
  {
    "plz": "87474",
    "gebiet": 9
  },
  {
    "plz": "87490",
    "gebiet": 9
  },
  {
    "plz": "87496",
    "gebiet": 9
  },
  {
    "plz": "87509",
    "gebiet": 9
  },
  {
    "plz": "87527",
    "gebiet": 9
  },
  {
    "plz": "87534",
    "gebiet": 9
  },
  {
    "plz": "87538",
    "gebiet": 9
  },
  {
    "plz": "87541",
    "gebiet": 9
  },
  {
    "plz": "87544",
    "gebiet": 9
  },
  {
    "plz": "87549",
    "gebiet": 9
  },
  {
    "plz": "87561",
    "gebiet": 9
  },
  {
    "plz": "87573",
    "gebiet": 9
  },
  {
    "plz": "87600",
    "gebiet": 9
  },
  {
    "plz": "87616",
    "gebiet": 9
  },
  {
    "plz": "87629",
    "gebiet": 9
  },
  {
    "plz": "87634",
    "gebiet": 9
  },
  {
    "plz": "87647",
    "gebiet": 9
  },
  {
    "plz": "87656",
    "gebiet": 9
  },
  {
    "plz": "87660",
    "gebiet": 9
  },
  {
    "plz": "87666",
    "gebiet": 9
  },
  {
    "plz": "87671",
    "gebiet": 9
  },
  {
    "plz": "87677",
    "gebiet": 9
  },
  {
    "plz": "87700",
    "gebiet": 9
  },
  {
    "plz": "87724",
    "gebiet": 9
  },
  {
    "plz": "87727",
    "gebiet": 9
  },
  {
    "plz": "87730",
    "gebiet": 9
  },
  {
    "plz": "87740",
    "gebiet": 9
  },
  {
    "plz": "87748",
    "gebiet": 9
  },
  {
    "plz": "87757",
    "gebiet": 9
  },
  {
    "plz": "87758",
    "gebiet": 9
  },
  {
    "plz": "87766",
    "gebiet": 9
  },
  {
    "plz": "87778",
    "gebiet": 9
  },
  {
    "plz": "87784",
    "gebiet": 9
  },
  {
    "plz": "87785",
    "gebiet": 9
  },
  {
    "plz": "87787",
    "gebiet": 9
  },
  {
    "plz": "88045",
    "gebiet": 9
  },
  {
    "plz": "88046",
    "gebiet": 9
  },
  {
    "plz": "88048",
    "gebiet": 9
  },
  {
    "plz": "88069",
    "gebiet": 9
  },
  {
    "plz": "88074",
    "gebiet": 9
  },
  {
    "plz": "88079",
    "gebiet": 9
  },
  {
    "plz": "88085",
    "gebiet": 9
  },
  {
    "plz": "88090",
    "gebiet": 8
  },
  {
    "plz": "88094",
    "gebiet": 8
  },
  {
    "plz": "88131",
    "gebiet": 9
  },
  {
    "plz": "88138",
    "gebiet": 9
  },
  {
    "plz": "88142",
    "gebiet": 9
  },
  {
    "plz": "88153",
    "gebiet": 9
  },
  {
    "plz": "88171",
    "gebiet": 9
  },
  {
    "plz": "88175",
    "gebiet": 9
  },
  {
    "plz": "88212",
    "gebiet": 9
  },
  {
    "plz": "88213",
    "gebiet": 9
  },
  {
    "plz": "88214",
    "gebiet": 9
  },
  {
    "plz": "88239",
    "gebiet": 9
  },
  {
    "plz": "88250",
    "gebiet": 9
  },
  {
    "plz": "88255",
    "gebiet": 9
  },
  {
    "plz": "88263",
    "gebiet": 8
  },
  {
    "plz": "88267",
    "gebiet": 9
  },
  {
    "plz": "88276",
    "gebiet": 9
  },
  {
    "plz": "88285",
    "gebiet": 9
  },
  {
    "plz": "88299",
    "gebiet": 9
  },
  {
    "plz": "88316",
    "gebiet": 9
  },
  {
    "plz": "88321",
    "gebiet": 9
  },
  {
    "plz": "88326",
    "gebiet": 9
  },
  {
    "plz": "88339",
    "gebiet": 9
  },
  {
    "plz": "88348",
    "gebiet": 8
  },
  {
    "plz": "88353",
    "gebiet": 9
  },
  {
    "plz": "88367",
    "gebiet": 8
  },
  {
    "plz": "88368",
    "gebiet": 9
  },
  {
    "plz": "88370",
    "gebiet": 8
  },
  {
    "plz": "88371",
    "gebiet": 9
  },
  {
    "plz": "88400",
    "gebiet": 9
  },
  {
    "plz": "88422",
    "gebiet": 9
  },
  {
    "plz": "88437",
    "gebiet": 9
  },
  {
    "plz": "88444",
    "gebiet": 9
  },
  {
    "plz": "88447",
    "gebiet": 9
  },
  {
    "plz": "88453",
    "gebiet": 9
  },
  {
    "plz": "88471",
    "gebiet": 9
  },
  {
    "plz": "88483",
    "gebiet": 9
  },
  {
    "plz": "88487",
    "gebiet": 9
  },
  {
    "plz": "88499",
    "gebiet": 8
  },
  {
    "plz": "88512",
    "gebiet": 8
  },
  {
    "plz": "88518",
    "gebiet": 8
  },
  {
    "plz": "88524",
    "gebiet": 9
  },
  {
    "plz": "88525",
    "gebiet": 8
  },
  {
    "plz": "88527",
    "gebiet": 8
  },
  {
    "plz": "88630",
    "gebiet": 8
  },
  {
    "plz": "88634",
    "gebiet": 8
  },
  {
    "plz": "88639",
    "gebiet": 8
  },
  {
    "plz": "88662",
    "gebiet": 8
  },
  {
    "plz": "88677",
    "gebiet": 8
  },
  {
    "plz": "88682",
    "gebiet": 8
  },
  {
    "plz": "88696",
    "gebiet": 8
  },
  {
    "plz": "88719",
    "gebiet": 8
  },
  {
    "plz": "89073",
    "gebiet": 9
  },
  {
    "plz": "89075",
    "gebiet": 9
  },
  {
    "plz": "89077",
    "gebiet": 9
  },
  {
    "plz": "89079",
    "gebiet": 9
  },
  {
    "plz": "89081",
    "gebiet": 9
  },
  {
    "plz": "89134",
    "gebiet": 9
  },
  {
    "plz": "89143",
    "gebiet": 9
  },
  {
    "plz": "89150",
    "gebiet": 9
  },
  {
    "plz": "89171",
    "gebiet": 9
  },
  {
    "plz": "89186",
    "gebiet": 9
  },
  {
    "plz": "89231",
    "gebiet": 9
  },
  {
    "plz": "89233",
    "gebiet": 9
  },
  {
    "plz": "89250",
    "gebiet": 9
  },
  {
    "plz": "89257",
    "gebiet": 9
  },
  {
    "plz": "89264",
    "gebiet": 9
  },
  {
    "plz": "89266",
    "gebiet": 9
  },
  {
    "plz": "89269",
    "gebiet": 9
  },
  {
    "plz": "89275",
    "gebiet": 9
  },
  {
    "plz": "89278",
    "gebiet": 9
  },
  {
    "plz": "89281",
    "gebiet": 9
  },
  {
    "plz": "89284",
    "gebiet": 9
  },
  {
    "plz": "89287",
    "gebiet": 9
  },
  {
    "plz": "89294",
    "gebiet": 9
  },
  {
    "plz": "89312",
    "gebiet": 9
  },
  {
    "plz": "89331",
    "gebiet": 9
  },
  {
    "plz": "89340",
    "gebiet": 9
  },
  {
    "plz": "89343",
    "gebiet": 9
  },
  {
    "plz": "89344",
    "gebiet": 9
  },
  {
    "plz": "89349",
    "gebiet": 9
  },
  {
    "plz": "89355",
    "gebiet": 9
  },
  {
    "plz": "89358",
    "gebiet": 9
  },
  {
    "plz": "89407",
    "gebiet": 9
  },
  {
    "plz": "89415",
    "gebiet": 9
  },
  {
    "plz": "89423",
    "gebiet": 9
  },
  {
    "plz": "89431",
    "gebiet": 9
  },
  {
    "plz": "89438",
    "gebiet": 9
  },
  {
    "plz": "89518",
    "gebiet": 7
  },
  {
    "plz": "89520",
    "gebiet": 7
  },
  {
    "plz": "89522",
    "gebiet": 7
  },
  {
    "plz": "89547",
    "gebiet": 9
  },
  {
    "plz": "89551",
    "gebiet": 9
  },
  {
    "plz": "89558",
    "gebiet": 9
  },
  {
    "plz": "89561",
    "gebiet": 7
  },
  {
    "plz": "89564",
    "gebiet": 7
  },
  {
    "plz": "89584",
    "gebiet": 9
  },
  {
    "plz": "89601",
    "gebiet": 9
  },
  {
    "plz": "89604",
    "gebiet": 9
  },
  {
    "plz": "89613",
    "gebiet": 9
  },
  {
    "plz": "89614",
    "gebiet": 9
  },
  {
    "plz": "89616",
    "gebiet": 9
  },
  {
    "plz": "90010",
    "gebiet": 9
  },
  {
    "plz": "90267",
    "gebiet": 9
  },
  {
    "plz": "90402",
    "gebiet": 7
  },
  {
    "plz": "90403",
    "gebiet": 7
  },
  {
    "plz": "90408",
    "gebiet": 7
  },
  {
    "plz": "90409",
    "gebiet": 7
  },
  {
    "plz": "90411",
    "gebiet": 7
  },
  {
    "plz": "90419",
    "gebiet": 7
  },
  {
    "plz": "90425",
    "gebiet": 7
  },
  {
    "plz": "90427",
    "gebiet": 7
  },
  {
    "plz": "90429",
    "gebiet": 7
  },
  {
    "plz": "90439",
    "gebiet": 7
  },
  {
    "plz": "90441",
    "gebiet": 7
  },
  {
    "plz": "90443",
    "gebiet": 7
  },
  {
    "plz": "90449",
    "gebiet": 7
  },
  {
    "plz": "90451",
    "gebiet": 7
  },
  {
    "plz": "90453",
    "gebiet": 7
  },
  {
    "plz": "90455",
    "gebiet": 7
  },
  {
    "plz": "90459",
    "gebiet": 7
  },
  {
    "plz": "90461",
    "gebiet": 7
  },
  {
    "plz": "90469",
    "gebiet": 7
  },
  {
    "plz": "90471",
    "gebiet": 7
  },
  {
    "plz": "90473",
    "gebiet": 7
  },
  {
    "plz": "90475",
    "gebiet": 7
  },
  {
    "plz": "90480",
    "gebiet": 7
  },
  {
    "plz": "90482",
    "gebiet": 7
  },
  {
    "plz": "90489",
    "gebiet": 7
  },
  {
    "plz": "90491",
    "gebiet": 7
  },
  {
    "plz": "90505",
    "gebiet": 7
  },
  {
    "plz": "90513",
    "gebiet": 7
  },
  {
    "plz": "90518",
    "gebiet": 7
  },
  {
    "plz": "90522",
    "gebiet": 7
  },
  {
    "plz": "90530",
    "gebiet": 7
  },
  {
    "plz": "90537",
    "gebiet": 7
  },
  {
    "plz": "90542",
    "gebiet": 7
  },
  {
    "plz": "90547",
    "gebiet": 7
  },
  {
    "plz": "90552",
    "gebiet": 7
  },
  {
    "plz": "90556",
    "gebiet": 7
  },
  {
    "plz": "90559",
    "gebiet": 7
  },
  {
    "plz": "90562",
    "gebiet": 7
  },
  {
    "plz": "90571",
    "gebiet": 7
  },
  {
    "plz": "90574",
    "gebiet": 7
  },
  {
    "plz": "90575",
    "gebiet": 7
  },
  {
    "plz": "90579",
    "gebiet": 7
  },
  {
    "plz": "90584",
    "gebiet": 7
  },
  {
    "plz": "90587",
    "gebiet": 7
  },
  {
    "plz": "90592",
    "gebiet": 7
  },
  {
    "plz": "90596",
    "gebiet": 7
  },
  {
    "plz": "90607",
    "gebiet": 7
  },
  {
    "plz": "90610",
    "gebiet": 7
  },
  {
    "plz": "90613",
    "gebiet": 7
  },
  {
    "plz": "90616",
    "gebiet": 7
  },
  {
    "plz": "90762",
    "gebiet": 7
  },
  {
    "plz": "90765",
    "gebiet": 7
  },
  {
    "plz": "90766",
    "gebiet": 7
  },
  {
    "plz": "90768",
    "gebiet": 7
  },
  {
    "plz": "91052",
    "gebiet": 7
  },
  {
    "plz": "91054",
    "gebiet": 7
  },
  {
    "plz": "91056",
    "gebiet": 7
  },
  {
    "plz": "91058",
    "gebiet": 7
  },
  {
    "plz": "91074",
    "gebiet": 7
  },
  {
    "plz": "91077",
    "gebiet": 7
  },
  {
    "plz": "91083",
    "gebiet": 7
  },
  {
    "plz": "91086",
    "gebiet": 7
  },
  {
    "plz": "91093",
    "gebiet": 7
  },
  {
    "plz": "91126",
    "gebiet": 7
  },
  {
    "plz": "91154",
    "gebiet": 7
  },
  {
    "plz": "91161",
    "gebiet": 7
  },
  {
    "plz": "91166",
    "gebiet": 7
  },
  {
    "plz": "91171",
    "gebiet": 7
  },
  {
    "plz": "91180",
    "gebiet": 7
  },
  {
    "plz": "91183",
    "gebiet": 7
  },
  {
    "plz": "91187",
    "gebiet": 7
  },
  {
    "plz": "91207",
    "gebiet": 7
  },
  {
    "plz": "91217",
    "gebiet": 7
  },
  {
    "plz": "91220",
    "gebiet": 7
  },
  {
    "plz": "91224",
    "gebiet": 7
  },
  {
    "plz": "91227",
    "gebiet": 7
  },
  {
    "plz": "91230",
    "gebiet": 7
  },
  {
    "plz": "91244",
    "gebiet": 7
  },
  {
    "plz": "91245",
    "gebiet": 7
  },
  {
    "plz": "91257",
    "gebiet": 7
  },
  {
    "plz": "91275",
    "gebiet": 7
  },
  {
    "plz": "91278",
    "gebiet": 7
  },
  {
    "plz": "91301",
    "gebiet": 7
  },
  {
    "plz": "91311",
    "gebiet": 7
  },
  {
    "plz": "91315",
    "gebiet": 7
  },
  {
    "plz": "91322",
    "gebiet": 7
  },
  {
    "plz": "91325",
    "gebiet": 7
  },
  {
    "plz": "91327",
    "gebiet": 7
  },
  {
    "plz": "91330",
    "gebiet": 7
  },
  {
    "plz": "91338",
    "gebiet": 7
  },
  {
    "plz": "91344",
    "gebiet": 7
  },
  {
    "plz": "91346",
    "gebiet": 7
  },
  {
    "plz": "91352",
    "gebiet": 7
  },
  {
    "plz": "91353",
    "gebiet": 7
  },
  {
    "plz": "91359",
    "gebiet": 7
  },
  {
    "plz": "91361",
    "gebiet": 7
  },
  {
    "plz": "91391",
    "gebiet": 7
  },
  {
    "plz": "91413",
    "gebiet": 7
  },
  {
    "plz": "91438",
    "gebiet": 7
  },
  {
    "plz": "91462",
    "gebiet": 7
  },
  {
    "plz": "91471",
    "gebiet": 7
  },
  {
    "plz": "91475",
    "gebiet": 7
  },
  {
    "plz": "91484",
    "gebiet": 7
  },
  {
    "plz": "91522",
    "gebiet": 7
  },
  {
    "plz": "91541",
    "gebiet": 7
  },
  {
    "plz": "91550",
    "gebiet": 7
  },
  {
    "plz": "91555",
    "gebiet": 7
  },
  {
    "plz": "91560",
    "gebiet": 7
  },
  {
    "plz": "91564",
    "gebiet": 7
  },
  {
    "plz": "91567",
    "gebiet": 7
  },
  {
    "plz": "91578",
    "gebiet": 7
  },
  {
    "plz": "91580",
    "gebiet": 7
  },
  {
    "plz": "91604",
    "gebiet": 7
  },
  {
    "plz": "91608",
    "gebiet": 7
  },
  {
    "plz": "91616",
    "gebiet": 7
  },
  {
    "plz": "91623",
    "gebiet": 7
  },
  {
    "plz": "91639",
    "gebiet": 7
  },
  {
    "plz": "91710",
    "gebiet": 7
  },
  {
    "plz": "91723",
    "gebiet": 7
  },
  {
    "plz": "91729",
    "gebiet": 7
  },
  {
    "plz": "91732",
    "gebiet": 7
  },
  {
    "plz": "91738",
    "gebiet": 7
  },
  {
    "plz": "91781",
    "gebiet": 7
  },
  {
    "plz": "91785",
    "gebiet": 7
  },
  {
    "plz": "91788",
    "gebiet": 7
  },
  {
    "plz": "91790",
    "gebiet": 7
  },
  {
    "plz": "91796",
    "gebiet": 7
  },
  {
    "plz": "91801",
    "gebiet": 7
  },
  {
    "plz": "91804",
    "gebiet": 7
  },
  {
    "plz": "92224",
    "gebiet": 7
  },
  {
    "plz": "92232",
    "gebiet": 7
  },
  {
    "plz": "92237",
    "gebiet": 7
  },
  {
    "plz": "92242",
    "gebiet": 7
  },
  {
    "plz": "92245",
    "gebiet": 7
  },
  {
    "plz": "92253",
    "gebiet": 7
  },
  {
    "plz": "92256",
    "gebiet": 7
  },
  {
    "plz": "92262",
    "gebiet": 7
  },
  {
    "plz": "92269",
    "gebiet": 7
  },
  {
    "plz": "92272",
    "gebiet": 7
  },
  {
    "plz": "92277",
    "gebiet": 7
  },
  {
    "plz": "92280",
    "gebiet": 7
  },
  {
    "plz": "92284",
    "gebiet": 7
  },
  {
    "plz": "92287",
    "gebiet": 7
  },
  {
    "plz": "92289",
    "gebiet": 7
  },
  {
    "plz": "92318",
    "gebiet": 7
  },
  {
    "plz": "92331",
    "gebiet": 7
  },
  {
    "plz": "92334",
    "gebiet": 7
  },
  {
    "plz": "92342",
    "gebiet": 7
  },
  {
    "plz": "92348",
    "gebiet": 7
  },
  {
    "plz": "92353",
    "gebiet": 7
  },
  {
    "plz": "92358",
    "gebiet": 7
  },
  {
    "plz": "92363",
    "gebiet": 7
  },
  {
    "plz": "92364",
    "gebiet": 7
  },
  {
    "plz": "92367",
    "gebiet": 7
  },
  {
    "plz": "92369",
    "gebiet": 7
  },
  {
    "plz": "92421",
    "gebiet": 7
  },
  {
    "plz": "92431",
    "gebiet": 7
  },
  {
    "plz": "92436",
    "gebiet": 7
  },
  {
    "plz": "92439",
    "gebiet": 7
  },
  {
    "plz": "92442",
    "gebiet": 7
  },
  {
    "plz": "92444",
    "gebiet": 7
  },
  {
    "plz": "92507",
    "gebiet": 7
  },
  {
    "plz": "92521",
    "gebiet": 7
  },
  {
    "plz": "92526",
    "gebiet": 7
  },
  {
    "plz": "92533",
    "gebiet": 7
  },
  {
    "plz": "92536",
    "gebiet": 7
  },
  {
    "plz": "92542",
    "gebiet": 7
  },
  {
    "plz": "92637",
    "gebiet": 7
  },
  {
    "plz": "92648",
    "gebiet": 7
  },
  {
    "plz": "92655",
    "gebiet": 7
  },
  {
    "plz": "92660",
    "gebiet": 7
  },
  {
    "plz": "92665",
    "gebiet": 7
  },
  {
    "plz": "92681",
    "gebiet": 7
  },
  {
    "plz": "92685",
    "gebiet": 7
  },
  {
    "plz": "92690",
    "gebiet": 7
  },
  {
    "plz": "92693",
    "gebiet": 7
  },
  {
    "plz": "92705",
    "gebiet": 7
  },
  {
    "plz": "92712",
    "gebiet": 7
  },
  {
    "plz": "92718",
    "gebiet": 7
  },
  {
    "plz": "93023",
    "gebiet": 7
  },
  {
    "plz": "93047",
    "gebiet": 7
  },
  {
    "plz": "93049",
    "gebiet": 7
  },
  {
    "plz": "93051",
    "gebiet": 7
  },
  {
    "plz": "93053",
    "gebiet": 7
  },
  {
    "plz": "93055",
    "gebiet": 7
  },
  {
    "plz": "93057",
    "gebiet": 7
  },
  {
    "plz": "93059",
    "gebiet": 7
  },
  {
    "plz": "93073",
    "gebiet": 7
  },
  {
    "plz": "93080",
    "gebiet": 7
  },
  {
    "plz": "93086",
    "gebiet": 7
  },
  {
    "plz": "93089",
    "gebiet": 7
  },
  {
    "plz": "93093",
    "gebiet": 7
  },
  {
    "plz": "93096",
    "gebiet": 7
  },
  {
    "plz": "93098",
    "gebiet": 7
  },
  {
    "plz": "93102",
    "gebiet": 7
  },
  {
    "plz": "93104",
    "gebiet": 7
  },
  {
    "plz": "93105",
    "gebiet": 7
  },
  {
    "plz": "93128",
    "gebiet": 7
  },
  {
    "plz": "93133",
    "gebiet": 7
  },
  {
    "plz": "93138",
    "gebiet": 7
  },
  {
    "plz": "93152",
    "gebiet": 7
  },
  {
    "plz": "93158",
    "gebiet": 7
  },
  {
    "plz": "93170",
    "gebiet": 7
  },
  {
    "plz": "93173",
    "gebiet": 7
  },
  {
    "plz": "93176",
    "gebiet": 7
  },
  {
    "plz": "93179",
    "gebiet": 7
  },
  {
    "plz": "93188",
    "gebiet": 7
  },
  {
    "plz": "93194",
    "gebiet": 7
  },
  {
    "plz": "93197",
    "gebiet": 7
  },
  {
    "plz": "93309",
    "gebiet": 7
  },
  {
    "plz": "93326",
    "gebiet": 7
  },
  {
    "plz": "93333",
    "gebiet": 7
  },
  {
    "plz": "93336",
    "gebiet": 7
  },
  {
    "plz": "93354",
    "gebiet": 7
  },
  {
    "plz": "93413",
    "gebiet": 7
  },
  {
    "plz": "93426",
    "gebiet": 7
  },
  {
    "plz": "93437",
    "gebiet": 7
  },
  {
    "plz": "93444",
    "gebiet": 7
  },
  {
    "plz": "93449",
    "gebiet": 7
  },
  {
    "plz": "93455",
    "gebiet": 7
  },
  {
    "plz": "93458",
    "gebiet": 7
  },
  {
    "plz": "93466",
    "gebiet": 7
  },
  {
    "plz": "93473",
    "gebiet": 7
  },
  {
    "plz": "93479",
    "gebiet": 7
  },
  {
    "plz": "93495",
    "gebiet": 7
  },
  {
    "plz": "94032",
    "gebiet": 9
  },
  {
    "plz": "94034",
    "gebiet": 9
  },
  {
    "plz": "94036",
    "gebiet": 9
  },
  {
    "plz": "94051",
    "gebiet": 9
  },
  {
    "plz": "94060",
    "gebiet": 9
  },
  {
    "plz": "94065",
    "gebiet": 9
  },
  {
    "plz": "94078",
    "gebiet": 9
  },
  {
    "plz": "94081",
    "gebiet": 9
  },
  {
    "plz": "94086",
    "gebiet": 9
  },
  {
    "plz": "94094",
    "gebiet": 9
  },
  {
    "plz": "94104",
    "gebiet": 9
  },
  {
    "plz": "94107",
    "gebiet": 9
  },
  {
    "plz": "94110",
    "gebiet": 9
  },
  {
    "plz": "94113",
    "gebiet": 9
  },
  {
    "plz": "94116",
    "gebiet": 9
  },
  {
    "plz": "94118",
    "gebiet": 9
  },
  {
    "plz": "94121",
    "gebiet": 9
  },
  {
    "plz": "94124",
    "gebiet": 9
  },
  {
    "plz": "94127",
    "gebiet": 9
  },
  {
    "plz": "94130",
    "gebiet": 9
  },
  {
    "plz": "94133",
    "gebiet": 9
  },
  {
    "plz": "94136",
    "gebiet": 9
  },
  {
    "plz": "94137",
    "gebiet": 9
  },
  {
    "plz": "94143",
    "gebiet": 9
  },
  {
    "plz": "94152",
    "gebiet": 9
  },
  {
    "plz": "94161",
    "gebiet": 9
  },
  {
    "plz": "94209",
    "gebiet": 7
  },
  {
    "plz": "94227",
    "gebiet": 7
  },
  {
    "plz": "94234",
    "gebiet": 7
  },
  {
    "plz": "94239",
    "gebiet": 7
  },
  {
    "plz": "94244",
    "gebiet": 7
  },
  {
    "plz": "94249",
    "gebiet": 7
  },
  {
    "plz": "94250",
    "gebiet": 7
  },
  {
    "plz": "94253",
    "gebiet": 7
  },
  {
    "plz": "94259",
    "gebiet": 7
  },
  {
    "plz": "94315",
    "gebiet": 7
  },
  {
    "plz": "94327",
    "gebiet": 7
  },
  {
    "plz": "94333",
    "gebiet": 7
  },
  {
    "plz": "94336",
    "gebiet": 7
  },
  {
    "plz": "94339",
    "gebiet": 7
  },
  {
    "plz": "94356",
    "gebiet": 7
  },
  {
    "plz": "94357",
    "gebiet": 7
  },
  {
    "plz": "94360",
    "gebiet": 7
  },
  {
    "plz": "94363",
    "gebiet": 7
  },
  {
    "plz": "94368",
    "gebiet": 7
  },
  {
    "plz": "94371",
    "gebiet": 7
  },
  {
    "plz": "94379",
    "gebiet": 7
  },
  {
    "plz": "94405",
    "gebiet": 7
  },
  {
    "plz": "94436",
    "gebiet": 7
  },
  {
    "plz": "94447",
    "gebiet": 7
  },
  {
    "plz": "94451",
    "gebiet": 7
  },
  {
    "plz": "94469",
    "gebiet": 7
  },
  {
    "plz": "94474",
    "gebiet": 7
  },
  {
    "plz": "94481",
    "gebiet": 7
  },
  {
    "plz": "94486",
    "gebiet": 7
  },
  {
    "plz": "94491",
    "gebiet": 7
  },
  {
    "plz": "94501",
    "gebiet": 7
  },
  {
    "plz": "94513",
    "gebiet": 7
  },
  {
    "plz": "94522",
    "gebiet": 7
  },
  {
    "plz": "94535",
    "gebiet": 7
  },
  {
    "plz": "94551",
    "gebiet": 7
  },
  {
    "plz": "94557",
    "gebiet": 7
  },
  {
    "plz": "94559",
    "gebiet": 7
  },
  {
    "plz": "94560",
    "gebiet": 7
  },
  {
    "plz": "94569",
    "gebiet": 7
  },
  {
    "plz": "94574",
    "gebiet": 7
  },
  {
    "plz": "94575",
    "gebiet": 7
  },
  {
    "plz": "94577",
    "gebiet": 7
  },
  {
    "plz": "95028",
    "gebiet": 7
  },
  {
    "plz": "95030",
    "gebiet": 7
  },
  {
    "plz": "95032",
    "gebiet": 7
  },
  {
    "plz": "95035",
    "gebiet": 7
  },
  {
    "plz": "95100",
    "gebiet": 7
  },
  {
    "plz": "95131",
    "gebiet": 7
  },
  {
    "plz": "95145",
    "gebiet": 7
  },
  {
    "plz": "95158",
    "gebiet": 7
  },
  {
    "plz": "95176",
    "gebiet": 7
  },
  {
    "plz": "95182",
    "gebiet": 7
  },
  {
    "plz": "95183",
    "gebiet": 7
  },
  {
    "plz": "95194",
    "gebiet": 7
  },
  {
    "plz": "95213",
    "gebiet": 7
  },
  {
    "plz": "95233",
    "gebiet": 7
  },
  {
    "plz": "95234",
    "gebiet": 7
  },
  {
    "plz": "95236",
    "gebiet": 7
  },
  {
    "plz": "95237",
    "gebiet": 7
  },
  {
    "plz": "95326",
    "gebiet": 7
  },
  {
    "plz": "95339",
    "gebiet": 7
  },
  {
    "plz": "95352",
    "gebiet": 7
  },
  {
    "plz": "95367",
    "gebiet": 7
  },
  {
    "plz": "95369",
    "gebiet": 7
  },
  {
    "plz": "95444",
    "gebiet": 7
  },
  {
    "plz": "95445",
    "gebiet": 7
  },
  {
    "plz": "95447",
    "gebiet": 7
  },
  {
    "plz": "95448",
    "gebiet": 7
  },
  {
    "plz": "95463",
    "gebiet": 7
  },
  {
    "plz": "95466",
    "gebiet": 7
  },
  {
    "plz": "95469",
    "gebiet": 7
  },
  {
    "plz": "95478",
    "gebiet": 7
  },
  {
    "plz": "95488",
    "gebiet": 7
  },
  {
    "plz": "95494",
    "gebiet": 7
  },
  {
    "plz": "95496",
    "gebiet": 7
  },
  {
    "plz": "95499",
    "gebiet": 7
  },
  {
    "plz": "95500",
    "gebiet": 7
  },
  {
    "plz": "95502",
    "gebiet": 7
  },
  {
    "plz": "95511",
    "gebiet": 7
  },
  {
    "plz": "95615",
    "gebiet": 7
  },
  {
    "plz": "95632",
    "gebiet": 7
  },
  {
    "plz": "95643",
    "gebiet": 7
  },
  {
    "plz": "95652",
    "gebiet": 7
  },
  {
    "plz": "95659",
    "gebiet": 7
  },
  {
    "plz": "95666",
    "gebiet": 7
  },
  {
    "plz": "95676",
    "gebiet": 7
  },
  {
    "plz": "95679",
    "gebiet": 7
  },
  {
    "plz": "95685",
    "gebiet": 7
  },
  {
    "plz": "96047",
    "gebiet": 7
  },
  {
    "plz": "96049",
    "gebiet": 7
  },
  {
    "plz": "96050",
    "gebiet": 7
  },
  {
    "plz": "96052",
    "gebiet": 7
  },
  {
    "plz": "96103",
    "gebiet": 7
  },
  {
    "plz": "96106",
    "gebiet": 7
  },
  {
    "plz": "96110",
    "gebiet": 7
  },
  {
    "plz": "96114",
    "gebiet": 7
  },
  {
    "plz": "96117",
    "gebiet": 7
  },
  {
    "plz": "96120",
    "gebiet": 7
  },
  {
    "plz": "96123",
    "gebiet": 7
  },
  {
    "plz": "96126",
    "gebiet": 7
  },
  {
    "plz": "96129",
    "gebiet": 7
  },
  {
    "plz": "96132",
    "gebiet": 7
  },
  {
    "plz": "96135",
    "gebiet": 7
  },
  {
    "plz": "96138",
    "gebiet": 7
  },
  {
    "plz": "96139",
    "gebiet": 7
  },
  {
    "plz": "96142",
    "gebiet": 7
  },
  {
    "plz": "96149",
    "gebiet": 7
  },
  {
    "plz": "96151",
    "gebiet": 7
  },
  {
    "plz": "96155",
    "gebiet": 7
  },
  {
    "plz": "96164",
    "gebiet": 7
  },
  {
    "plz": "96173",
    "gebiet": 7
  },
  {
    "plz": "96179",
    "gebiet": 7
  },
  {
    "plz": "96182",
    "gebiet": 7
  },
  {
    "plz": "96187",
    "gebiet": 7
  },
  {
    "plz": "96191",
    "gebiet": 7
  },
  {
    "plz": "96194",
    "gebiet": 7
  },
  {
    "plz": "96199",
    "gebiet": 7
  },
  {
    "plz": "96215",
    "gebiet": 7
  },
  {
    "plz": "96224",
    "gebiet": 7
  },
  {
    "plz": "96231",
    "gebiet": 7
  },
  {
    "plz": "96242",
    "gebiet": 7
  },
  {
    "plz": "96250",
    "gebiet": 7
  },
  {
    "plz": "96253",
    "gebiet": 7
  },
  {
    "plz": "96260",
    "gebiet": 7
  },
  {
    "plz": "96268",
    "gebiet": 7
  },
  {
    "plz": "96269",
    "gebiet": 7
  },
  {
    "plz": "96274",
    "gebiet": 7
  },
  {
    "plz": "96317",
    "gebiet": 7
  },
  {
    "plz": "96328",
    "gebiet": 7
  },
  {
    "plz": "96332",
    "gebiet": 7
  },
  {
    "plz": "96337",
    "gebiet": 7
  },
  {
    "plz": "96352",
    "gebiet": 7
  },
  {
    "plz": "96364",
    "gebiet": 7
  },
  {
    "plz": "96365",
    "gebiet": 7
  },
  {
    "plz": "96369",
    "gebiet": 7
  },
  {
    "plz": "96450",
    "gebiet": 7
  },
  {
    "plz": "96465",
    "gebiet": 7
  },
  {
    "plz": "96472",
    "gebiet": 7
  },
  {
    "plz": "96476",
    "gebiet": 7
  },
  {
    "plz": "96479",
    "gebiet": 7
  },
  {
    "plz": "96484",
    "gebiet": 7
  },
  {
    "plz": "96486",
    "gebiet": 7
  },
  {
    "plz": "96489",
    "gebiet": 7
  },
  {
    "plz": "96515",
    "gebiet": 7
  },
  {
    "plz": "96523",
    "gebiet": 7
  },
  {
    "plz": "96524",
    "gebiet": 7
  },
  {
    "plz": "96528",
    "gebiet": 7
  },
  {
    "plz": "97070",
    "gebiet": 7
  },
  {
    "plz": "97072",
    "gebiet": 7
  },
  {
    "plz": "97074",
    "gebiet": 7
  },
  {
    "plz": "97076",
    "gebiet": 7
  },
  {
    "plz": "97078",
    "gebiet": 7
  },
  {
    "plz": "97082",
    "gebiet": 7
  },
  {
    "plz": "97084",
    "gebiet": 7
  },
  {
    "plz": "97199",
    "gebiet": 7
  },
  {
    "plz": "97204",
    "gebiet": 7
  },
  {
    "plz": "97209",
    "gebiet": 7
  },
  {
    "plz": "97215",
    "gebiet": 7
  },
  {
    "plz": "97218",
    "gebiet": 7
  },
  {
    "plz": "97222",
    "gebiet": 7
  },
  {
    "plz": "97225",
    "gebiet": 7
  },
  {
    "plz": "97234",
    "gebiet": 7
  },
  {
    "plz": "97236",
    "gebiet": 7
  },
  {
    "plz": "97239",
    "gebiet": 7
  },
  {
    "plz": "97241",
    "gebiet": 7
  },
  {
    "plz": "97249",
    "gebiet": 7
  },
  {
    "plz": "97253",
    "gebiet": 7
  },
  {
    "plz": "97259",
    "gebiet": 7
  },
  {
    "plz": "97261",
    "gebiet": 7
  },
  {
    "plz": "97262",
    "gebiet": 7
  },
  {
    "plz": "97264",
    "gebiet": 7
  },
  {
    "plz": "97265",
    "gebiet": 7
  },
  {
    "plz": "97276",
    "gebiet": 7
  },
  {
    "plz": "97277",
    "gebiet": 7
  },
  {
    "plz": "97280",
    "gebiet": 7
  },
  {
    "plz": "97282",
    "gebiet": 7
  },
  {
    "plz": "97286",
    "gebiet": 7
  },
  {
    "plz": "97288",
    "gebiet": 7
  },
  {
    "plz": "97291",
    "gebiet": 7
  },
  {
    "plz": "97294",
    "gebiet": 7
  },
  {
    "plz": "97297",
    "gebiet": 7
  },
  {
    "plz": "97299",
    "gebiet": 7
  },
  {
    "plz": "97318",
    "gebiet": 7
  },
  {
    "plz": "97332",
    "gebiet": 7
  },
  {
    "plz": "97340",
    "gebiet": 7
  },
  {
    "plz": "97342",
    "gebiet": 7
  },
  {
    "plz": "97346",
    "gebiet": 7
  },
  {
    "plz": "97353",
    "gebiet": 7
  },
  {
    "plz": "97355",
    "gebiet": 7
  },
  {
    "plz": "97357",
    "gebiet": 7
  },
  {
    "plz": "97421",
    "gebiet": 7
  },
  {
    "plz": "97422",
    "gebiet": 7
  },
  {
    "plz": "97424",
    "gebiet": 7
  },
  {
    "plz": "97437",
    "gebiet": 7
  },
  {
    "plz": "97440",
    "gebiet": 7
  },
  {
    "plz": "97447",
    "gebiet": 7
  },
  {
    "plz": "97450",
    "gebiet": 7
  },
  {
    "plz": "97453",
    "gebiet": 7
  },
  {
    "plz": "97456",
    "gebiet": 7
  },
  {
    "plz": "97464",
    "gebiet": 7
  },
  {
    "plz": "97469",
    "gebiet": 7
  },
  {
    "plz": "97475",
    "gebiet": 7
  },
  {
    "plz": "97478",
    "gebiet": 7
  },
  {
    "plz": "97486",
    "gebiet": 7
  },
  {
    "plz": "97490",
    "gebiet": 7
  },
  {
    "plz": "97491",
    "gebiet": 7
  },
  {
    "plz": "97493",
    "gebiet": 7
  },
  {
    "plz": "97500",
    "gebiet": 7
  },
  {
    "plz": "97502",
    "gebiet": 7
  },
  {
    "plz": "97505",
    "gebiet": 7
  },
  {
    "plz": "97509",
    "gebiet": 7
  },
  {
    "plz": "97514",
    "gebiet": 7
  },
  {
    "plz": "97523",
    "gebiet": 7
  },
  {
    "plz": "97535",
    "gebiet": 7
  },
  {
    "plz": "97616",
    "gebiet": 7
  },
  {
    "plz": "97618",
    "gebiet": 7
  },
  {
    "plz": "97631",
    "gebiet": 7
  },
  {
    "plz": "97638",
    "gebiet": 7
  },
  {
    "plz": "97640",
    "gebiet": 7
  },
  {
    "plz": "97647",
    "gebiet": 7
  },
  {
    "plz": "97653",
    "gebiet": 7
  },
  {
    "plz": "97657",
    "gebiet": 7
  },
  {
    "plz": "97688",
    "gebiet": 7
  },
  {
    "plz": "97702",
    "gebiet": 7
  },
  {
    "plz": "97705",
    "gebiet": 7
  },
  {
    "plz": "97714",
    "gebiet": 7
  },
  {
    "plz": "97720",
    "gebiet": 7
  },
  {
    "plz": "97737",
    "gebiet": 7
  },
  {
    "plz": "97753",
    "gebiet": 7
  },
  {
    "plz": "97762",
    "gebiet": 7
  },
  {
    "plz": "97769",
    "gebiet": 7
  },
  {
    "plz": "97772",
    "gebiet": 7
  },
  {
    "plz": "97778",
    "gebiet": 7
  },
  {
    "plz": "97789",
    "gebiet": 7
  },
  {
    "plz": "97816",
    "gebiet": 7
  },
  {
    "plz": "97828",
    "gebiet": 7
  },
  {
    "plz": "97833",
    "gebiet": 7
  },
  {
    "plz": "97837",
    "gebiet": 7
  },
  {
    "plz": "97840",
    "gebiet": 7
  },
  {
    "plz": "97843",
    "gebiet": 7
  },
  {
    "plz": "97852",
    "gebiet": 7
  },
  {
    "plz": "97854",
    "gebiet": 7
  },
  {
    "plz": "97855",
    "gebiet": 7
  },
  {
    "plz": "97877",
    "gebiet": 7
  },
  {
    "plz": "97892",
    "gebiet": 7
  },
  {
    "plz": "97896",
    "gebiet": 7
  },
  {
    "plz": "97903",
    "gebiet": 7
  },
  {
    "plz": "97909",
    "gebiet": 7
  },
  {
    "plz": "97911",
    "gebiet": 7
  },
  {
    "plz": "97922",
    "gebiet": 7
  },
  {
    "plz": "97941",
    "gebiet": 7
  },
  {
    "plz": "97947",
    "gebiet": 7
  },
  {
    "plz": "97956",
    "gebiet": 7
  },
  {
    "plz": "97957",
    "gebiet": 7
  },
  {
    "plz": "97980",
    "gebiet": 7
  },
  {
    "plz": "97990",
    "gebiet": 7
  },
  {
    "plz": "97999",
    "gebiet": 7
  },
  {
    "plz": "98527",
    "gebiet": 5
  },
  {
    "plz": "98528",
    "gebiet": 5
  },
  {
    "plz": "98529",
    "gebiet": 5
  },
  {
    "plz": "98530",
    "gebiet": 5
  },
  {
    "plz": "98544",
    "gebiet": 5
  },
  {
    "plz": "98553",
    "gebiet": 5
  },
  {
    "plz": "98559",
    "gebiet": 5
  },
  {
    "plz": "98574",
    "gebiet": 5
  },
  {
    "plz": "98587",
    "gebiet": 5
  },
  {
    "plz": "98590",
    "gebiet": 5
  },
  {
    "plz": "98593",
    "gebiet": 5
  },
  {
    "plz": "98596",
    "gebiet": 5
  },
  {
    "plz": "98597",
    "gebiet": 5
  },
  {
    "plz": "98617",
    "gebiet": 5
  },
  {
    "plz": "98630",
    "gebiet": 5
  },
  {
    "plz": "98634",
    "gebiet": 5
  },
  {
    "plz": "98639",
    "gebiet": 5
  },
  {
    "plz": "98646",
    "gebiet": 7
  },
  {
    "plz": "98660",
    "gebiet": 7
  },
  {
    "plz": "98673",
    "gebiet": 7
  },
  {
    "plz": "98693",
    "gebiet": 5
  },
  {
    "plz": "98716",
    "gebiet": 5
  },
  {
    "plz": "98724",
    "gebiet": 5
  },
  {
    "plz": "98743",
    "gebiet": 5
  },
  {
    "plz": "99084",
    "gebiet": 5
  },
  {
    "plz": "99085",
    "gebiet": 5
  },
  {
    "plz": "99086",
    "gebiet": 5
  },
  {
    "plz": "99087",
    "gebiet": 5
  },
  {
    "plz": "99089",
    "gebiet": 5
  },
  {
    "plz": "99091",
    "gebiet": 5
  },
  {
    "plz": "99092",
    "gebiet": 5
  },
  {
    "plz": "99094",
    "gebiet": 5
  },
  {
    "plz": "99095",
    "gebiet": 5
  },
  {
    "plz": "99096",
    "gebiet": 5
  },
  {
    "plz": "99097",
    "gebiet": 5
  },
  {
    "plz": "99098",
    "gebiet": 5
  },
  {
    "plz": "99099",
    "gebiet": 5
  },
  {
    "plz": "99192",
    "gebiet": 5
  },
  {
    "plz": "99195",
    "gebiet": 5
  },
  {
    "plz": "99310",
    "gebiet": 5
  },
  {
    "plz": "99326",
    "gebiet": 5
  },
  {
    "plz": "99330",
    "gebiet": 5
  },
  {
    "plz": "99334",
    "gebiet": 5
  },
  {
    "plz": "99401",
    "gebiet": 5
  },
  {
    "plz": "99423",
    "gebiet": 5
  },
  {
    "plz": "99425",
    "gebiet": 5
  },
  {
    "plz": "99427",
    "gebiet": 5
  },
  {
    "plz": "99428",
    "gebiet": 5
  },
  {
    "plz": "99438",
    "gebiet": 5
  },
  {
    "plz": "99439",
    "gebiet": 5
  },
  {
    "plz": "99444",
    "gebiet": 5
  },
  {
    "plz": "99448",
    "gebiet": 5
  },
  {
    "plz": "99510",
    "gebiet": 5
  },
  {
    "plz": "99518",
    "gebiet": 5
  },
  {
    "plz": "99610",
    "gebiet": 5
  },
  {
    "plz": "99625",
    "gebiet": 5
  },
  {
    "plz": "99636",
    "gebiet": 5
  },
  {
    "plz": "99638",
    "gebiet": 5
  },
  {
    "plz": "99706",
    "gebiet": 5
  },
  {
    "plz": "99707",
    "gebiet": 5
  },
  {
    "plz": "99713",
    "gebiet": 5
  },
  {
    "plz": "99718",
    "gebiet": 5
  },
  {
    "plz": "99734",
    "gebiet": 5
  },
  {
    "plz": "99752",
    "gebiet": 5
  },
  {
    "plz": "99765",
    "gebiet": 5
  },
  {
    "plz": "99768",
    "gebiet": 5
  },
  {
    "plz": "99817",
    "gebiet": 5
  },
  {
    "plz": "99820",
    "gebiet": 5
  },
  {
    "plz": "99826",
    "gebiet": 5
  },
  {
    "plz": "99830",
    "gebiet": 5
  },
  {
    "plz": "99831",
    "gebiet": 5
  },
  {
    "plz": "99834",
    "gebiet": 5
  },
  {
    "plz": "99837",
    "gebiet": 5
  },
  {
    "plz": "99842",
    "gebiet": 5
  },
  {
    "plz": "99848",
    "gebiet": 5
  },
  {
    "plz": "99867",
    "gebiet": 5
  },
  {
    "plz": "99869",
    "gebiet": 5
  },
  {
    "plz": "99880",
    "gebiet": 5
  },
  {
    "plz": "99885",
    "gebiet": 5
  },
  {
    "plz": "99887",
    "gebiet": 5
  },
  {
    "plz": "99894",
    "gebiet": 5
  },
  {
    "plz": "99947",
    "gebiet": 5
  },
  {
    "plz": "99955",
    "gebiet": 5
  },
  {
    "plz": "99974",
    "gebiet": 5
  },
  {
    "plz": "99986",
    "gebiet": 5
  },
  {
    "plz": "99996",
    "gebiet": 5
  }
];

// Build a fast lookup map
const plzMap = new Map(plzData.map(e => [e.plz, e.gebiet]));

function normalizePlz(input) {
  if (input == null) return null;
  const s = String(input).trim().replace(/D/g, '');
  if (!s) return null;
  return s.padStart(5, '0');
}

function getGebietForPlz(plzInput) {
  const plz = normalizePlz(plzInput);
  if (!plz) return 0;
  return plzMap.get(plz) ?? 0;
}



export default getGebietForPlz;
